import { useState, useEffect, useRef, useMemo } from "react";
import HS_LOGO from "./hs_logo.png";
import { db } from "./firebase";
import {
  doc, getDoc, setDoc, collection,
  onSnapshot, getDocs
} from "firebase/firestore";
const LOGO_B64 = "data:image/png;base64,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";
const SIGNATURE_B64 = "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";


// ─── HELPERS ──────────────────────────────────────────────────────────────────
const uid = () => Math.random().toString(36).slice(2, 10);
const today = () => new Date().toISOString().slice(0, 10);
const monthLabel = (y, m) => new Date(y, m - 1).toLocaleString("default", { month: "long", year: "numeric" });
const daysInMonth = (y, m) => new Date(y, m, 0).getDate();
const dayName = (y, m, d) => new Date(y, m - 1, d).toLocaleString("default", { weekday: "short" });
const isWeekend = (y, m, d) => { const dn = new Date(y, m - 1, d).getDay(); return dn === 0 || dn === 6; };
const isOffDay = (y, m, d, workDays) => { const dn = new Date(y, m - 1, d).getDay(); return !(workDays || [1,2,3,4,5,6]).includes(dn); };
const initials = (name) => name.split(" ").map(p => p[0]).join("").toUpperCase().slice(0, 2);
const fmtCurrency = (n) => new Intl.NumberFormat("en-PK", { style: "currency", currency: "PKR", maximumFractionDigits: 0 }).format(n);

// ─── INITIAL DATA ─────────────────────────────────────────────────────────────
const ROLES = ["Super Admin", "HR Manager", "Supervisor", "Employee"];
const DEPTS = ["Engineering", "Finance", "HR", "Operations", "Sales", "Management"];

const INIT_USERS = [
  { id: "u1", name: "Abhijeet", email: "abhijeet@civyxinfra.com", password: "#Abhijeet@2007", role: "Super Admin", dept: "Management", designation: "Director", salary: 150000, active: true, joinDate: "2020-01-01", deductLeaveOverride: "global", phone: "" },
];

const PERMS = {
  "Super Admin":  ["dashboard", "users", "attendance", "attendance_mark", "leave", "salary", "reports", "settings", "workorder", "quotation", "helpdesk", "appointment"],
  "HR Manager":   ["dashboard", "users", "attendance", "attendance_mark", "leave", "salary", "reports", "workorder", "quotation", "helpdesk", "appointment"],
  "Supervisor":   ["dashboard", "attendance", "attendance_mark", "leave", "reports", "workorder", "quotation", "helpdesk", "appointment"],
  "Employee":     ["dashboard", "attendance", "leave", "salary", "helpdesk"],
};

// Human-readable labels for permission keys shown in Access Control
const PERM_LABELS = {
  dashboard:       { label: "Dashboard",        color: "badge-blue" },
  users:           { label: "User Management",  color: "badge-purple" },
  attendance:      { label: "View Attendance",  color: "badge-green" },
  attendance_mark: { label: "Mark Attendance",  color: "badge-gold" },
  leave:           { label: "Leave Management", color: "badge-orange" },
  salary:          { label: "Salary",           color: "badge-red" },
  reports:         { label: "Reports",          color: "badge-blue" },
  settings:        { label: "Settings",         color: "badge-gray" },
  workorder:       { label: "Work Orders",      color: "badge-gold" },
  quotation:       { label: "Quotations",       color: "badge-purple" },
  helpdesk:        { label: "Helpdesk",         color: "badge-green" },
  appointment:     { label: "Appointment Letters", color: "badge-orange" },
};

// ─── COMPANY INFO (used in WO/Quotation) ──────────────────────────────────────
const COMPANY_INFO = {
  name: "Civyx Infra",
  tagline: "Building Infrastructure, Building Trust",
  address: "Saurikh, Tirwa Road, Saurikh, Kannauj, Uttar Pradesh - 209728",
  phone: "+91-60059 72206",
  email: "info@civyxinfra.com",
  website: "www.civyxinfra.com",
  gstin: "09ASVPK6249E1Z6",
  bank: "State Bank of India",
  accountNo: "XXXXXXXXXXXX",
  ifsc: "SBIN0XXXXXX",
};

const AVATAR_COLORS = ["#1a3a6b","#1a7a4a","#b86a00","#5a3a8a","#c0392b","#2471a3","#117a65","#6e2f8a"];
const avatarColor = (id) => AVATAR_COLORS[id.charCodeAt(1) % AVATAR_COLORS.length];

// ─── STYLES ───────────────────────────────────────────────────────────────────
const S = {
  "@import": "https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500&display=swap",
};

const css = `
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
:root{
  --navy:#0d1b2e;--navy2:#162135;--navy3:#1c2d45;--navy4:#233452;
  --blue:#1854d4;--blue2:#2563eb;--blue3:#3b82f6;--blue-lt:#eff6ff;--blue-lt2:#dbeafe;
  --gold:#c9922a;--gold2:#d4a544;--gold-lt:#fffbeb;--gold-lt2:#fef3c7;
  --green:#059669;--green2:#10b981;--green-lt:#ecfdf5;--green-lt2:#d1fae5;
  --red:#dc2626;--red2:#ef4444;--red-lt:#fef2f2;--red-lt2:#fee2e2;
  --orange:#d97706;--orange-lt:#fffbeb;--orange-lt2:#fde68a;
  --purple:#7c3aed;--purple-lt:#f5f3ff;--purple-lt2:#ede9fe;
  --slate:#64748b;--slate2:#94a3b8;--slate3:#cbd5e1;
  --bg:#f1f5f9;--bg2:#e2e8f0;--bg3:#f8fafc;
  --white:#ffffff;--border:#e2e8f0;--border2:#cbd5e1;
  --text:#0f172a;--text2:#334155;--text3:#64748b;--text4:#94a3b8;
  --sidebar:240px;--topbar:60px;
  --shadow-sm:0 1px 3px rgba(0,0,0,.08),0 1px 2px rgba(0,0,0,.06);
  --shadow:0 4px 16px rgba(0,0,0,.08),0 2px 4px rgba(0,0,0,.05);
  --shadow-lg:0 20px 50px rgba(0,0,0,.15),0 8px 20px rgba(0,0,0,.1);
  --radius:8px;--radius-lg:12px;--radius-xl:16px;
  --mobile-nav:65px;
}
html,body{margin:0;padding:0;width:100%;height:100%;overflow:hidden}#root{width:100%;height:100%;display:block}html,body,#root{font-family:'Plus Jakarta Sans',sans-serif;background:var(--bg);color:var(--text);font-size:14px;line-height:1.5}
::-webkit-scrollbar{width:4px;height:4px}
::-webkit-scrollbar-track{background:transparent}
::-webkit-scrollbar-thumb{background:var(--border2);border-radius:2px}

/* LAYOUT */
.erp-app{display:flex;height:100vh;width:100vw;overflow:hidden;position:fixed;top:0;left:0}
.sidebar{width:var(--sidebar);background:var(--navy);display:flex;flex-direction:column;flex-shrink:0;overflow-y:auto;position:relative;z-index:50;transition:width .2s}
.main{flex:1;display:flex;flex-direction:column;overflow:hidden;min-width:0}
.topbar{height:var(--topbar);background:var(--white);border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;padding:0 1.5rem;flex-shrink:0;box-shadow:var(--shadow-sm)}
.content{flex:1;overflow-y:auto;padding:1.5rem;background:var(--bg)}

/* SIDEBAR */
.sb-brand{padding:1.1rem 1.2rem 1rem;border-bottom:1px solid rgba(255,255,255,.08);display:flex;align-items:center;gap:.7rem}
.sb-logo{width:36px;height:36px;background:var(--blue);border-radius:8px;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:.95rem;color:#fff;letter-spacing:-.02em;flex-shrink:0}
.sb-brand-text{font-size:.92rem;font-weight:700;color:#fff;line-height:1.2}
.sb-brand-text span{color:rgba(255,255,255,.4);font-weight:400;font-size:.68rem;display:block}
.sb-section{padding:.9rem 1rem .25rem;font-size:.62rem;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:rgba(255,255,255,.3)}
.nav-item{display:flex;align-items:center;gap:.65rem;padding:.6rem .9rem;margin:.05rem .5rem;border-radius:6px;cursor:pointer;color:rgba(255,255,255,.6);font-size:.83rem;font-weight:500;transition:all .15s;user-select:none;text-decoration:none}
.nav-item:hover{background:rgba(255,255,255,.07);color:rgba(255,255,255,.9)}
.nav-item.active{background:var(--blue);color:#fff;box-shadow:0 2px 8px rgba(37,99,235,.4)}
.nav-item svg{width:16px;height:16px;flex-shrink:0;opacity:.8}
.nav-item.active svg{opacity:1}
.sb-footer{margin-top:auto;padding:1rem;border-top:1px solid rgba(255,255,255,.08)}
.sb-user{display:flex;align-items:center;gap:.6rem;padding:.5rem;border-radius:6px;cursor:pointer;transition:background .15s}
.sb-user:hover{background:rgba(255,255,255,.07)}
.sb-info{flex:1;min-width:0}
.sb-name{font-size:.8rem;font-weight:600;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.sb-role{font-size:.67rem;color:rgba(255,255,255,.4)}
.sb-logout{background:none;border:none;color:rgba(255,255,255,.4);cursor:pointer;font-size:.78rem;display:flex;align-items:center;gap:.3rem;padding:.4rem .7rem;border-radius:4px;transition:all .15s;margin-top:.3rem;width:100%}
.sb-logout:hover{background:rgba(220,38,38,.15);color:#ef4444}

/* TOPBAR */
.tb-title{font-size:.95rem;font-weight:700;color:var(--text)}
.tb-sub{font-size:.73rem;color:var(--text3);margin-top:.05rem}
.tb-right{display:flex;align-items:center;gap:.8rem}
.tb-date{font-size:.75rem;color:var(--text3);font-family:'JetBrains Mono',monospace;background:var(--bg);padding:.3rem .7rem;border-radius:6px;border:1px solid var(--border)}
.tb-badge{background:var(--blue-lt);color:var(--blue);font-size:.72rem;font-weight:700;padding:.25rem .7rem;border-radius:20px;border:1px solid var(--blue-lt2)}
.tb-notif{width:32px;height:32px;border-radius:6px;border:1px solid var(--border);background:var(--white);display:flex;align-items:center;justify-content:center;cursor:pointer;position:relative;font-size:.9rem}
.tb-notif:hover{background:var(--bg)}

/* AVATAR */
.avatar{display:inline-flex;align-items:center;justify-content:center;border-radius:50%;font-weight:700;color:#fff;flex-shrink:0;font-family:'Plus Jakarta Sans',sans-serif}
.av-sm{width:28px;height:28px;font-size:.7rem}
.av-md{width:36px;height:36px;font-size:.83rem}
.av-lg{width:44px;height:44px;font-size:1rem}
.av-xl{width:56px;height:56px;font-size:1.2rem}

/* CARDS */
.card{background:var(--white);border:1px solid var(--border);border-radius:var(--radius-lg);padding:1.3rem;box-shadow:var(--shadow-sm)}
.card-hdr{display:flex;align-items:center;justify-content:space-between;margin-bottom:1.1rem}
.card-title{font-size:.88rem;font-weight:700;color:var(--text)}
.card-sub{font-size:.73rem;color:var(--text3);margin-top:.1rem}

/* STAT CARDS */
.stat-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:1rem;margin-bottom:1.4rem}
.stat-card{background:var(--white);border:1px solid var(--border);border-radius:var(--radius-lg);padding:1.2rem 1.3rem;display:flex;align-items:flex-start;gap:.9rem;box-shadow:var(--shadow-sm);transition:box-shadow .2s,transform .2s}
.stat-card:hover{box-shadow:var(--shadow);transform:translateY(-1px)}
.stat-icon{width:40px;height:40px;border-radius:9px;display:flex;align-items:center;justify-content:center;font-size:1.1rem;flex-shrink:0}
.stat-num{font-size:1.6rem;font-weight:800;color:var(--text);line-height:1;font-family:'JetBrains Mono',monospace;letter-spacing:-.02em}
.stat-lbl{font-size:.73rem;color:var(--text3);margin-top:.18rem;font-weight:500}
.stat-chg{font-size:.72rem;font-weight:600;margin-top:.3rem}

/* TABLES */
.tbl-wrap{overflow-x:auto;border-radius:var(--radius-lg);border:1px solid var(--border);box-shadow:var(--shadow-sm)}
table{width:100%;border-collapse:collapse;background:var(--white)}
thead{position:sticky;top:0;z-index:1}
th{background:var(--bg3);font-size:.7rem;font-weight:700;letter-spacing:.05em;text-transform:uppercase;color:var(--text3);padding:.7rem 1rem;text-align:left;border-bottom:1px solid var(--border);white-space:nowrap}
td{padding:.75rem 1rem;border-bottom:1px solid var(--bg);font-size:.83rem;color:var(--text);vertical-align:middle}
tr:last-child td{border-bottom:none}
tbody tr:hover td{background:var(--bg3)}
.tbl-actions{display:flex;gap:.4rem;align-items:center}

/* BADGES */
.badge{display:inline-flex;align-items:center;gap:.25rem;font-size:.68rem;font-weight:700;padding:.2rem .6rem;border-radius:20px;letter-spacing:.01em;white-space:nowrap}
.badge-green{background:var(--green-lt);color:var(--green)}
.badge-red{background:var(--red-lt);color:var(--red)}
.badge-orange{background:var(--orange-lt);color:var(--orange)}
.badge-blue{background:var(--blue-lt);color:var(--blue)}
.badge-purple{background:var(--purple-lt);color:var(--purple)}
.badge-gray{background:var(--bg2);color:var(--text3)}
.badge-gold{background:var(--gold-lt);color:var(--gold)}

/* BUTTONS */
.btn{display:inline-flex;align-items:center;gap:.4rem;font-family:'Plus Jakarta Sans',sans-serif;font-size:.8rem;font-weight:600;padding:.5rem 1rem;border-radius:6px;border:none;cursor:pointer;transition:all .15s;white-space:nowrap;letter-spacing:.01em}
.btn:disabled{opacity:.5;cursor:not-allowed}
.btn-primary{background:var(--blue);color:#fff}
.btn-primary:hover:not(:disabled){background:var(--blue2)}
.btn-success{background:var(--green);color:#fff}
.btn-success:hover:not(:disabled){background:#047857}
.btn-danger{background:var(--red);color:#fff}
.btn-danger:hover:not(:disabled){background:#b91c1c}
.btn-warning{background:var(--orange);color:#fff}
.btn-warning:hover:not(:disabled){background:#b45309}
.btn-outline{background:transparent;color:var(--blue);border:1px solid var(--blue)}
.btn-outline:hover:not(:disabled){background:var(--blue-lt)}
.btn-ghost{background:transparent;color:var(--text2);border:1px solid var(--border)}
.btn-ghost:hover:not(:disabled){background:var(--bg);color:var(--text)}
.btn-gold{background:var(--gold);color:#fff}
.btn-gold:hover:not(:disabled){background:var(--gold2)}
.btn-sm{font-size:.75rem;padding:.35rem .75rem}
.btn-xs{font-size:.7rem;padding:.25rem .55rem}
.btn-icon{padding:.5rem;border-radius:6px}

/* FORMS */
.form-grid{display:grid;grid-template-columns:1fr 1fr;gap:1rem}
.form-grid-3{display:grid;grid-template-columns:1fr 1fr 1fr;gap:1rem}
.form-group{display:flex;flex-direction:column;gap:.3rem}
.form-group.full{grid-column:1/-1}
label{font-size:.75rem;font-weight:600;color:var(--text2)}
input,select,textarea{font-family:'Plus Jakarta Sans',sans-serif;font-size:.85rem;padding:.55rem .8rem;border:1px solid var(--border2);border-radius:6px;background:var(--white);color:var(--text);outline:none;transition:border-color .15s,box-shadow .15s;width:100%}
input:focus,select:focus,textarea:focus{border-color:var(--blue);box-shadow:0 0 0 3px rgba(37,99,235,.08)}
textarea{resize:vertical;min-height:80px}
.form-actions{display:flex;gap:.6rem;justify-content:flex-end;margin-top:1.1rem;padding-top:1rem;border-top:1px solid var(--bg2)}
.form-hint{font-size:.7rem;color:var(--text3)}

/* MODAL */
.overlay{position:fixed;inset:0;background:rgba(15,23,42,.5);z-index:1000;display:flex;align-items:center;justify-content:center;padding:1rem;backdrop-filter:blur(2px)}
.modal{background:var(--white);border-radius:var(--radius-xl);width:100%;max-width:560px;max-height:92vh;overflow-y:auto;box-shadow:var(--shadow-lg);animation:modalIn .2s ease}
.modal-lg{max-width:740px}
.modal-xl{max-width:900px}
@keyframes modalIn{from{opacity:0;transform:translateY(-12px) scale(.97)}to{opacity:1;transform:translateY(0) scale(1)}}
.modal-hdr{padding:1.2rem 1.4rem;border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;position:sticky;top:0;background:var(--white);z-index:2;border-radius:var(--radius-xl) var(--radius-xl) 0 0}
.modal-title{font-size:.92rem;font-weight:700;color:var(--text)}
.modal-sub{font-size:.73rem;color:var(--text3);margin-top:.1rem}
.modal-close{background:none;border:none;font-size:1.1rem;cursor:pointer;color:var(--text3);width:28px;height:28px;display:flex;align-items:center;justify-content:center;border-radius:5px;transition:all .15s}
.modal-close:hover{background:var(--bg);color:var(--text)}
.modal-body{padding:1.4rem}

/* PAGE */
.page-hdr{display:flex;align-items:center;justify-content:space-between;margin-bottom:1.4rem;flex-wrap:wrap;gap:.8rem}
.page-title{font-size:1.1rem;font-weight:800;color:var(--text)}
.page-sub{font-size:.77rem;color:var(--text3);margin-top:.1rem}

/* SEARCH BAR */
.search-bar{display:flex;align-items:center;gap:.8rem;margin-bottom:1.1rem;flex-wrap:wrap}
.search-wrap{position:relative;flex:1;min-width:200px;max-width:300px}
.search-wrap input{padding-left:2rem}
.search-ic{position:absolute;left:.65rem;top:50%;transform:translateY(-50%);color:var(--text4);font-size:.85rem;pointer-events:none}

/* TABS */
.tabs{display:flex;gap:0;border-bottom:1px solid var(--border);margin-bottom:1.3rem}
.tab{padding:.6rem 1.1rem;font-size:.82rem;font-weight:500;color:var(--text3);cursor:pointer;border-bottom:2px solid transparent;margin-bottom:-1px;transition:all .15s;user-select:none}
.tab:hover{color:var(--text)}
.tab.active{color:var(--blue);border-bottom-color:var(--blue);font-weight:700}

/* ATTENDANCE MARK */
.att-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(210px,1fr));gap:.9rem}
.att-emp-card{background:var(--white);border:2px solid var(--border);border-radius:var(--radius-lg);padding:1rem;display:flex;flex-direction:column;gap:.7rem;transition:border-color .2s,box-shadow .2s}
.att-emp-card.marked-P{border-color:var(--green);background:var(--green-lt);box-shadow:0 0 0 3px rgba(5,150,105,.08)}
.att-emp-card.marked-A{border-color:var(--red);background:var(--red-lt);box-shadow:0 0 0 3px rgba(220,38,38,.08)}
.att-emp-card.marked-L{border-color:var(--orange);background:var(--orange-lt);box-shadow:0 0 0 3px rgba(217,119,6,.08)}
.att-emp-card.marked-H{border-color:var(--purple);background:var(--purple-lt);box-shadow:0 0 0 3px rgba(124,58,237,.08)}
.att-emp-card.marked-WO{border-color:var(--border2);background:var(--bg2)}
.att-btns{display:grid;grid-template-columns:1fr 1fr;gap:.35rem}
.att-btn{padding:.35rem .2rem;border:1.5px solid var(--border);border-radius:5px;background:#fff;font-size:.72rem;font-weight:700;cursor:pointer;text-align:center;transition:all .15s;letter-spacing:.03em}
.att-btn.P{border-color:var(--green);color:var(--green)}
.att-btn.P.act,.att-btn.P:hover{background:var(--green);color:#fff}
.att-btn.A{border-color:var(--red);color:var(--red)}
.att-btn.A.act,.att-btn.A:hover{background:var(--red);color:#fff}
.att-btn.L{border-color:var(--orange);color:var(--orange)}
.att-btn.L.act,.att-btn.L:hover{background:var(--orange);color:#fff}
.att-btn.H{border-color:var(--purple);color:var(--purple)}
.att-btn.H.act,.att-btn.H:hover{background:var(--purple);color:#fff}

/* REPORT TABLE */
.rpt-wrap{overflow-x:auto;border-radius:var(--radius-lg);border:1px solid var(--border);box-shadow:var(--shadow-sm)}
.rpt-tbl{border-collapse:collapse;background:var(--white);font-size:.72rem;min-width:100%}
.rpt-tbl th{background:var(--navy);color:#fff;padding:.5rem .5rem;font-size:.65rem;letter-spacing:.05em;text-transform:uppercase;border:1px solid rgba(255,255,255,.1);text-align:center;white-space:nowrap}
.rpt-tbl th:first-child{text-align:left;min-width:140px;position:sticky;left:0;z-index:2}
.rpt-tbl td{padding:.42rem .45rem;border:1px solid var(--border);text-align:center;white-space:nowrap;vertical-align:middle}
.rpt-tbl td:first-child{text-align:left;position:sticky;left:0;background:var(--white);z-index:1;font-weight:600}
.rpt-tbl tr:hover td:first-child{background:var(--bg3)}
.rc-P{background:#dcfce7;color:#15803d;font-weight:700}
.rc-A{background:#fee2e2;color:#b91c1c;font-weight:700}
.rc-L{background:#fef3c7;color:#b45309;font-weight:700}
.rc-H{background:#ede9fe;color:#6d28d9;font-weight:700}
.rc-WO{background:#f1f5f9;color:#94a3b8;font-size:.65rem}
.rc-empty{color:#e2e8f0}

/* CELL RICH TEXT EDITOR (WO/Quotation table) */
.cell-rich-editor{width:100%;min-height:58px;font-size:.82rem;border:1px solid var(--border2);border-radius:0 0 4px 4px;border-top:none;padding:.4rem .55rem;font-family:inherit;line-height:1.55;outline:none;background:var(--white);color:var(--text);word-break:break-word;white-space:pre-wrap;overflow-y:auto;max-height:220px;transition:border-color .15s,box-shadow .15s;resize:vertical}
.cell-rich-editor:focus{border-color:var(--blue);box-shadow:0 0 0 3px rgba(37,99,235,.08)}
.cell-rich-toolbar{display:flex;align-items:center;gap:.25rem;flex-wrap:wrap;background:var(--bg3);border:1px solid var(--border2);border-radius:4px 4px 0 0;padding:.28rem .5rem}
.cell-rich-toolbar button{width:24px;height:24px;border-radius:3px;border:1px solid var(--border2);background:var(--white);cursor:pointer;font-size:.85rem;color:var(--text);display:flex;align-items:center;justify-content:center;transition:background .12s}
.cell-rich-toolbar button:hover{background:var(--bg2)}
.cell-rich-toolbar .color-dot{width:14px;height:14px;border-radius:50%;cursor:pointer;border:1.5px solid var(--border2);transition:transform .1s}
.cell-rich-toolbar .color-dot:hover{transform:scale(1.2)}
.cell-rich-editor:empty:before{content:attr(data-placeholder);color:var(--text4);pointer-events:none;display:block}

/* SALARY CARD */
.salary-card{background:var(--white);border:1px solid var(--border);border-radius:var(--radius-lg);overflow:hidden;box-shadow:var(--shadow-sm)}
.sal-hdr{background:linear-gradient(135deg,var(--navy) 0%,var(--navy3) 100%);padding:1.2rem 1.4rem;display:flex;align-items:center;justify-content:space-between}
.sal-emp-name{font-size:.95rem;font-weight:700;color:#fff}
.sal-month{font-size:.73rem;color:rgba(255,255,255,.55);margin-top:.1rem}
.sal-gross{font-size:1.5rem;font-weight:800;color:var(--gold2);font-family:'JetBrains Mono',monospace}
.sal-body{padding:1rem 1.4rem}
.sal-row{display:flex;justify-content:space-between;align-items:center;padding:.5rem 0;border-bottom:1px solid var(--bg);font-size:.82rem}
.sal-row:last-child{border-bottom:none;font-weight:700;font-size:.9rem;padding-top:.8rem;margin-top:.3rem;border-top:2px solid var(--border)}
.sal-deduct{color:var(--red);font-weight:600}

/* LEAVE */
.leave-card{background:var(--white);border:1px solid var(--border);border-radius:var(--radius);padding:1rem 1.2rem;display:flex;align-items:center;justify-content:space-between;gap:1rem;transition:box-shadow .15s}
.leave-card:hover{box-shadow:var(--shadow)}

/* TOAST */
#erp-toast{position:fixed;bottom:1.5rem;right:1.5rem;background:var(--navy);color:#fff;padding:.8rem 1.2rem;border-radius:8px;font-size:.83rem;z-index:9999;opacity:0;transform:translateY(10px);transition:all .3s;pointer-events:none;max-width:300px;box-shadow:var(--shadow-lg);font-family:'Plus Jakarta Sans',sans-serif;font-weight:500}
#erp-toast.show{opacity:1;transform:translateY(0)}
#erp-toast.ok{background:var(--green)}
#erp-toast.err{background:var(--red)}

/* ═══════════════════════════════════════════════════════
   PREMIUM LOGIN PAGE
   ═══════════════════════════════════════════════════════ */

/* Animated background orbs */
@keyframes float1{0%,100%{transform:translateY(0) scale(1)}50%{transform:translateY(-40px) scale(1.08)}}
@keyframes float2{0%,100%{transform:translateY(0) scale(1)}50%{transform:translateY(30px) scale(0.94)}}
@keyframes float3{0%,100%{transform:translateX(0) scale(1)}50%{transform:translateX(-30px) scale(1.05)}}
@keyframes fadeSlideUp{from{opacity:0;transform:translateY(28px)}to{opacity:1;transform:translateY(0)}}
@keyframes scaleIn{from{opacity:0;transform:scale(.92)}to{opacity:1;transform:scale(1)}}
@keyframes shimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}
@keyframes pulse-ring{0%{transform:scale(.9);opacity:.7}70%{transform:scale(1.15);opacity:0}100%{transform:scale(.9);opacity:0}}
@keyframes gradientShift{0%{background-position:0% 50%}50%{background-position:100% 50%}100%{background-position:0% 50%}}

.login-wrap{
  min-height:100vh;
  background:linear-gradient(135deg,#060d1a 0%,#0d1b2e 40%,#091528 70%,#030810 100%);
  display:flex;align-items:stretch;justify-content:center;
  position:relative;overflow:hidden;
  font-family:'Plus Jakarta Sans',sans-serif;
}

/* Animated background orbs */
.login-bg-orb{
  position:absolute;border-radius:50%;pointer-events:none;
  filter:blur(80px);opacity:.18;
}
.login-bg-orb-1{
  width:600px;height:600px;left:-200px;top:-200px;
  background:radial-gradient(circle,#1854d4 0%,transparent 70%);
  animation:float1 8s ease-in-out infinite;
}
.login-bg-orb-2{
  width:500px;height:500px;right:-150px;bottom:-100px;
  background:radial-gradient(circle,#7c3aed 0%,transparent 70%);
  animation:float2 10s ease-in-out infinite;
}
.login-bg-orb-3{
  width:400px;height:400px;left:40%;top:30%;
  background:radial-gradient(circle,#0ea5e9 0%,transparent 70%);
  animation:float3 12s ease-in-out infinite;
  opacity:.1;
}

/* Grid overlay */
.login-grid-overlay{
  position:absolute;inset:0;
  background-image:linear-gradient(rgba(255,255,255,.025) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.025) 1px,transparent 1px);
  background-size:50px 50px;
  pointer-events:none;
}

/* SPLIT LAYOUT */
.login-split{
  display:flex;width:100%;max-width:1100px;
  margin:auto;z-index:1;
  min-height:100vh;
}

/* LEFT PANEL — branding */
.login-left{
  flex:1;display:flex;flex-direction:column;
  justify-content:center;padding:3rem 3.5rem;
  position:relative;overflow:hidden;
  animation:fadeSlideUp .7s ease both;
}
.login-left-content{max-width:440px}
.login-brand-logo{
  width: 72px;
  height: 72px;
  background: #fff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 35px rgba(0,0,0,.35), 0 0 0 1px rgba(255,255,255,.1);
  margin-bottom: 2.5rem;
  position: relative;
}
.login-brand-logo::after{
  content:"";position:absolute;inset:-5px;
  border-radius: 25px;border:1px solid rgba(255,255,255,.12);
  animation:pulse-ring 2.5s ease-in-out infinite;
}
.login-company-name{
  font-size: 2.8rem;
  font-weight: 800;
  color: #fff;
  letter-spacing: -0.04em;
  line-height: 1.15;
  margin-bottom: 0.75rem;
}
.login-company-name span{
  background:linear-gradient(135deg,#60a5fa,#a78bfa,#38bdf8);
  -webkit-background-clip:text;-webkit-text-fill-color:transparent;
  background-clip:text;
  background-size:200% auto;
  animation:shimmer 4s linear infinite;
}
.login-tagline{
  font-size: 1.05rem;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 400;
  margin-bottom: 3.5rem;
  line-height: 1.7;
}

/* Feature pills */
.login-features{display:flex;flex-direction:column;gap:.75rem;margin-bottom:2.5rem}
.login-feature{
  display:flex;align-items:center;gap:.8rem;
  animation:fadeSlideUp .6s ease both;
}
.login-feature:nth-child(1){animation-delay:.1s}
.login-feature:nth-child(2){animation-delay:.2s}
.login-feature:nth-child(3){animation-delay:.3s}
.login-feature:nth-child(4){animation-delay:.4s}
.login-feature-icon{
  width:36px;height:36px;border-radius:9px;
  display:flex;align-items:center;justify-content:center;
  font-size:1rem;flex-shrink:0;
  background:rgba(255,255,255,.07);
  border:1px solid rgba(255,255,255,.1);
}
.login-feature-text{font-size:.85rem;color:rgba(255,255,255,.65);font-weight:500}
.login-feature-text strong{color:rgba(255,255,255,.9);font-weight:700}

/* Website link */
.login-website-link{
  display:inline-flex;align-items:center;gap:.45rem;
  color:rgba(255,255,255,.4);font-size:.78rem;
  text-decoration:none;transition:color .2s;
  border-top:1px solid rgba(255,255,255,.07);
  padding-top:1.5rem;margin-top:.5rem;
}
.login-website-link:hover{color:rgba(255,255,255,.8)}
.login-website-link svg{width:14px;height:14px}

/* RIGHT PANEL — form */
.login-right{
  width:460px;flex-shrink:0;
  display:flex;align-items:center;justify-content:center;
  padding:2rem;
  animation:scaleIn .6s ease .1s both;
}

/* Glass card */
.login-card {
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-radius: 24px;
  padding: 3rem 2.5rem;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 30px 70px rgba(0, 0, 0, 0.55), inset 0 1px 0 rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.08);
  position: relative;
  overflow: hidden;
}
.login-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #1854d4, #7c3aed, #0ea5e9, #1854d4);
  background-size: 300% auto;
  animation: shimmer 3s linear infinite;
}

.login-card-logo {
  width: 62px;
  height: 62px;
  background: #fff;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  margin: 0 auto 1.6rem;
  position: relative;
}
.login-card-logo::after {
  content: "";
  position: absolute;
  inset: -3px;
  border-radius: 19px;
  border: 1.5px solid rgba(24, 84, 212, 0.3);
}

.login-card-title {
  text-align: center;
  font-size: 1.55rem;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: -0.03em;
  margin-bottom: 0.3rem;
}
.login-card-sub {
  text-align: center;
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 2.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
}
.login-card-sub-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  display: inline-block;
}

/* Input groups */
.login-field {
  margin-bottom: 1.25rem;
}
.login-label {
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 0.45rem;
  letter-spacing: 0.03em;
}
.login-input-wrap {
  position: relative;
}
.login-input-icon {
  position: absolute;
  left: 0.95rem;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.35);
  pointer-events: none;
  display: flex;
  align-items: center;
}
.login-input {
  width: 100%;
  padding: 0.8rem 0.95rem 0.8rem 2.8rem;
  border: 1.5px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.5);
  color: #ffffff;
  font-size: 0.9rem;
  font-family: 'Plus Jakarta Sans', sans-serif;
  outline: none;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}
.login-input:focus {
  border-color: #3b82f6;
  background: rgba(15, 23, 42, 0.7);
  box-shadow: 0 0 16px rgba(59, 130, 246, 0.25);
}
.login-input::placeholder {
  color: rgba(255, 255, 255, 0.25);
}
.login-eye-btn {
  position: absolute;
  right: 0.9rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.35);
  padding: 0.25rem;
  border-radius: 5px;
  display: flex;
  align-items: center;
  transition: color 0.15s;
}
.login-eye-btn:hover {
  color: rgba(255, 255, 255, 0.75);
}

.login-error {
  background: rgba(239, 68, 68, 0.1);
  color: #f87171;
  font-size: 0.78rem;
  padding: 0.7rem 0.95rem;
  border-radius: 10px;
  margin-bottom: 1rem;
  border: 1px solid rgba(239, 68, 68, 0.2);
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* Sign in button */
.login-btn {
  width: 100%;
  padding: 0.88rem;
  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 0.92rem;
  font-weight: 700;
  font-family: 'Plus Jakarta Sans', sans-serif;
  cursor: pointer;
  letter-spacing: 0.02em;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 8px 24px rgba(29, 78, 216, 0.3);
  position: relative;
  overflow: hidden;
  margin-top: 0.4rem;
}
.login-btn::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.12), transparent);
  opacity: 0;
  transition: opacity 0.2s;
}
.login-btn:hover::after {
  opacity: 1;
}
.login-btn:hover {
  transform: translateY(-1.5px);
  box-shadow: 0 12px 28px rgba(29, 78, 216, 0.45);
}
.login-btn:active {
  transform: translateY(0);
}
.login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Spinner inside button */
@keyframes spin { to { transform: rotate(360deg); } }
.login-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  display: inline-block;
  margin-right: 0.5rem;
  vertical-align: middle;
}

.login-hint {
  text-align: center;
  font-size: 0.72rem;
  color: rgba(255, 255, 255, 0.4);
  margin-top: 1.5rem;
  line-height: 1.6;
}
.login-hint a {
  color: #60a5fa;
  text-decoration: none;
  font-weight: 600;
}
.login-hint a:hover {
  text-decoration: underline;
}

/* Copyright footer */
.login-copyright {
  margin-top: 1.6rem;
  padding-top: 1.1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  text-align: center;
  font-size: 0.68rem;
  color: rgba(255, 255, 255, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  letter-spacing: 0.01em;
}
.login-copyright svg {
  opacity: 0.45;
}

/* Divider */
.login-divider{
  display:flex;align-items:center;gap:.75rem;
  margin:1.2rem 0;color:#cbd5e1;font-size:.72rem;
}
.login-divider::before,.login-divider::after{
  content:"";flex:1;height:1px;background:#e2e8f0;
}

/* RESPONSIVE */
@media(max-width:900px){
  .login-left{display:none}
  .login-right{width:100%;padding:1.5rem}
  .login-split{min-height:100vh;justify-content:center}
}
@media(max-width:480px){
  .login-right{padding:1rem}
  .login-card{padding:2rem 1.5rem;border-radius:18px}
  .login-card-title{font-size:1.2rem}
}

/* SECTION DIVIDER */
.divider{border:none;border-top:1px solid var(--border);margin:1.2rem 0}

/* EMPTY */
.empty{text-align:center;padding:3rem 1rem;color:var(--text3)}
.empty-ic{font-size:2.5rem;margin-bottom:.8rem;opacity:.5}
.empty-txt{font-size:.88rem}

/* PRINT */
@media print{
  .no-print{display:none!important}
  .print-only{display:block!important}
  .erp-app{display:block}
  .sidebar,.topbar{display:none}
  .content{overflow:visible;padding:0}
  body{background:white;font-size:11px}
  .card,.stat-card,.salary-card{box-shadow:none;border:1px solid #ccc}
  @page{margin:15mm}
  /* Block printing of salary content for non-SA users unless explicitly allowed */
  .sal-print-blocked{display:none!important}
  /* Hide screenshot watermark in normal print (it shows in browser print preview which is fine) */
  .screenshot-watermark{display:none!important}
}
.print-only{display:none}

/* ═══════════════════════════════════════════════════════
   SCREENSHOT PROTECTION  (PC + Mobile)
   ═══════════════════════════════════════════════════════ */

/* 1. Confidential diagonal watermark — always visible, burns into screenshots */
.screenshot-watermark{
  position:fixed;inset:0;pointer-events:none;z-index:500;
  display:flex;align-items:center;justify-content:center;
  overflow:hidden;
}
.screenshot-watermark-inner{
  position:absolute;inset:-60%;
  display:flex;flex-wrap:wrap;align-content:flex-start;
  transform:rotate(-35deg);
  gap:0;
}
.screenshot-watermark-text{
  font-size:.75rem;font-weight:900;letter-spacing:.16em;
  /* High enough opacity to be clearly visible in screenshots */
  color:rgba(140,0,0,.15);white-space:nowrap;
  padding:1.5rem .9rem;user-select:none;pointer-events:none;
  font-family:'Plus Jakarta Sans',sans-serif;text-transform:uppercase;
}

/* 2. PrtScn / screenshot flash overlay — covers entire viewport */
#prtscn-block{
  position:fixed;inset:0;z-index:99999;
  background:rgba(8,8,18,.99);
  display:flex;flex-direction:column;align-items:center;justify-content:center;
  gap:1.2rem;pointer-events:none;opacity:0;
  transition:opacity .08s ease;
  /* GPU-composited layer so it beats OS screenshot timing on most devices */
  will-change:opacity;transform:translateZ(0);
}
#prtscn-block.show{opacity:1;pointer-events:all}
#prtscn-block .prtscn-icon{font-size:4rem}
#prtscn-block .prtscn-title{
  font-size:1.4rem;font-weight:800;color:#fff;
  font-family:'Plus Jakarta Sans',sans-serif;
}
#prtscn-block .prtscn-sub{
  font-size:.9rem;color:rgba(255,255,255,.6);
  font-family:'Plus Jakarta Sans',sans-serif;text-align:center;max-width:380px;
}

/* 3. Salary page: disable text selection, drag, and touch callout (mobile) */
.salary-protected{
  user-select:none;-webkit-user-select:none;-moz-user-select:none;
  -webkit-touch-callout:none;   /* iOS: disables long-press save image */
  -webkit-user-drag:none;
  -khtml-user-drag:none;
}

/* 4. Blur-guard: when the browser tab is hidden (e.g. user opens Snipping
      Tool, Win+Shift+S, or swipes the notification shade on Android),
      the salary content is immediately blurred so a screenshot captures
      nothing readable.  The blur is removed when the tab returns to focus. */
.salary-blur-guard{
  transition:filter .05s ease;  /* near-instant blur */
}
/* Applied by JS via data attribute when visibility:hidden */
.salary-blur-guard[data-hidden="1"]{
  filter:blur(18px) brightness(.4);
  pointer-events:none;
}

/* Print Request Panel */
.print-req-panel{
  background:var(--white);border:1px solid var(--border);
  border-radius:var(--radius-lg);overflow:hidden;
  box-shadow:var(--shadow-sm);margin-bottom:1.2rem;
}
.print-req-header{
  background:linear-gradient(135deg,var(--navy) 0%,var(--navy3) 100%);
  padding:.9rem 1.2rem;display:flex;align-items:center;
  justify-content:space-between;
}
.print-req-header-title{
  font-size:.88rem;font-weight:700;color:#fff;
  display:flex;align-items:center;gap:.5rem;
}
.print-req-badge{
  background:var(--red);color:#fff;font-size:.65rem;
  font-weight:800;padding:.15rem .5rem;border-radius:20px;
  min-width:20px;text-align:center;
}
.print-req-row{
  display:flex;align-items:center;gap:.8rem;
  padding:.8rem 1.2rem;border-bottom:1px solid var(--bg);
  transition:background .15s;
}
.print-req-row:last-child{border-bottom:none}
.print-req-row:hover{background:var(--bg3)}

/* HAMBURGER */
.hamburger{display:none;flex-direction:column;gap:5px;cursor:pointer;padding:.5rem;border-radius:6px;border:none;background:transparent;transition:background .15s;flex-shrink:0}
.hamburger:hover{background:var(--bg)}
.hamburger span{display:block;width:20px;height:2px;background:var(--text2);border-radius:2px;transition:all .2s}
.hamburger.open span:nth-child(1){transform:translateY(7px) rotate(45deg)}
.hamburger.open span:nth-child(2){opacity:0}
.hamburger.open span:nth-child(3){transform:translateY(-7px) rotate(-45deg)}

/* MOBILE SIDEBAR OVERLAY */
.sidebar-overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:49;backdrop-filter:blur(2px)}
.sidebar-overlay.visible{display:block}

/* MOBILE NAV BAR */
.mobile-nav{display:none;position:fixed;bottom:0;left:0;right:0;background:var(--white);border-top:1px solid var(--border);z-index:100;box-shadow:0 -4px 16px rgba(0,0,0,.08);padding-bottom:calc(10px + env(safe-area-inset-bottom,0px))}
.mobile-nav-inner{display:flex;height:var(--mobile-nav);overflow-x:auto;scrollbar-width:none;-webkit-overflow-scrolling:touch}
.mobile-nav-inner::-webkit-scrollbar{display:none}
.mobile-nav-item{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:.2rem;min-width:64px;flex:1;padding:.4rem .2rem;cursor:pointer;color:var(--text4);transition:all .15s;border-top:2px solid transparent;text-decoration:none;-webkit-tap-highlight-color:transparent}
.mobile-nav-item.active{color:var(--blue);border-top-color:var(--blue)}
.mobile-nav-item span{font-size:.58rem;font-weight:600;text-align:center;letter-spacing:.01em;line-height:1.2;white-space:nowrap}

/* RESPONSIVE BREAKPOINTS */
@media(max-width:768px){
  .hamburger{display:flex}
  .mobile-nav{display:flex}
  .content{padding:1rem;padding-bottom:calc(var(--mobile-nav) + 20px + env(safe-area-inset-bottom,0px) + 3rem)}
  .sidebar{position:fixed;top:0;left:0;height:100vh;z-index:50;transform:translateX(-100%);transition:transform .25s cubic-bezier(.4,0,.2,1)}
  .sidebar.open{transform:translateX(0);box-shadow:4px 0 24px rgba(0,0,0,.25)}
  .stat-grid{grid-template-columns:1fr 1fr!important}
  .grid-2{grid-template-columns:1fr!important}
  .grid-3{grid-template-columns:1fr!important}
  .form-grid{grid-template-columns:1fr!important}
  .form-grid-3{grid-template-columns:1fr!important}
  .search-bar{flex-direction:column;align-items:stretch}
  .search-wrap{max-width:100%}
  .page-hdr{flex-direction:column;align-items:flex-start;gap:.6rem}
  .tb-date{display:none}
  .leave-card{flex-direction:column;align-items:flex-start}
  .tbl-actions{flex-wrap:wrap}
  #erp-toast{left:1rem;right:1rem;bottom:calc(var(--mobile-nav) + 10px + env(safe-area-inset-bottom,0px) + .75rem);max-width:none}
  .att-grid{grid-template-columns:1fr}
  .sal-hdr{flex-direction:column;gap:.5rem}
  .perm-card{flex-direction:column!important}
}
@media(max-width:480px){
  .stat-grid{grid-template-columns:1fr!important}
  .modal{border-radius:var(--radius-lg) var(--radius-lg) 0 0;max-height:95vh;margin:auto 0 0;align-self:flex-end}
  .overlay{align-items:flex-end;padding:0}
}

/* UTILS */
.flex{display:flex}.flex-col{flex-direction:column}.flex-1{flex:1}.items-center{align-items:center}.items-start{align-items:flex-start}.justify-between{justify-content:space-between}.justify-end{justify-content:flex-end}.gap-1{gap:.4rem}.gap-2{gap:.8rem}.gap-3{gap:1.2rem}.gap-4{gap:1.6rem}
.mt-1{margin-top:.4rem}.mt-2{margin-top:.8rem}.mt-3{margin-top:1.2rem}.mt-4{margin-top:1.6rem}
.mb-1{margin-bottom:.4rem}.mb-2{margin-bottom:.8rem}.mb-3{margin-bottom:1.2rem}
.w-full{width:100%}.text-sm{font-size:.8rem}.text-xs{font-size:.72rem}.text-muted{color:var(--text3)}.text-right{text-align:right}.font-bold{font-weight:700}.font-mono{font-family:'JetBrains Mono',monospace}
.grid-2{display:grid;grid-template-columns:1fr 1fr;gap:1rem}
.grid-3{display:grid;grid-template-columns:1fr 1fr 1fr;gap:1rem}
.rounded{border-radius:var(--radius)}.rounded-lg{border-radius:var(--radius-lg)}
.p-2{padding:.8rem}.p-3{padding:1.2rem}
.separator{display:flex;align-items:center;gap:.8rem;margin:1rem 0;color:var(--text4);font-size:.72rem}.separator::before,.separator::after{content:'';flex:1;height:1px;background:var(--border)}
.info-box{background:var(--blue-lt);border:1px solid var(--blue-lt2);border-radius:6px;padding:.8rem 1rem;font-size:.8rem;color:var(--blue2)}
.warning-box{background:var(--orange-lt);border:1px solid var(--orange-lt2);border-radius:6px;padding:.8rem 1rem;font-size:.8rem;color:var(--orange)}

/* TOGGLE */
.toggle{display:flex;align-items:center;gap:.5rem;cursor:pointer;user-select:none}
.toggle-track{width:38px;height:20px;background:var(--border2);border-radius:10px;position:relative;transition:background .2s;flex-shrink:0}
.toggle-track.on{background:var(--green)}
.toggle-thumb{position:absolute;width:14px;height:14px;background:#fff;border-radius:50%;top:3px;left:3px;transition:left .2s;box-shadow:0 1px 3px rgba(0,0,0,.2)}
.toggle-track.on .toggle-thumb{left:21px}
.toggle-label{font-size:.8rem;font-weight:500;color:var(--text2)}

/* SECTION CARD (for print reports) */
.print-report{background:white}
.print-hdr{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:1.5rem;padding-bottom:1rem;border-bottom:2px solid var(--navy)}
.print-company{font-size:1.4rem;font-weight:800;color:var(--navy)}
.print-report-title{font-size:.9rem;font-weight:600;color:var(--text3)}

/* Helpdesk Chat Module Styles */
.helpdesk-container {
  display: flex;
  height: calc(100vh - var(--topbar) - 40px);
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  overflow: hidden;
  box-shadow: var(--shadow);
}
.invite-dropdown-wrap {
  position: relative;
}
.invite-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  width: 250px;
  max-height: 250px;
  overflow-y: auto;
  z-index: 100;
  margin-top: 0.5rem;
}
.invite-option {
  padding: 0.6rem 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: background 0.2s ease;
}
.invite-option:hover {
  background: var(--bg);
}
.invite-header {
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--text3);
  background: var(--bg3);
  border-bottom: 1px solid var(--border);
}
.chat-participants-list {
  font-size: 0.75rem;
  color: var(--text3);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 500px;
  margin-top: 0.1rem;
}
.ended-chat-notice {
  background: var(--red-lt);
  border-top: 1px solid var(--red-lt2);
  color: var(--red);
  padding: 1rem 1.5rem;
  font-weight: 600;
  text-align: center;
  font-size: 0.9rem;
}
.helpdesk-sidebar {
  width: 320px;
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  background: var(--bg3);
}
.sidebar-search {
  padding: 1rem;
  border-bottom: 1px solid var(--border);
}
.sidebar-search input {
  width: 100%;
  padding: 0.6rem 0.8rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  font-size: 0.85rem;
  outline: none;
}
.sidebar-search input:focus {
  border-color: var(--blue2);
}
.employee-list {
  flex: 1;
  overflow-y: auto;
}
.employee-item {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 1rem;
  border-bottom: 1px solid var(--border);
  cursor: pointer;
  transition: all 0.2s ease;
}
.employee-item:hover {
  background: var(--bg);
}
.employee-item.active {
  background: var(--blue-lt2);
  border-left: 4px solid var(--blue2);
}
.employee-details {
  flex: 1;
  min-width: 0;
}
.employee-name-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 0.2rem;
}
.employee-name {
  font-weight: 700;
  font-size: 0.9rem;
  color: var(--text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.last-msg-time {
  font-size: 0.7rem;
  color: var(--text4);
}
.last-msg-preview {
  font-size: 0.8rem;
  color: var(--text3);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.chat-window {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: var(--white);
}
.chat-window-placeholder {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--text3);
  gap: 0.8rem;
}
.chat-window-placeholder span {
  font-size: 1.2rem;
  font-weight: 600;
}
.chat-header {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  gap: 0.8rem;
  background: var(--bg3);
}
.chat-header-info {
  flex: 1;
}
.chat-header-name {
  font-weight: 800;
  font-size: 1rem;
}
.chat-header-status {
  font-size: 0.75rem;
  color: var(--green);
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.chat-header-status::before {
  content: "";
  display: inline-block;
  width: 6px;
  height: 6px;
  background: var(--green2);
  border-radius: 50%;
}
.chat-messages {
  flex: 1;
  padding: 1.5rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: #f8fafc;
}
.message-row {
  display: flex;
  align-items: flex-end;
  gap: 0.8rem;
  max-width: 75%;
}
.message-row.sent {
  align-self: flex-end;
  flex-direction: row-reverse;
}
.message-row.received {
  align-self: flex-start;
}
.message-content {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}
.message-bubble {
  padding: 0.8rem 1.2rem;
  border-radius: var(--radius-lg);
  font-size: 0.9rem;
  line-height: 1.4;
  word-break: break-word;
  box-shadow: var(--shadow-sm);
}
.message-row.sent .message-bubble {
  background: var(--blue);
  color: var(--white);
  border-bottom-right-radius: 2px;
}
.message-row.received .message-bubble {
  background: var(--white);
  color: var(--text);
  border-bottom-left-radius: 2px;
  border: 1px solid var(--border);
}
.message-meta {
  font-size: 0.7rem;
  color: var(--text3);
  display: flex;
  gap: 0.5rem;
}
.message-row.sent .message-meta {
  justify-content: flex-end;
}
.chat-input-area {
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--border);
  background: var(--bg3);
  display: flex;
  gap: 1rem;
  align-items: center;
}
.chat-input-area input {
  flex: 1;
  padding: 0.8rem 1rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  outline: none;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}
.chat-input-area input:focus {
  border-color: var(--blue2);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  background: var(--white);
}
.chat-input-area button {
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: var(--radius-lg);
  background: var(--blue);
  color: var(--white);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.chat-input-area button:hover {
  background: var(--blue2);
  transform: translateY(-1px);
}
.chat-input-area button:active {
  transform: translateY(0);
}

.msg-delete-btn {
  background: none;
  border: none;
  color: var(--text4);
  cursor: pointer;
  font-size: 0.65rem;
  padding: 0;
  margin-left: 0.5rem;
  transition: color 0.15s;
}
.msg-delete-btn:hover {
  color: var(--red) !important;
}

.chat-attach-btn {
  font-size: 1.2rem;
  cursor: pointer;
  padding: 0.5rem;
  color: var(--text3);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.15s;
  border-radius: var(--radius);
}
.chat-attach-btn:hover {
  color: var(--blue);
  background: var(--bg);
}

.chat-media-wrap {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.chat-media-image {
  max-width: 200px;
  max-height: 200px;
  border-radius: var(--radius);
  cursor: pointer;
  object-fit: cover;
  transition: opacity 0.2s;
}
.chat-media-image:hover {
  opacity: 0.9;
}
.chat-media-caption {
  font-size: 0.75rem;
  opacity: 0.8;
  word-break: break-all;
}
.chat-media-file {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  color: inherit;
  text-decoration: underline;
  word-break: break-all;
  font-weight: 500;
}

.mobile-back-btn {
  display: none;
}

/* Helpdesk Mobile Responsiveness */
@media(max-width:768px) {
  .helpdesk-container {
    height: calc(100vh - var(--topbar) - var(--mobile-nav) - 3.5rem);
    margin-bottom: 0;
    flex-direction: column;
  }
  .mobile-back-btn {
    display: inline-flex !important;
    align-items: center;
    gap: 0.3rem;
    background: transparent;
    border: 1px solid var(--border);
    padding: 0.3rem 0.6rem;
    margin-right: 0.5rem;
    font-size: 0.8rem;
    border-radius: var(--radius);
    color: var(--text2);
    cursor: pointer;
  }
  .mobile-back-btn:hover {
    background: var(--bg);
  }
  .helpdesk-sidebar {
    width: 100% !important;
    border-right: none !important;
    flex: 1;
    display: flex;
  }
  .chat-window {
    width: 100% !important;
    flex: 1;
    display: flex;
  }
  .chat-header {
    padding: 0.8rem 1rem;
  }
  .chat-messages {
    padding: 1rem;
  }
  .message-row {
    max-width: 85%;
  }
  .chat-input-area {
    padding: 0.8rem 1rem;
  }

  /* Toggling logic */
  .helpdesk-container:not(.chat-active) .helpdesk-sidebar {
    display: flex !important;
  }
  .helpdesk-container:not(.chat-active) .chat-window,
  .helpdesk-container:not(.chat-active) .chat-window-placeholder {
    display: none !important;
  }
  
  .helpdesk-container.chat-active .helpdesk-sidebar {
    display: none !important;
  }
  .helpdesk-container.chat-active .chat-window {
    display: flex !important;
  }
  .helpdesk-container.chat-active .chat-window-placeholder {
    display: none !important;
  }
}

/* ═══════════════════════════════════════════════════════
   3D PAGE TRANSITIONS & STAGGER EFFECTS
   ═══════════════════════════════════════════════════════ */

@keyframes pagePerspectiveIn {
  0% {
    opacity: 0;
    transform: translateY(30px) scale(0.96) rotateX(4deg);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1) rotateX(0deg);
  }
}

@keyframes slideUpFade {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes navGlowPulse {
  0%, 100% { box-shadow: 0 2px 8px rgba(37,99,235,.4); }
  50% { box-shadow: 0 2px 20px rgba(59,130,246,.75); }
}

.content > div {
  animation: pagePerspectiveIn 0.65s cubic-bezier(0.16, 1, 0.3, 1) both;
  transform-origin: top center;
  perspective: 1000px;
}

/* Sidebar Item Slide-in Accent */
.nav-item.active {
  position: relative;
  overflow: hidden;
  animation: navGlowPulse 2.5s infinite ease-in-out;
}
.nav-item.active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 15%;
  height: 70%;
  width: 4px;
  background: #60a5fa;
  border-radius: 0 4px 4px 0;
  animation: slideUpFade 0.4s ease-out both;
}

/* Stagger Animations for Sub-elements */
.content > div > .page-hdr {
  animation: slideUpFade 0.5s cubic-bezier(0.16, 1, 0.3, 1) both;
}
.content > div > .search-bar {
  animation: slideUpFade 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.05s both;
}
.content > div > .stat-grid > .stat-card {
  animation: slideUpFade 0.6s cubic-bezier(0.16, 1, 0.3, 1) both;
}
.content > div > .stat-grid > .stat-card:nth-child(1) { animation-delay: 0.08s; }
.content > div > .stat-grid > .stat-card:nth-child(2) { animation-delay: 0.13s; }
.content > div > .stat-grid > .stat-card:nth-child(3) { animation-delay: 0.18s; }
.content > div > .stat-grid > .stat-card:nth-child(4) { animation-delay: 0.23s; }

.content > div > .card, 
.content > div > .tbl-wrap,
.content > div > .rpt-wrap,
.content > div > .salary-card,
.content > div > .helpdesk-container {
  animation: slideUpFade 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.12s both;
}


`;

// ─── TOAST ────────────────────────────────────────────────────────────────────
let toastTimer;
function showToast(msg, type = "ok") {
  const t = document.getElementById("erp-toast");
  if (!t) return;
  t.textContent = msg;
  t.className = `show ${type}`;
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => (t.className = ""), 3000);
}

// ─── ICONS (inline SVG) ───────────────────────────────────────────────────────
const Icon = ({ n, size = 16, col }) => {
  const paths = {
    dashboard: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z",
    users: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z",
    attendance: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z",
    leave: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z",
    salary: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z",
    reports: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z",
    settings: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z",
    logout: "M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z",
    mark: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z",
    add: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z",
    edit: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z",
    del: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z",
    search: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z",
    eye: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z",
    lock: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z",
    print: "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z",
    download: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z",
    chevron: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z",
    info: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z",
    group: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z",
    workorder: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z",
    quotation: "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zM9 13v2h6v-2H9zm0 4v2h6v-2H9zm0-8v2h4V9H9z",
    helpdesk: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z",
    arrow_back: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z",
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill={col || "currentColor"} style={{ flexShrink: 0 }}>
      <path d={paths[n] || ""} />
    </svg>
  );
};

// ─── FIRESTORE HELPERS ───────────────────────────────────────────────────────
// Each data collection is stored as a single Firestore document under
// civyx-erp/{key} for simplicity (matches original localStorage shape).
async function fsWrite(key, value) {
  try {
    await setDoc(doc(db, "civyx-erp", key), { data: JSON.stringify(value) });
  } catch (e) {
    console.error("Firestore write error:", e);
  }
}

// ─── MAIN APP ─────────────────────────────────────────────────────────────────
export default function App() {
  const DEFAULT_SETTINGS = {
    companyName: "Civyx Infra",
    companyTagline: "Building Infrastructure, Building Trust",
    companyAddress: "Saurikh, Tirwa Road, Saurikh, Kannauj, Uttar Pradesh - 209728",
    companyPhone: "+91-60059 72206",
    companyEmail: "info@civyxinfra.com",
    companyWebsite: "www.civyxinfra.com",
    companyGstin: "09ASVPK6249E1Z6",
    companyBank: "State Bank of India",
    companyAccountNo: "XXXXXXXXXXXX",
    companyIfsc: "SBIN0XXXXXX",
    logo: LOGO_B64,
    deductLeave: true,
    halfDayFactor: 0.5,
    weekOffPaid: true,
    holidayPaid: true,
    workDays: [1, 2, 3, 4, 5, 6],
    activeProfileId: "civyx",
    profiles: [
      {
        id: "civyx",
        companyName: "Civyx Infra",
        companyTagline: "Building Infrastructure, Building Trust",
        companyAddress: "Saurikh, Tirwa Road, Saurikh, Kannauj, Uttar Pradesh - 209728",
        companyPhone: "+91-60059 72206",
        companyEmail: "info@civyxinfra.com",
        companyWebsite: "www.civyxinfra.com",
        companyGstin: "09ASVPK6249E1Z6",
        companyBank: "State Bank of India",
        companyAccountNo: "XXXXXXXXXXXX",
        companyIfsc: "SBIN0XXXXXX",
        logo: LOGO_B64,
      },
      {
        id: "highway",
        companyName: "M/S Highway Solutions",
        companyTagline: "Road & Highway Infrastructure Solutions",
        companyAddress: "Rampur Shadi, Satoura, Talgram, Kannauj, 209731",
        companyPhone: "+91 78894 72206",
        companyEmail: "highwaysolutions0@gmail.com",
        companyWebsite: "www.highwaysolutions.com",
        companyGstin: "09DLWPP0181F1ZM",
        companyBank: "",
        companyAccountNo: "",
        companyIfsc: "",
        logo: HS_LOGO,
      }
    ]
  };

  const [loading, setLoading] = useState(true);
  const [users, setUsersRaw] = useState(INIT_USERS);
  const [attendance, setAttendanceRaw] = useState({});
  const [leaves, setLeavesRaw] = useState([]);
  const [workOrders, setWorkOrdersRaw] = useState([]);
  const [quotations, setQuotationsRaw] = useState([]);
  const [appointmentLetters, setAppointmentLettersRaw] = useState([]);
  const [settings, setSettingsRaw] = useState(DEFAULT_SETTINGS);
  const [printRequests, setPrintRequestsRaw] = useState([]);
  const [deductions, setDeductionsRaw] = useState([]);
  const [incentives, setIncentivesRaw] = useState([]);
  const [chats, setChatsRaw] = useState([]);
  const [threads, setThreadsRaw] = useState([]);
  const [loggedIn, setLoggedIn] = useState(null);
  const [page, setPage] = useState("dashboard");
  const [modal, setModal] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [prtScnFlash, setPrtScnFlash] = useState(false);

  // ── FIRESTORE REAL-TIME LISTENERS ──
  useEffect(() => {
    const keys = [
      { key: "users",              setter: setUsersRaw,              fallback: INIT_USERS },
      { key: "attendance",         setter: setAttendanceRaw,         fallback: {} },
      { key: "leaves",             setter: setLeavesRaw,             fallback: [] },
      { key: "workorders",         setter: setWorkOrdersRaw,         fallback: [] },
      { key: "quotations",         setter: setQuotationsRaw,         fallback: [] },
      { key: "appointmentletters", setter: setAppointmentLettersRaw, fallback: [] },
      { key: "settings",           setter: (data) => {
          const merged = {
            ...DEFAULT_SETTINGS,
            ...data,
            profiles: data?.profiles && data?.profiles.length > 0 ? data.profiles : DEFAULT_SETTINGS.profiles,
            activeProfileId: data?.activeProfileId || DEFAULT_SETTINGS.activeProfileId,
          };
          setSettingsRaw(merged);
        },           fallback: DEFAULT_SETTINGS },
      { key: "printRequests",      setter: setPrintRequestsRaw,      fallback: [] },
      { key: "chats",              setter: setChatsRaw,              fallback: [] },
      { key: "threads",            setter: setThreadsRaw,              fallback: [] },
      { key: "deductions",         setter: setDeductionsRaw,         fallback: [] },
      { key: "incentives",         setter: setIncentivesRaw,         fallback: [] },
    ];

    // ── SAFE SEED ──
    const seedIfMissing = async () => {
      for (const { key, fallback } of keys) {
        try {
          const snap = await getDoc(doc(db, "civyx-erp", key));
          if (!snap.exists()) {
            await fsWrite(key, fallback);
          }
        } catch (e) {
          console.error(`Firestore seed error (${key}):`, e);
        }
      }
    };
    seedIfMissing();

    let resolved = 0;
    const total = keys.length;

    const unsubs = keys.map(({ key, setter, fallback }) =>
      onSnapshot(doc(db, "civyx-erp", key), (snap) => {
        if (snap.exists()) {
          try { setter(JSON.parse(snap.data().data)); } catch { setter(fallback); }
        } else {
          setter(fallback);
        }
        resolved++;
        if (resolved >= total) setLoading(false);
      }, (err) => {
        console.error(`Firestore listener error (${key}):`, err);
        resolved++;
        if (resolved >= total) setLoading(false);
      })
    );

    return () => unsubs.forEach(u => u());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── AUTO-GENERATE, SYNC & RESERIAL APPOINTMENT LETTERS BY JOINING YEAR ──
  useEffect(() => {
    if (loading || !users || users.length === 0) return;

    let updated = false;
    const nextLetters = [...appointmentLetters];

    // Step 1: create new letters for new users / sync profile fields for existing
    users.forEach(user => {
      const existingIdx = nextLetters.findIndex(al => al.userId === user.id);
      if (existingIdx === -1) {
        const newLetter = {
          id: uid(),
          userId: user.id,
          userName: user.name,
          serialNo: "PENDING", // will be assigned in step 2
          issuedDate: user.joinDate || today(),
          designation: user.designation || "Employee",
          dept: user.dept || "Management",
          salary: user.salary || 0,
          status: "Final",
          createdBy: "System",
          createdAt: today()
        };
        nextLetters.push(newLetter);
        updated = true;
      } else {
        const al = nextLetters[existingIdx];
        const newDesignation = user.designation || "Employee";
        const newDept = user.dept || "Management";
        const newSalary = user.salary || 0;
        const changed =
          al.userName !== user.name ||
          al.designation !== newDesignation ||
          al.dept !== newDept ||
          al.salary !== newSalary;
        if (changed) {
          nextLetters[existingIdx] = {
            ...al,
            userName: user.name,
            designation: newDesignation,
            dept: newDept,
            salary: newSalary,
          };
          updated = true;
        }
      }
    });

    // Step 2: recalculate ALL serial numbers, grouped by joining year
    // Build a map: letter index -> joining year (from the user's joinDate)
    const byYear = {};
    nextLetters.forEach((al, idx) => {
      const user = users.find(u => u.id === al.userId);
      const year = user?.joinDate
        ? new Date(user.joinDate).getFullYear()
        : new Date(al.issuedDate || today()).getFullYear();
      if (!byYear[year]) byYear[year] = [];
      byYear[year].push({ idx, al });
    });

    Object.entries(byYear).forEach(([year, group]) => {
      // Sort within each year by issuedDate for a stable, predictable order
      group.sort((a, b) => (a.al.issuedDate || "").localeCompare(b.al.issuedDate || ""));
      group.forEach((item, i) => {
        const expectedSerial = `AL-${year}-${String(i + 1).padStart(4, "0")}`;
        if (nextLetters[item.idx].serialNo !== expectedSerial) {
          nextLetters[item.idx] = { ...nextLetters[item.idx], serialNo: expectedSerial };
          updated = true;
        }
      });
    });

    if (updated) {
      setAppointmentLetters(nextLetters);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users, loading]);

  // ── WRITE HELPERS (write to Firestore, update local state optimistically) ──
  const setUsers = (v) => {
    const next = typeof v === "function" ? v(users) : v;
    setUsersRaw(next);
    fsWrite("users", next);
  };
  const setAttendance = (v) => {
    const next = typeof v === "function" ? v(attendance) : v;
    setAttendanceRaw(next);
    fsWrite("attendance", next);
  };
  const setLeaves = (v) => {
    const next = typeof v === "function" ? v(leaves) : v;
    setLeavesRaw(next);
    fsWrite("leaves", next);
  };
  const setWorkOrders = (v) => {
    const next = typeof v === "function" ? v(workOrders) : v;
    setWorkOrdersRaw(next);
    fsWrite("workorders", next);
  };
  const setQuotations = (v) => {
    const next = typeof v === "function" ? v(quotations) : v;
    setQuotationsRaw(next);
    fsWrite("quotations", next);
  };
  const setAppointmentLetters = (v) => {
    const next = typeof v === "function" ? v(appointmentLetters) : v;
    setAppointmentLettersRaw(next);
    fsWrite("appointmentletters", next);
  };
  const setSettings = (v) => {
    const next = typeof v === "function" ? v(settings) : v;
    setSettingsRaw(next);
    fsWrite("settings", next);
  };
  const setPrintRequests = (v) => {
    const next = typeof v === "function" ? v(printRequests) : v;
    setPrintRequestsRaw(next);
    fsWrite("printRequests", next);
  };
  const setDeductions = (v) => {
    const next = typeof v === "function" ? v(deductions) : v;
    setDeductionsRaw(next);
    fsWrite("deductions", next);
  };
  const setIncentives = (v) => {
    const next = typeof v === "function" ? v(incentives) : v;
    setIncentivesRaw(next);
    fsWrite("incentives", next);
  };
  const setChats = (v) => {
    const next = typeof v === "function" ? v(chats) : v;
    setChatsRaw(next);
    fsWrite("chats", next);
  };
  const setThreads = (v) => {
    const next = typeof v === "function" ? v(threads) : v;
    setThreadsRaw(next);
    fsWrite("threads", next);
  };

  // ── SCREENSHOT PROTECTION (PC + Mobile) ──
  // Tracks whether any non-SA user is viewing the salary page
  const isSalaryPage = !!(loggedIn && loggedIn.role !== "Super Admin" && page === "salary");

  useEffect(() => {
    // ─ 1. PrintScreen key (PC) ─
    const handleKey = (e) => {
      if (e.key === "PrintScreen" || e.key === "Print Screen") {
        if (!loggedIn || loggedIn.role !== "Super Admin") {
          e.preventDefault();
          setPrtScnFlash(true);
          // Overwrite clipboard with blank so the screenshot is empty
          try {
            navigator.clipboard.write([
              new ClipboardItem({ 'image/png': new Blob([], { type: 'image/png' }) })
            ]);
          } catch(_) {
            try { navigator.clipboard.writeText(""); } catch(__) {}
          }
          setTimeout(() => setPrtScnFlash(false), 3000);
        }
      }
    };

    // ─ 2. Page visibility change (Win+Shift+S, Snipping Tool, mobile screenshot) ─
    // ─ 3. Context menu (right-click / long-press on mobile) block on salary page ─
    const handleContextMenu = (e) => {
      if (!loggedIn || loggedIn.role === "Super Admin") return;
      if (page === "salary") e.preventDefault();
    };

    // ─ 4. Mobile: block touch-hold save / screenshot shortcut ─
    const handleTouchStart = (e) => {
      if (!loggedIn || loggedIn.role === "Super Admin") return;
      if (page === "salary" && e.touches.length >= 3) {
        // 3-finger tap on some Android devices triggers screenshot
        e.preventDefault();
        setPrtScnFlash(true);
        setTimeout(() => setPrtScnFlash(false), 2500);
      }
    };

    window.addEventListener("keydown", handleKey);
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("touchstart", handleTouchStart, { passive: false });
    return () => {
      window.removeEventListener("keydown", handleKey);
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("touchstart", handleTouchStart);
    };
  }, [loggedIn, page]);

  // ── LOADING SCREEN ──
  if (loading) return (
    <>
      <style>{css}</style>
      <div style={{ minHeight: "100vh", background: "var(--navy)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "1.2rem" }}>
        <div style={{ width: 52, height: 52, background: "#fff", borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 2px 16px rgba(0,0,0,.3)" }}>
          <img src={LOGO_B64} alt="Civyx Infra" style={{ width: 44, height: 44, objectFit: "contain" }} />
        </div>
        <div style={{ color: "#fff", fontWeight: 700, fontSize: "1.1rem" }}>Civyx Infra ERP</div>
        <div style={{ color: "rgba(255,255,255,.5)", fontSize: ".82rem" }}>Connecting to database…</div>
      </div>
    </>
  );

  // Use rolePerms from saved settings if available, otherwise fall back to hardcoded PERMS
  // Super Admin always gets all permissions. Newly introduced permissions (like helpdesk)
  // are auto-granted to roles configured in PERMS if they are completely missing from DB rolePerms.
  const effectivePerms = (() => {
    const cur = settings?.rolePerms;
    if (!cur) return PERMS;
    const merged = {};
    Object.keys(PERMS).forEach(role => {
      if (role === "Super Admin") {
        merged[role] = PERMS[role];
      } else {
        let roleArr = cur[role] || [];
        const hasHelpdeskSomewhereInDB = Object.values(cur).some(arr => arr.includes("helpdesk"));
        if (!hasHelpdeskSomewhereInDB && PERMS[role].includes("helpdesk") && !roleArr.includes("helpdesk")) {
          roleArr = [...roleArr, "helpdesk"];
        }
        const hasAppointmentSomewhereInDB = Object.values(cur).some(arr => arr.includes("appointment"));
        if (!hasAppointmentSomewhereInDB && PERMS[role].includes("appointment") && !roleArr.includes("appointment")) {
          roleArr = [...roleArr, "appointment"];
        }
        merged[role] = roleArr;
      }
    });
    return merged;
  })();
  const can = (perm) => loggedIn && (effectivePerms[loggedIn.role] || []).includes(perm);

  // ── LOGIN ──
  if (!loggedIn) return (
    <>
      <style>{css}</style>
      <div id="erp-toast" />
      <LoginScreen users={users} onLogin={setLoggedIn} />
    </>
  );

  const navItems = [
    { id: "dashboard",       label: "Dashboard",       shortLabel: "Dashboard",  icon: "dashboard",  perm: "dashboard" },
    { id: "users",           label: "User Management", shortLabel: "Users",      icon: "users",      perm: "users" },
    { id: "attendance",      label: loggedIn.role === "Employee" ? "My Attendance" : "Attendance", shortLabel: loggedIn.role === "Employee" ? "Attendance" : "Attendance", icon: "attendance", perm: "attendance" },
    { id: "attendance_mark", label: "Mark Attendance", shortLabel: "Mark",       icon: "mark",       perm: "attendance_mark" },
    { id: "leave",           label: loggedIn.role === "Employee" ? "My Leaves" : "Leave Management", shortLabel: loggedIn.role === "Employee" ? "Leaves" : "Leave", icon: "leave", perm: "leave" },
    { id: "salary",          label: "Salary",          shortLabel: "Salary",     icon: "salary",     perm: "salary" },
    { id: "reports",         label: "Reports",         shortLabel: "Reports",    icon: "reports",    perm: "reports" },
    { id: "workorder",       label: "Work Orders",     shortLabel: "Orders",     icon: "workorder",  perm: "workorder" },
    { id: "quotation",       label: "Quotations",      shortLabel: "Quotes",     icon: "quotation",  perm: "quotation" },
    { id: "appointment",     label: "Appointment Letters", shortLabel: "Letters", icon: "quotation",  perm: "appointment" },
    { id: "helpdesk",        label: "Helpdesk",        shortLabel: "Helpdesk",   icon: "helpdesk",   perm: "helpdesk" },
    { id: "settings",        label: "Settings",        shortLabel: "Settings",   icon: "settings",   perm: "settings" },
  ].filter(x => can(x.perm));

  const nowDate = new Date().toLocaleDateString("en-PK", { weekday: "long", year: "numeric", month: "long", day: "numeric" });

  const closeSidebar = () => setSidebarOpen(false);
  const handleNavClick = (id) => { setPage(id); closeSidebar(); };

  const isSA = loggedIn && loggedIn.role === "Super Admin";

  return (
    <>
      <style>{css}</style>
      <div id="erp-toast" />



      {/* PrtScn flash blocker — shown only for non-SA */}
      <div id="prtscn-block" className={prtScnFlash ? "show" : ""}>
        <div className="prtscn-icon">🚫</div>
        <div className="prtscn-title">Screenshot Blocked</div>
        <div className="prtscn-sub">Capturing screenshots of confidential data is not permitted. This activity may be logged.</div>
      </div>

      <div className="erp-app">
        {/* MOBILE SIDEBAR OVERLAY */}
        <div className={`sidebar-overlay${sidebarOpen ? " visible" : ""}`} onClick={closeSidebar} />

        {/* SIDEBAR */}
        <aside className={`sidebar${sidebarOpen ? " open" : ""}`}>
          <div className="sb-brand">
            <div className="sb-logo" style={{ background: "#fff", padding: 2 }}>
              <img src={settings.logo || LOGO_B64} alt={settings.companyName} style={{ width: 32, height: 32, objectFit: "contain" }} />
            </div>
            <div className="sb-brand-text">
              {settings.companyName}
              <span>ERP · Enterprise Suite</span>
            </div>
          </div>
          <div className="sb-section">Navigation</div>
          {navItems.map(n => (
            <div key={n.id} className={`nav-item${page === n.id ? " active" : ""}`} onClick={() => handleNavClick(n.id)}>
              <Icon n={n.icon} size={15} />
              <span>{n.label}</span>
            </div>
          ))}
          <div className="sb-footer">
            <div className="sb-user" onClick={() => { setModal("profile"); closeSidebar(); }}>
              <div className="avatar av-sm" style={{ background: avatarColor(loggedIn.id) }}>{initials(loggedIn.name)}</div>
              <div className="sb-info">
                <div className="sb-name">{loggedIn.name}</div>
                <div className="sb-role">{loggedIn.role}</div>
              </div>
            </div>
            <button className="sb-logout" onClick={() => { setLoggedIn(null); setPage("dashboard"); closeSidebar(); }}>
              <Icon n="logout" size={14} /> Sign Out
            </button>
          </div>
        </aside>

        {/* MAIN */}
        <div className="main">
          <div className="topbar">
            <div style={{ display: "flex", alignItems: "center", gap: ".6rem" }}>
              <button className={`hamburger${sidebarOpen ? " open" : ""}`} onClick={() => setSidebarOpen(o => !o)} aria-label="Toggle menu">
                <span /><span /><span />
              </button>
              <div>
                <div className="tb-title">{navItems.find(x => x.id === page)?.label || "Dashboard"}</div>
                <div className="tb-sub">{settings.companyName}</div>
              </div>
            </div>
            <div className="tb-right">
              <div className="tb-date">{nowDate}</div>
              <div className="tb-badge">{loggedIn.role}</div>
            </div>
          </div>

          <div className="content">
            {page === "dashboard" && <Dashboard users={users} attendance={attendance} leaves={leaves} loggedIn={loggedIn} setPage={setPage} />}
            {page === "users" && <UserMgmt users={users} setUsers={setUsers} loggedIn={loggedIn} />}
            {page === "attendance" && <AttendancePage users={users} attendance={attendance} loggedIn={loggedIn} settings={settings} />}
            {page === "attendance_mark" && <MarkAttendance users={users} attendance={attendance} setAttendance={setAttendance} loggedIn={loggedIn} settings={settings} />}
            {page === "leave" && <LeavePage users={users} leaves={leaves} setLeaves={setLeaves} loggedIn={loggedIn} can={can} attendance={attendance} setAttendance={setAttendance} />}
            {page === "salary" && <SalaryPage users={users} attendance={attendance} settings={settings} loggedIn={loggedIn} can={can} printRequests={printRequests} setPrintRequests={setPrintRequests} deductions={deductions} setDeductions={setDeductions} incentives={incentives} setIncentives={setIncentives} />}
            {page === "reports" && <ReportsPage users={users} attendance={attendance} leaves={leaves} settings={settings} loggedIn={loggedIn} can={can} deductions={deductions} incentives={incentives} />}
            {page === "workorder" && <WorkOrderPage workOrders={workOrders} setWorkOrders={setWorkOrders} loggedIn={loggedIn} settings={settings} />}
            {page === "quotation" && <QuotationPage quotations={quotations} setQuotations={setQuotations} loggedIn={loggedIn} settings={settings} />}
            {page === "appointment" && <AppointmentLetterPage appointmentLetters={appointmentLetters} setAppointmentLetters={setAppointmentLetters} loggedIn={loggedIn} users={users} settings={settings} />}
            {page === "helpdesk" && <HelpdeskPage users={users} loggedIn={loggedIn} chats={chats} setChats={setChats} threads={threads} setThreads={setThreads} loading={loading} />}
            {page === "settings" && <SettingsPage settings={settings} setSettings={setSettings} />}
          </div>
        </div>

        {/* MOBILE BOTTOM NAV */}
        <nav className="mobile-nav">
          <div className="mobile-nav-inner">
            {navItems.map(n => (
              <div key={n.id} className={`mobile-nav-item${page === n.id ? " active" : ""}`} onClick={() => setPage(n.id)}>
                <Icon n={n.icon} size={20} />
                <span>{n.shortLabel}</span>
              </div>
            ))}
            <div className="mobile-nav-item" onClick={() => { setLoggedIn(null); setPage("dashboard"); }}>
              <Icon n="logout" size={20} />
              <span>Logout</span>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
}



// ─── LOGIN ────────────────────────────────────────────────────────────────────
function LoginScreen({ users, onLogin }) {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [err, setErr] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);

  const login = () => {
    if (!email || !pass) { setErr("Please enter your email and password."); return; }
    setLoading(true);
    setErr("");
    // Slight delay for UX feel
    setTimeout(() => {
      const u = users.find(u => u.email === email && u.password === pass && u.active);
      if (u) { onLogin(u); setErr(""); }
      else setErr("Invalid credentials or account inactive.");
      setLoading(false);
    }, 600);
  };

  const features = [
    { icon: "📊", title: "Real-Time Dashboard", desc: "Live attendance & payroll insights" },
    { icon: "👥", title: "Team Management",     desc: "Roles, departments & access control" },
    { icon: "📋", title: "Work Orders & Quotes", desc: "End-to-end project documentation" },
    { icon: "🔒", title: "Enterprise Security",  desc: "Screenshot & data protection built-in" },
  ];

  return (
    <div className="login-wrap">
      {/* Animated background */}
      <div className="login-bg-orb login-bg-orb-1" />
      <div className="login-bg-orb login-bg-orb-2" />
      <div className="login-bg-orb login-bg-orb-3" />
      <div className="login-grid-overlay" />

      <div className="login-split">
        {/* LEFT — Branding panel */}
        <div className="login-left">
          <div className="login-left-content">
            <div className="login-brand-logo">
              <img src={LOGO_B64} alt="Civyx Infra" style={{ width: 52, height: 52, objectFit: "contain" }} />
            </div>

            <div className="login-company-name">
              Civyx <span>Infra</span>
            </div>
            <div className="login-tagline">
              Enterprise Resource Planning Suite —<br />
              Built for infrastructure teams that move fast.
            </div>


            <a
              href="https://www.civyxinfra.com"
              target="_blank"
              rel="noopener noreferrer"
              className="login-website-link"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
              </svg>
              www.civyxinfra.com
            </a>
          </div>
        </div>

        {/* RIGHT — Login form */}
        <div className="login-right">
          <div className="login-card">
            {/* Card logo */}
            <div className="login-card-logo">
              <img src={LOGO_B64} alt="Civyx Infra" style={{ width: 46, height: 46, objectFit: "contain" }} />
            </div>

            <div className="login-card-title">Welcome back</div>
            <div className="login-card-sub">
              <span>Civyx Infra ERP</span>
              <span className="login-card-sub-dot" />
              <span>Secure Portal</span>
            </div>

            {/* Email */}
            <div className="login-field">
              <label className="login-label" htmlFor="login-email">Email Address</label>
              <div className="login-input-wrap">
                <span className="login-input-icon">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                  </svg>
                </span>
                <input
                  id="login-email"
                  className="login-input"
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@civyxinfra.com"
                  onKeyDown={e => e.key === "Enter" && login()}
                  autoComplete="email"
                />
              </div>
            </div>

            {/* Password */}
            <div className="login-field">
              <label className="login-label" htmlFor="login-pass">Password</label>
              <div className="login-input-wrap">
                <span className="login-input-icon">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
                  </svg>
                </span>
                <input
                  id="login-pass"
                  className="login-input"
                  type={showPass ? "text" : "password"}
                  value={pass}
                  onChange={e => setPass(e.target.value)}
                  placeholder="••••••••"
                  onKeyDown={e => e.key === "Enter" && login()}
                  autoComplete="current-password"
                  style={{ paddingRight: "2.8rem" }}
                />
                <button
                  className="login-eye-btn"
                  type="button"
                  onClick={() => setShowPass(s => !s)}
                  tabIndex={-1}
                  aria-label={showPass ? "Hide password" : "Show password"}
                >
                  {showPass ? (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"/>
                    </svg>
                  ) : (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {/* Error */}
            {err && (
              <div className="login-error">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                </svg>
                {err}
              </div>
            )}

            {/* Submit */}
            <button
              id="login-submit-btn"
              className="login-btn"
              onClick={login}
              disabled={loading}
            >
              {loading && <span className="login-spinner" />}
              {loading ? "Signing in…" : "Sign In to ERP"}
            </button>

            <div className="login-hint">
              Need access? Contact your administrator<br />
              <a href="https://www.civyxinfra.com" target="_blank" rel="noopener noreferrer">
                🌐 www.civyxinfra.com
              </a>
            </div>

            <div className="login-copyright">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                <path d="M11.88 9.14c1.28.06 1.61 1.15 1.63 1.66h1.79c-.08-1.98-1.49-3.19-3.45-3.19C9.64 7.61 8 9 8 12.14c0 1.94.93 4.24 3.84 4.24 2.22 0 3.41-1.65 3.44-2.95h-1.79c-.03.59-.45 1.38-1.63 1.38-1.31 0-1.9-1.2-1.9-2.67 0-2.03.71-2.98 1.92-3zm.12-7.14C5.37 2 2 6.48 2 12s3.37 10 9.99 10C18.63 22 22 17.52 22 12S18.63 2 12 2zm-.01 18C6.47 20 4 16.42 4 12S6.47 4 12 4s8 3.58 8 8-3.58 8-8 8z"/>
              </svg>
              2026 Civyx Infra &nbsp;·&nbsp; All rights reserved
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── DASHBOARD ────────────────────────────────────────────────────────────────
function Dashboard({ users, attendance, leaves, loggedIn, setPage }) {
  const now = new Date();
  const todayStr = today();
  const isEmployee = loggedIn.role === "Employee";

  // ── EMPLOYEE PERSONAL DASHBOARD ──
  if (isEmployee) {
    const me = users.find(u => u.id === loggedIn.id) || loggedIn;
    const myLeaves = leaves.filter(l => l.userId === me.id);
    const approvedLeaves = myLeaves.filter(l => l.status === "Approved").length;
    const pendingLeaves = myLeaves.filter(l => l.status === "Pending").length;

    // Today's attendance status
    const todayKey = `${todayStr}_${me.id}`;
    const todayStatus = attendance[todayKey] || null;

    // This month attendance summary
    const y = now.getFullYear(), m = now.getMonth() + 1;
    const days = new Date(y, m, 0).getDate();
    let P = 0, A = 0, L = 0, H = 0;
    for (let d = 1; d <= days; d++) {
      const dateStr = `${y}-${String(m).padStart(2,"0")}-${String(d).padStart(2,"0")}`;
      const key = `${dateStr}_${me.id}`;
      let v = attendance[key];
      if (!v && me.joinDate && dateStr < me.joinDate) v = "A";
      if (v === "P") P++;
      else if (v === "A") A++;
      else if (v === "L") L++;
      else if (v === "H") H++;
    }

    const statusLabel = todayStatus === "P" ? "Present" : todayStatus === "A" ? "Absent" : todayStatus === "L" ? "On Leave" : todayStatus === "H" ? "Holiday" : "Not Marked";
    const statusClass = todayStatus === "P" ? "badge-green" : todayStatus === "A" ? "badge-red" : todayStatus === "L" ? "badge-orange" : todayStatus === "H" ? "badge-purple" : "badge-gray";

    const infoRows = [
      { label: "Full Name",    value: me.name },
      { label: "Employee ID",  value: me.id.toUpperCase() },
      { label: "Email",        value: me.email },
      { label: "Phone",        value: me.phone || "—" },
      { label: "Designation",  value: me.role },
      { label: "Department",   value: me.dept },
      { label: "Date Joined",  value: me.joinDate },
      { label: "Status",       value: me.active ? "Active" : "Inactive", badge: me.active ? "badge-green" : "badge-red" },
    ];

    return (
      <div>
        <div className="page-hdr">
          <div>
            <div className="page-title">Welcome back, {me.name.split(" ")[0]} 👋</div>
            <div className="page-sub">{new Date().toLocaleDateString("en-PK", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}</div>
          </div>
        </div>

        {/* Profile + Today Status */}
        <div className="grid-2" style={{ marginBottom: "1.2rem" }}>
          <div className="card">
            <div className="card-hdr"><div className="card-title">My Profile</div></div>
            <div className="flex items-center gap-3" style={{ marginBottom: "1.2rem" }}>
              <div className="avatar av-xl" style={{ background: avatarColor(me.id) }}>{initials(me.name)}</div>
              <div>
                <div style={{ fontWeight: 800, fontSize: "1.05rem" }}>{me.name}</div>
                <div className="text-sm text-muted">{me.role} · {me.dept}</div>
                <div className="text-xs text-muted" style={{ marginTop: ".2rem" }}>ID: {me.id.toUpperCase()}</div>
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
              {infoRows.map(r => (
                <div key={r.label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: ".55rem 0", borderBottom: "1px solid var(--bg)" }}>
                  <span className="text-xs text-muted" style={{ fontWeight: 600 }}>{r.label}</span>
                  {r.badge
                    ? <span className={`badge ${r.badge}`}>{r.value}</span>
                    : <span className="text-sm" style={{ fontWeight: 500, color: "var(--text)" }}>{r.value}</span>
                  }
                </div>
              ))}
            </div>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            {/* Today's status */}
            <div className="card" style={{ flex: "0 0 auto" }}>
              <div className="card-hdr"><div className="card-title">Today's Attendance</div></div>
              <div className="flex items-center gap-3">
                <div style={{ width: 48, height: 48, borderRadius: 12, background: todayStatus === "P" ? "var(--green-lt)" : todayStatus === "A" ? "var(--red-lt)" : todayStatus === "L" ? "var(--orange-lt)" : "var(--bg2)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.4rem" }}>
                  {todayStatus === "P" ? "✅" : todayStatus === "A" ? "❌" : todayStatus === "L" ? "🏖️" : todayStatus === "H" ? "🎉" : "⏳"}
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: "1rem" }}>{statusLabel}</div>
                  <div className="text-xs text-muted">{todayStr}</div>
                </div>
                <span className={`badge ${statusClass}`} style={{ marginLeft: "auto" }}>{statusLabel}</span>
              </div>
            </div>

            {/* This month summary */}
            <div className="card" style={{ flex: 1 }}>
              <div className="card-hdr"><div className="card-title">This Month's Summary</div><div className="card-sub">{new Date(now.getFullYear(), now.getMonth()).toLocaleString("default", { month: "long", year: "numeric" })}</div></div>
              <div className="stat-grid" style={{ gridTemplateColumns: "1fr 1fr", gap: ".7rem", marginBottom: 0 }}>
                {[
                  { label: "Present", num: P, bg: "var(--green-lt)", col: "var(--green)" },
                  { label: "Absent",  num: A, bg: "var(--red-lt)",   col: "var(--red)" },
                  { label: "On Leave",num: L, bg: "var(--orange-lt)",col: "var(--orange)" },
                  { label: "Holiday", num: H, bg: "var(--purple-lt)",col: "var(--purple)" },
                ].map(s => (
                  <div key={s.label} style={{ background: s.bg, borderRadius: 8, padding: ".7rem 1rem", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <span style={{ fontSize: ".75rem", fontWeight: 600, color: s.col }}>{s.label}</span>
                    <span style={{ fontSize: "1.3rem", fontWeight: 800, color: s.col, fontFamily: "'JetBrains Mono',monospace" }}>{s.num}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Leave summary */}
            <div className="card" style={{ flex: "0 0 auto" }}>
              <div className="card-hdr">
                <div className="card-title">My Leaves</div>
                <button className="btn btn-ghost btn-sm" onClick={() => setPage("leave")}>View All</button>
              </div>
              <div className="flex gap-3">
                <div style={{ flex: 1, textAlign: "center", background: "var(--orange-lt)", borderRadius: 8, padding: ".7rem" }}>
                  <div style={{ fontSize: "1.4rem", fontWeight: 800, color: "var(--orange)", fontFamily: "'JetBrains Mono',monospace" }}>{pendingLeaves}</div>
                  <div style={{ fontSize: ".72rem", color: "var(--orange)", fontWeight: 600 }}>Pending</div>
                </div>
                <div style={{ flex: 1, textAlign: "center", background: "var(--green-lt)", borderRadius: 8, padding: ".7rem" }}>
                  <div style={{ fontSize: "1.4rem", fontWeight: 800, color: "var(--green)", fontFamily: "'JetBrains Mono',monospace" }}>{approvedLeaves}</div>
                  <div style={{ fontSize: ".72rem", color: "var(--green)", fontWeight: 600 }}>Approved</div>
                </div>
                <div style={{ flex: 1, textAlign: "center", background: "var(--blue-lt)", borderRadius: 8, padding: ".7rem" }}>
                  <div style={{ fontSize: "1.4rem", fontWeight: 800, color: "var(--blue)", fontFamily: "'JetBrains Mono',monospace" }}>{myLeaves.length}</div>
                  <div style={{ fontSize: ".72rem", color: "var(--blue)", fontWeight: 600 }}>Total</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Recent leave applications */}
        {myLeaves.length > 0 && (
          <div className="card">
            <div className="card-hdr">
              <div className="card-title">Recent Leave Applications</div>
              <button className="btn btn-ghost btn-sm" onClick={() => setPage("leave")}>View All</button>
            </div>
            <div className="flex flex-col gap-1">
              {myLeaves.slice(-5).reverse().map(l => (
                <div key={l.id} className="flex items-center justify-between" style={{ padding: ".6rem 0", borderBottom: "1px solid var(--bg)" }}>
                  <div>
                    <div className="text-sm font-bold">{l.type} Leave</div>
                    <div className="text-xs text-muted">{l.from} → {l.to} · Applied: {l.appliedOn}</div>
                    <div className="text-xs" style={{ color: "var(--text2)", marginTop: ".1rem" }}>{l.reason}</div>
                  </div>
                  <span className={`badge ${l.status === "Approved" ? "badge-green" : l.status === "Rejected" ? "badge-red" : "badge-orange"}`}>{l.status}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }

  // ── ADMIN / HR / SUPERVISOR DASHBOARD ──
  const activeUsers = users.filter(u => u.active);
  const todayAtt = Object.entries(attendance)
    .filter(([k]) => k.startsWith(todayStr))
    .reduce((a, [k, v]) => { a[k.split("_")[1]] = v; return a; }, {});

  const presentToday = Object.values(todayAtt).filter(v => v === "P").length;
  const absentToday  = Object.values(todayAtt).filter(v => v === "A").length;
  const pendingLeaves = leaves.filter(l => l.status === "Pending").length;

  const stats = [
    { label: "Total Employees", num: activeUsers.length, icon: "users", color: "background:var(--blue-lt);color:var(--blue)" },
    { label: "Present Today",   num: presentToday,       icon: "mark",  color: "background:var(--green-lt);color:var(--green)" },
    { label: "Absent Today",    num: absentToday,        icon: "info",  color: "background:var(--red-lt);color:var(--red)" },
    { label: "Pending Leaves",  num: pendingLeaves,      icon: "leave", color: "background:var(--orange-lt);color:var(--orange)" },
  ];

  const recentLeaves = leaves.slice(-5).reverse();

  return (
    <div>
      <div className="page-hdr">
        <div>
          <div className="page-title">Welcome back, {loggedIn.name.split(" ")[0]} 👋</div>
          <div className="page-sub">Here's what's happening at {new Date().toLocaleDateString("en-PK", { weekday: "long", day: "numeric", month: "long" })}</div>
        </div>
      </div>

      <div className="stat-grid">
        {stats.map((s, i) => (
          <div className="stat-card" key={i}>
            <div className="stat-icon" style={{ cssText: s.color }}><Icon n={s.icon} size={20} /></div>
            <div>
              <div className="stat-num">{s.num}</div>
              <div className="stat-lbl">{s.label}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="grid-2">
        <div className="card">
          <div className="card-hdr">
            <div>
              <div className="card-title">Department Overview</div>
              <div className="card-sub">Employee distribution by department</div>
            </div>
          </div>
          <table style={{ width: "100%" }}>
            <thead><tr><th>Department</th><th>Employees</th><th>Avg. Salary</th></tr></thead>
            <tbody>
              {DEPTS.map(d => {
                const emp = activeUsers.filter(u => u.dept === d);
                const avg = emp.length ? Math.round(emp.reduce((s, u) => s + u.salary, 0) / emp.length) : 0;
                return emp.length > 0 ? (
                  <tr key={d}>
                    <td><span className="badge badge-blue">{d}</span></td>
                    <td className="font-mono">{emp.length}</td>
                    <td className="font-mono text-sm">{fmtCurrency(avg)}</td>
                  </tr>
                ) : null;
              })}
            </tbody>
          </table>
        </div>

        <div className="card">
          <div className="card-hdr">
            <div>
              <div className="card-title">Recent Leave Requests</div>
              <div className="card-sub">Latest applications submitted</div>
            </div>
            <button className="btn btn-ghost btn-sm" onClick={() => setPage("leave")}>View All</button>
          </div>
          {recentLeaves.length === 0 ? (
            <div className="empty"><div className="empty-ic">📋</div><div className="empty-txt">No leave requests yet</div></div>
          ) : (
            <div className="flex flex-col gap-1">
              {recentLeaves.map(l => {
                const u = users.find(u => u.id === l.userId);
                return (
                  <div key={l.id} className="flex items-center justify-between" style={{ padding: ".6rem 0", borderBottom: "1px solid var(--bg)" }}>
                    <div className="flex items-center gap-2">
                      <div className="avatar av-sm" style={{ background: avatarColor(l.userId) }}>{u ? initials(u.name) : "?"}</div>
                      <div>
                        <div className="text-sm font-bold">{u?.name || "Unknown"}</div>
                        <div className="text-xs text-muted">{l.type} · {l.from} → {l.to}</div>
                      </div>
                    </div>
                    <span className={`badge ${l.status === "Approved" ? "badge-green" : l.status === "Rejected" ? "badge-red" : "badge-orange"}`}>{l.status}</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      <div className="card mt-3">
        <div className="card-hdr">
          <div className="card-title">Today's Attendance Summary — {todayStr}</div>
        </div>
        {activeUsers.length === 0 ? (
          <div className="empty"><div className="empty-ic">👥</div><div className="empty-txt">No employees found</div></div>
        ) : (
          <div className="tbl-wrap">
            <table>
              <thead><tr><th>Employee</th><th>Department</th><th>Status</th><th>Role</th></tr></thead>
              <tbody>
                {activeUsers.map(u => {
                  const st = todayAtt[u.id] || "—";
                  return (
                    <tr key={u.id}>
                      <td>
                        <div className="flex items-center gap-2">
                          <div className="avatar av-sm" style={{ background: avatarColor(u.id) }}>{initials(u.name)}</div>
                          <div>
                            <div style={{ fontWeight: 600 }}>{u.name}</div>
                            <div className="text-xs text-muted">{u.email}</div>
                          </div>
                        </div>
                      </td>
                      <td>{u.dept}</td>
                      <td>
                        {st === "—" ? <span className="badge badge-gray">Not Marked</span> :
                          <span className={`badge ${st === "P" ? "badge-green" : st === "A" ? "badge-red" : st === "L" ? "badge-orange" : "badge-purple"}`}>
                            {st === "P" ? "Present" : st === "A" ? "Absent" : st === "L" ? "On Leave" : "Holiday"}
                          </span>}
                      </td>
                      <td><span className="badge badge-gray">{u.role}</span></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

// ─── USER MANAGEMENT ──────────────────────────────────────────────────────────
function UserMgmt({ users, setUsers, loggedIn }) {
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [modal, setModal] = useState(null);
  const [editing, setEditing] = useState(null);
  const [search, setSearch] = useState("");
  const [roleFilter, setRoleFilter] = useState("All");
  const [showPass, setShowPass] = useState(false);
  const [form, setForm] = useState({ id: "", name: "", email: "", password: "", role: "Employee", dept: DEPTS[0], salary: "", phone: "", active: true, joinDate: today() });

  const isSA = loggedIn.role === "Super Admin";
  const isHR = loggedIn.role === "HR Manager" || isSA;

  const filtered = users.filter(u => {
    const q = search.toLowerCase();
    const matchQ = u.name.toLowerCase().includes(q) || u.email.toLowerCase().includes(q) || u.dept.toLowerCase().includes(q);
    const matchR = roleFilter === "All" || u.role === roleFilter;
    return matchQ && matchR;
  });

  const openAdd = () => {
    setEditing(null);
    setForm({ id: uid(), name: "", email: "", password: "", role: "Employee", dept: DEPTS[0], designation: "", salary: "", phone: "", active: true, joinDate: today(), deductLeaveOverride: "global" });
    setModal("user");
  };
  const openEdit = (u) => {
    setEditing(u);
    setForm({ ...u });
    setModal("user");
  };

  const save = () => {
    if (!form.name || !form.email || !form.salary) return showToast("Fill all required fields", "err");
    if (!editing && !form.password) return showToast("Password is required for new user", "err");
    if (editing) {
      const newId = (form.id || editing.id).trim() || editing.id;
      if (newId !== editing.id && users.find(u => u.id === newId)) return showToast("Employee ID already in use", "err");
      setUsers(prev => prev.map(u => u.id === editing.id ? { ...u, ...form, id: newId, salary: Number(form.salary) } : u));
      showToast("User updated successfully");
    } else {
      if (users.find(u => u.email === form.email)) return showToast("Email already exists", "err");
      const newId = (form.id || "").trim() || uid();
      if (users.find(u => u.id === newId)) return showToast("Employee ID already in use — change it", "err");
      setUsers(prev => [...prev, { ...form, id: newId, salary: Number(form.salary) }]);
      showToast("User created successfully", "ok");
    }
    setModal(null);
  };

  const toggleActive = (u) => {
    if (u.id === loggedIn.id) return showToast("Cannot deactivate your own account", "err");
    setUsers(prev => prev.map(x => x.id === u.id ? { ...x, active: !x.active } : x));
    showToast(`User ${u.active ? "deactivated" : "activated"}`);
  };

  const del = (u) => {
    if (u.id === loggedIn.id) return showToast("Cannot delete your own account", "err");
    setDeleteTarget(u);
  };
  const confirmDelete = () => {
    setUsers(prev => prev.filter(x => x.id !== deleteTarget.id));
    showToast("User deleted");
    setDeleteTarget(null);
  };

  const canEditRole = (target) => {
    if (isSA) return true;
    if (isHR && target.role === "Employee") return true;
    return false;
  };

  return (
    <div>
      <div className="page-hdr">
        <div>
          <div className="page-title">User Management</div>
          <div className="page-sub">{users.length} total users · {users.filter(u => u.active).length} active</div>
        </div>
        {isHR && <button className="btn btn-primary" onClick={openAdd}><Icon n="add" size={15} />Add User</button>}
      </div>

      <div className="search-bar">
        <div className="search-wrap">
          <span className="search-ic"><Icon n="search" size={14} /></span>
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search by name, email, dept…" />
        </div>
        <select value={roleFilter} onChange={e => setRoleFilter(e.target.value)} style={{ width: 160 }}>
          <option value="All">All Roles</option>
          {ROLES.map(r => <option key={r}>{r}</option>)}
        </select>
      </div>

      <div className="tbl-wrap">
        <table>
          <thead>
            <tr>
              <th>Employee</th>{isSA && <th>Emp. ID</th>}<th>Role</th><th>Designation</th><th>Department</th><th>Phone</th><th>Salary</th><th>Joined</th><th>Status</th><th>Leave Deduction</th><th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(u => (
              <tr key={u.id}>
                <td>
                  <div className="flex items-center gap-2">
                    <div className="avatar av-sm" style={{ background: avatarColor(u.id) }}>{initials(u.name)}</div>
                    <div>
                      <div style={{ fontWeight: 600 }}>{u.name}</div>
                      <div className="text-xs text-muted">{u.email}</div>
                    </div>
                  </div>
                </td>
                {isSA && (
                  <td>
                    <span className="badge badge-gray" style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: ".68rem", letterSpacing: ".04em" }}>
                      {u.id.toUpperCase()}
                    </span>
                  </td>
                )}
                <td>
                  <span className={`badge ${u.role === "Super Admin" ? "badge-purple" : u.role === "HR Manager" ? "badge-blue" : u.role === "Supervisor" ? "badge-gold" : "badge-gray"}`}>
                    {u.role}
                  </span>
                </td>
                <td className="text-sm" style={{ color: "var(--text2)" }}>{u.designation || <span className="text-muted">—</span>}</td>
                <td>{u.dept}</td>
                <td className="text-sm" style={{ color: "var(--text2)" }}>{u.phone || <span className="text-muted">—</span>}</td>
                <td className="font-mono text-sm">{fmtCurrency(u.salary)}</td>
                <td className="text-muted text-sm">{u.joinDate}</td>
                <td>
                  <span className={`badge ${u.active ? "badge-green" : "badge-red"}`}>{u.active ? "Active" : "Inactive"}</span>
                </td>
                <td>
                  <span className={`badge ${u.deductLeaveOverride === "global" ? "badge-blue" : u.deductLeaveOverride === "yes" ? "badge-red" : "badge-green"}`}>
                    {u.deductLeaveOverride === "global" ? "Global" : u.deductLeaveOverride === "yes" ? "Deducted" : "Paid"}
                  </span>
                </td>
                <td>
                  <div className="tbl-actions">
                    {canEditRole(u) && <button className="btn btn-ghost btn-xs" onClick={() => openEdit(u)}><Icon n="edit" size={12} />Edit</button>}
                    {isSA && u.id !== loggedIn.id && (
                      <>
                        <button className="btn btn-xs" style={{ background: u.active ? "var(--orange-lt)" : "var(--green-lt)", color: u.active ? "var(--orange)" : "var(--green)", border: u.active ? "1px solid var(--orange-lt2)" : "1px solid var(--green-lt2)" }} onClick={() => toggleActive(u)}>
                          {u.active ? "Deactivate" : "Activate"}
                        </button>
                        <button className="btn btn-danger btn-xs" onClick={() => del(u)}><Icon n="del" size={12} /></button>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal === "user" && (
        <div className="overlay" onClick={e => e.target === e.currentTarget && setModal(null)}>
          <div className="modal">
            <div className="modal-hdr">
              <div>
                <div className="modal-title">{editing ? "Edit User" : "Add New User"}</div>
                <div className="modal-sub">{editing ? `Editing ${editing.name}` : "Create a new employee account"}</div>
              </div>
              <button className="modal-close" onClick={() => setModal(null)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-grid">
                <div className="form-group full">
                  <label>Full Name *</label>
                  <input value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} placeholder="e.g. Ahmad Raza" />
                </div>
                {isSA && (
                  <div className="form-group full">
                    <label>Employee ID {editing ? "(editable — changing ID updates all references)" : "(auto-generated, editable)"}</label>
                    <input
                      value={form.id || ""}
                      onChange={e => setForm(p => ({ ...p, id: e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "") }))}
                      placeholder="e.g. EMP001"
                      style={{ fontFamily: "'JetBrains Mono',monospace", letterSpacing: ".06em" }}
                    />
                    <div className="form-hint">Letters and numbers only. Auto-generated if left blank.</div>
                  </div>
                )}
                <div className="form-group">
                  <label>Email Address *</label>
                  <input type="email" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} placeholder="user@civyx.com" />
                </div>
                <div className="form-group">
                  <label>Password {editing ? "(leave blank to keep)" : "*"}</label>
                  <div style={{ position: "relative" }}>
                    <input type={showPass ? "text" : "password"} value={form.password} onChange={e => setForm(p => ({ ...p, password: e.target.value }))} placeholder="••••••••" />
                    <button onClick={() => setShowPass(!showPass)} style={{ position: "absolute", right: ".6rem", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "var(--text3)" }}>
                      <Icon n="eye" size={15} />
                    </button>
                  </div>
                </div>
                <div className="form-group">
                  <label>Role</label>
                  <select value={form.role} onChange={e => setForm(p => ({ ...p, role: e.target.value }))} disabled={!isSA}>
                    {ROLES.map(r => <option key={r}>{r}</option>)}
                  </select>
                  {!isSA && <div className="form-hint">Only Super Admin can change roles</div>}
                </div>
                <div className="form-group">
                  <label>Designation</label>
                  <input value={form.designation || ""} onChange={e => setForm(p => ({ ...p, designation: e.target.value }))} placeholder="e.g. Site Engineer, Project Manager…" />
                  <div className="form-hint">Job title shown on profile and salary slip</div>
                </div>
                <div className="form-group">
                  <label>Department</label>
                  <select value={form.dept} onChange={e => setForm(p => ({ ...p, dept: e.target.value }))}>
                    {DEPTS.map(d => <option key={d}>{d}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Phone Number</label>
                  <input type="tel" value={form.phone || ""} onChange={e => setForm(p => ({ ...p, phone: e.target.value }))} placeholder="e.g. +91-9876543210" />
                  <div className="form-hint">Contact number for this employee</div>
                </div>
                <div className="form-group">
                  <label>Monthly Salary (PKR) *</label>
                  <input type="number" value={form.salary} onChange={e => setForm(p => ({ ...p, salary: e.target.value }))} placeholder="75000" />
                </div>
                <div className="form-group">
                  <label>Join Date</label>
                  <input type="date" value={form.joinDate} onChange={e => setForm(p => ({ ...p, joinDate: e.target.value }))} />
                </div>
                <div className="form-group" style={{ justifyContent: "flex-end" }}>
                  <label>Account Status</label>
                  <div className="toggle" onClick={() => setForm(p => ({ ...p, active: !p.active }))}>
                    <div className={`toggle-track ${form.active ? "on" : ""}`}><div className="toggle-thumb" /></div>
                    <span className="toggle-label">{form.active ? "Active" : "Inactive"}</span>
                  </div>
                </div>
                <div className="form-group full">
                  <label>Leave Deduction Setting</label>
                  <div style={{ display: "flex", gap: ".5rem", marginTop: ".2rem" }}>
                    {[
                      { val: "global", label: "Use Global Setting", desc: "Follow company-wide policy", color: "var(--blue)" },
                      { val: "no",     label: "Paid Leave",         desc: "Never deduct leave days",   color: "var(--green)" },
                      { val: "yes",    label: "Unpaid Leave",       desc: "Always deduct leave days",  color: "var(--red)" },
                    ].map(opt => {
                      const active = (form.deductLeaveOverride || "global") === opt.val;
                      return (
                        <div key={opt.val} onClick={() => setForm(p => ({ ...p, deductLeaveOverride: opt.val }))}
                          style={{
                            flex: 1, padding: ".6rem .8rem", borderRadius: 8, cursor: "pointer",
                            border: `2px solid ${active ? opt.color : "var(--border2)"}`,
                            background: active ? `${opt.color}15` : "var(--white)",
                            transition: "all .15s"
                          }}>
                          <div style={{ fontWeight: 700, fontSize: ".78rem", color: active ? opt.color : "var(--text2)" }}>{opt.label}</div>
                          <div style={{ fontSize: ".68rem", color: "var(--text3)", marginTop: ".15rem" }}>{opt.desc}</div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div className="form-actions">
                <button className="btn btn-ghost" onClick={() => setModal(null)}>Cancel</button>
                <button className="btn btn-primary" onClick={save}>{editing ? "Save Changes" : "Create User"}</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {deleteTarget && (
        <div className="overlay">
          <div className="modal" style={{ maxWidth: 400 }}>
            <div className="modal-hdr">
              <div><div className="modal-title">Delete User</div><div className="modal-sub">This action cannot be undone</div></div>
              <button className="modal-close" onClick={() => setDeleteTarget(null)}>✕</button>
            </div>
            <div className="modal-body">
              <p style={{ fontSize: ".88rem", color: "var(--text2)", marginBottom: "1.2rem" }}>
                Are you sure you want to delete <strong>{deleteTarget.name}</strong>? All their data will be permanently removed.
              </p>
              <div className="form-actions" style={{ marginTop: 0, paddingTop: 0, borderTop: "none" }}>
                <button className="btn btn-ghost" onClick={() => setDeleteTarget(null)}>Cancel</button>
                <button className="btn btn-danger" onClick={confirmDelete}>Delete User</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── ATTENDANCE PAGE ──────────────────────────────────────────────────────────
function AttendancePage({ users, attendance, loggedIn, settings }) {
  const now = new Date();
  const [selY, setSelY] = useState(now.getFullYear());
  const [selM, setSelM] = useState(now.getMonth() + 1);
  const [search, setSearch] = useState("");

  const activeUsers = users.filter(u => u.active && (loggedIn.role === "Employee" ? u.id === loggedIn.id : true));
  const filtered = activeUsers.filter(u => u.name.toLowerCase().includes(search.toLowerCase()) || u.dept.toLowerCase().includes(search.toLowerCase()));
  const days = daysInMonth(selY, selM);
  const cols = Array.from({ length: days }, (_, i) => i + 1);

  const workDays = settings?.workDays || [1,2,3,4,5,6];
  const getStatus = (uid, d) => {
    const dateStr = `${selY}-${String(selM).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
    const key = `${dateStr}_${uid}`;
    if (attendance[key]) return attendance[key];
    const u = users.find(x => x.id === uid);
    if (u?.joinDate && dateStr < u.joinDate) return "A";
    if (isOffDay(selY, selM, d, workDays)) return "WO";
    return "";
  };

  const getSummary = (uid) => {
    const s = { P: 0, A: 0, L: 0, H: 0, WO: 0 };
    cols.forEach(d => { const v = getStatus(uid, d); if (v) s[v] = (s[v] || 0) + 1; });
    return s;
  };

  const years = Array.from({ length: 5 }, (_, i) => now.getFullYear() - 2 + i);

  return (
    <div>
      <div className="page-hdr">
        <div>
          <div className="page-title">Attendance Register</div>
          <div className="page-sub">{monthLabel(selY, selM)}</div>
        </div>
        <div className="flex gap-2">
          <select value={selM} onChange={e => setSelM(Number(e.target.value))} style={{ width: 130 }}>
            {Array.from({ length: 12 }, (_, i) => <option key={i} value={i + 1}>{new Date(2000, i).toLocaleString("default", { month: "long" })}</option>)}
          </select>
          <select value={selY} onChange={e => setSelY(Number(e.target.value))} style={{ width: 90 }}>
            {years.map(y => <option key={y}>{y}</option>)}
          </select>
        </div>
      </div>

      <div className="search-bar">
        <div className="search-wrap">
          <span className="search-ic"><Icon n="search" size={14} /></span>
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search employee…" />
        </div>
        <div className="flex gap-2 text-xs text-muted items-center">
          {[["P","Present","badge-green"],["A","Absent","badge-red"],["L","Leave","badge-orange"],["H","Holiday","badge-purple"],["WO","Weekend","badge-gray"]].map(([k,l,b]) => (
            <span key={k} className={`badge ${b}`}>{k} = {l}</span>
          ))}
        </div>
      </div>

      <div className="rpt-wrap">
        <table className="rpt-tbl">
          <thead>
            <tr>
              <th>Employee / Date →</th>
              {cols.map(d => (
                <th key={d} style={isOffDay(selY, selM, d, workDays) ? { background: "#374151", color: "#9ca3af" } : {}}>
                  {d}<br /><span style={{ fontSize: ".55rem", opacity: .7 }}>{dayName(selY, selM, d)}</span>
                </th>
              ))}
              <th>P</th><th>A</th><th>L</th><th>H</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(u => {
              const sum = getSummary(u.id);
              return (
                <tr key={u.id}>
                  <td>
                    <div style={{ fontWeight: 600 }}>{u.name}</div>
                    <div style={{ fontSize: ".68rem", color: "var(--text3)" }}>{u.dept}</div>
                  </td>
                  {cols.map(d => {
                    const st = getStatus(u.id, d);
                    return (
                      <td key={d} className={`rc-${st || "empty"}`}>{st || "·"}</td>
                    );
                  })}
                  <td style={{ background: "var(--green-lt)", color: "var(--green)", fontWeight: 700 }}>{sum.P}</td>
                  <td style={{ background: "var(--red-lt)", color: "var(--red)", fontWeight: 700 }}>{sum.A}</td>
                  <td style={{ background: "var(--orange-lt)", color: "var(--orange)", fontWeight: 700 }}>{sum.L}</td>
                  <td style={{ background: "var(--purple-lt)", color: "var(--purple)", fontWeight: 700 }}>{sum.H}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ─── MARK ATTENDANCE ─────────────────────────────────────────────────────────
function MarkAttendance({ users, attendance, setAttendance, loggedIn, settings }) {
  const isSuperAdmin = loggedIn.role === "Super Admin";

  // Super Admin can pick any date; non-admins are locked to today
  const [selDate, setSelDate] = useState(today());
  const [deptFilter, setDeptFilter] = useState("All");
  const [search, setSearch] = useState("");

  const activeUsers = users.filter(u => u.active);

  // Super Admin sees everyone; others only see themselves
  const visibleUsers = isSuperAdmin
    ? activeUsers
    : activeUsers.filter(u => u.id === loggedIn.id);

  const filtered = visibleUsers.filter(u =>
    (isSuperAdmin ? (deptFilter === "All" || u.dept === deptFilter) : true) &&
    (u.name.toLowerCase().includes(search.toLowerCase()))
  );

  // Effective date for non-SA is always today (ignore selDate)
  const effectiveDate = isSuperAdmin ? selDate : today();

  const getKey = (uid) => `${effectiveDate}_${uid}`;
  const getMark = (uid) => {
    const k = getKey(uid);
    if (attendance[k]) return attendance[k];
    const u = users.find(x => x.id === uid);
    if (u?.joinDate && effectiveDate < u.joinDate) return "A";
    return null;
  };

  const mark = (uid, status) => {
    // Extra guard: non-SA cannot mark others or past/future dates
    if (!isSuperAdmin) {
      if (uid !== loggedIn.id) return showToast("You can only mark your own attendance", "err");
    }
    setAttendance(prev => ({ ...prev, [getKey(uid)]: status }));
  };

  const markAll = (status) => {
    // markAll only for Super Admin
    if (!isSuperAdmin) return;
    const updates = {};
    filtered.forEach(u => { updates[getKey(u.id)] = status; });
    setAttendance(prev => ({ ...prev, ...updates }));
    showToast(`All marked as ${status === "P" ? "Present" : status === "A" ? "Absent" : status}`, "ok");
  };

  const workDays = settings?.workDays || [1,2,3,4,5,6];
  const isWknd = isOffDay(...effectiveDate.split("-").map(Number), workDays);
  const markedCount = filtered.filter(u => getMark(u.id)).length;

  return (
    <div>
      <div className="page-hdr">
        <div>
          <div className="page-title">Mark Attendance</div>
          <div className="page-sub">{markedCount}/{filtered.length} {isSuperAdmin ? "employees" : "record"} marked for {effectiveDate}</div>
        </div>
        <div className="flex gap-2 items-center">
          {isSuperAdmin ? (
            <>
              <input type="date" value={selDate} onChange={e => setSelDate(e.target.value)} style={{ width: 160 }} />
              <button className="btn btn-success btn-sm" onClick={() => markAll("P")}> All Present</button>
              <button className="btn btn-danger btn-sm" onClick={() => markAll("A")}> All Absent</button>
            </>
          ) : (
            <div style={{ display: "flex", alignItems: "center", gap: ".5rem", background: "var(--blue-lt)", border: "1px solid var(--blue-lt2)", borderRadius: 6, padding: ".4rem .9rem", fontSize: ".8rem", color: "var(--blue2)", fontWeight: 600 }}>
              📅 Today: <strong style={{ marginLeft: ".3rem" }}>{today()}</strong>
            </div>
          )}
        </div>
      </div>

      {/* Restriction info for non Super Admin */}
      {!isSuperAdmin && (
        <div className="info-box mb-3">
          🔒 <strong>Restricted:</strong> You can only mark <strong>your own</strong> attendance and only for <strong>today</strong>. Contact a Super Admin for changes to other dates or employees.
        </div>
      )}

      {isWknd && <div className="warning-box mb-3">⚠️ {isSuperAdmin ? "Selected date" : "Today"} is a weekend. You can still mark attendance if required.</div>}

      {isSuperAdmin && (
        <div className="search-bar">
          <div className="search-wrap">
            <span className="search-ic"><Icon n="search" size={14} /></span>
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search employee…" />
          </div>
          <select value={deptFilter} onChange={e => setDeptFilter(e.target.value)} style={{ width: 160 }}>
            <option value="All">All Departments</option>
            {DEPTS.map(d => <option key={d}>{d}</option>)}
          </select>
        </div>
      )}

      <div className="att-grid">
        {filtered.map(u => {
          const m = getMark(u.id);
          return (
            <div key={u.id} className={`att-emp-card${m ? ` marked-${m}` : ""}`}>
              <div className="flex items-center gap-2">
                <div className="avatar av-md" style={{ background: avatarColor(u.id) }}>{initials(u.name)}</div>
                <div>
                  <div style={{ fontWeight: 600, fontSize: ".88rem" }}>{u.name}</div>
                  <div className="text-xs text-muted">{u.dept}</div>
                  {m && <span className={`badge ${m === "P" ? "badge-green" : m === "A" ? "badge-red" : m === "L" ? "badge-orange" : "badge-purple"}`} style={{ marginTop: ".2rem" }}>
                    {m === "P" ? "Present" : m === "A" ? "Absent" : m === "L" ? "On Leave" : "Holiday"}
                  </span>}
                </div>
              </div>
              <div className="att-btns">
                {[["P","Present"],["A","Absent"],["L","Leave"],["H","Holiday"]].map(([k, l]) => (
                  <button key={k} className={`att-btn ${k}${m === k ? " act" : ""}`} onClick={() => mark(u.id, k)}>{l}</button>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ─── LEAVE PAGE ───────────────────────────────────────────────────────────────
function LeavePage({ users, leaves, setLeaves, loggedIn, can, attendance, setAttendance }) {
  const [modal, setModal] = useState(null);
  const [tab, setTab] = useState("all");
  const [form, setForm] = useState({ userId: loggedIn.id, type: "Annual", from: today(), to: today(), reason: "" });
  const [deleteTarget, setDeleteTarget] = useState(null); // step 1 target
  const [deleteConfirm, setDeleteConfirm] = useState(false); // step 2 flag

  const isHR = can("salary");
  const isSA = loggedIn.role === "Super Admin";

  const filtered = leaves.filter(l => {
    if (!isHR) return l.userId === loggedIn.id;
    if (tab === "pending")  return l.status === "Pending";
    if (tab === "approved") return l.status === "Approved";
    if (tab === "rejected") return l.status === "Rejected";
    return true;
  });

  const apply = () => {
    if (!form.reason) return showToast("Please provide a reason", "err");
    if (form.from > form.to) return showToast("Invalid date range", "err");
    setLeaves(prev => [...prev, { ...form, id: uid(), status: "Pending", appliedOn: today() }]);
    showToast("Leave application submitted", "ok");
    setModal(null);
    setForm({ userId: loggedIn.id, type: "Annual", from: today(), to: today(), reason: "" });
  };

  const decide = (id, status) => {
    const leave = leaves.find(l => l.id === id);
    setLeaves(prev => prev.map(l => l.id === id ? { ...l, status } : l));
    showToast(`Leave ${status}`, status === "Approved" ? "ok" : "err");
    // Auto-mark attendance as "L" for each day in the approved leave range
    if (status === "Approved" && leave) {
      const start = new Date(leave.from);
      const end = new Date(leave.to);
      const updates = {};
      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}_${leave.userId}`;
        // Only mark if not already marked (don't overwrite manual entries)
        if (!attendance[key]) updates[key] = "L";
      }
      if (Object.keys(updates).length > 0) {
        setAttendance(prev => ({ ...prev, ...updates }));
      }
    }
  };

  const withdraw = (id) => {
    setLeaves(prev => prev.filter(l => l.id !== id));
    showToast("Application withdrawn");
  };

  // Step 1: open confirmation modal
  const requestDelete = (l) => {
    setDeleteTarget(l);
    setDeleteConfirm(false);
  };
  // Step 2: final delete
  const confirmDelete = () => {
    setLeaves(prev => prev.filter(l => l.id !== deleteTarget.id));
    showToast("Leave record permanently deleted", "ok");
    setDeleteTarget(null);
    setDeleteConfirm(false);
  };
  const cancelDelete = () => {
    setDeleteTarget(null);
    setDeleteConfirm(false);
  };

  const userName = (id) => users.find(u => u.id === id)?.name || "Unknown";
  const userDept = (id) => users.find(u => u.id === id)?.dept || "";

  const tabs = isHR
    ? [["all","All"],["pending","Pending"],["approved","Approved"],["rejected","Rejected"]]
    : [["all","My Leaves"]];

  return (
    <div>
      <div className="page-hdr">
        <div>
          <div className="page-title">Leave Management</div>
          <div className="page-sub">{filtered.length} applications</div>
        </div>
        <button className="btn btn-primary" onClick={() => setModal("apply")}><Icon n="add" size={15} />Apply for Leave</button>
      </div>

      <div className="tabs">
        {tabs.map(([k, l]) => <div key={k} className={`tab${tab === k ? " active" : ""}`} onClick={() => setTab(k)}>{l}</div>)}
      </div>

      {filtered.length === 0 ? (
        <div className="empty"><div className="empty-ic">📅</div><div className="empty-txt">No leave applications found</div></div>
      ) : (
        <div className="flex flex-col gap-2">
          {filtered.map(l => {
            const isResolved = l.status === "Approved" || l.status === "Rejected";
            return (
              <div className="leave-card" key={l.id}>
                <div className="flex items-center gap-2" style={{ flex: 1 }}>
                  <div className="avatar av-md" style={{ background: avatarColor(l.userId) }}>{initials(userName(l.userId))}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600, fontSize: ".88rem" }}>{userName(l.userId)}</div>
                    <div className="text-xs text-muted">{userDept(l.userId)} · {l.type} Leave · {l.from} to {l.to} · Applied: {l.appliedOn}</div>
                    <div className="text-xs" style={{ marginTop: ".2rem", color: "var(--text2)" }}>{l.reason}</div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <span className={`badge ${l.status === "Approved" ? "badge-green" : l.status === "Rejected" ? "badge-red" : "badge-orange"}`}>{l.status}</span>
                  {isHR && l.userId !== loggedIn.id && l.status === "Pending" && (
                    <>
                      <button className="btn btn-success btn-xs" onClick={() => decide(l.id, "Approved")}>Approve</button>
                      <button className="btn btn-danger btn-xs" onClick={() => decide(l.id, "Rejected")}>Reject</button>
                    </>
                  )}
                  {(l.userId === loggedIn.id && l.status === "Pending") && (
                    <button className="btn btn-ghost btn-xs" onClick={() => withdraw(l.id)}>Withdraw</button>
                  )}
                  {isSA && isResolved && (
                    <button className="btn btn-danger btn-xs" onClick={() => requestDelete(l)} title="Delete record">
                      <Icon n="del" size={12} />
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* 2-step delete confirmation modal */}
      {deleteTarget && (
        <div className="overlay">
          <div className="modal" style={{ maxWidth: 420 }}>
            <div className="modal-hdr">
              <div>
                <div className="modal-title">Delete Leave Record</div>
                <div className="modal-sub">
                  {!deleteConfirm ? "Step 1 of 2 — Review" : "Step 2 of 2 — Final Confirmation"}
                </div>
              </div>
              <button className="modal-close" onClick={cancelDelete}>✕</button>
            </div>
            <div className="modal-body">
              {/* Record summary */}
              <div style={{ background: "var(--bg3)", border: "1px solid var(--border)", borderRadius: 8, padding: "1rem", marginBottom: "1rem" }}>
                <div className="flex items-center gap-2" style={{ marginBottom: ".6rem" }}>
                  <div className="avatar av-sm" style={{ background: avatarColor(deleteTarget.userId) }}>{initials(userName(deleteTarget.userId))}</div>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: ".88rem" }}>{userName(deleteTarget.userId)}</div>
                    <div className="text-xs text-muted">{userDept(deleteTarget.userId)}</div>
                  </div>
                  <span className={`badge ${deleteTarget.status === "Approved" ? "badge-green" : "badge-red"}`} style={{ marginLeft: "auto" }}>{deleteTarget.status}</span>
                </div>
                <div className="text-xs text-muted">{deleteTarget.type} Leave · {deleteTarget.from} → {deleteTarget.to}</div>
                <div className="text-xs" style={{ color: "var(--text2)", marginTop: ".3rem" }}>{deleteTarget.reason}</div>
              </div>

              {!deleteConfirm ? (
                /* Step 1 */
                <>
                  <div className="warning-box" style={{ marginBottom: "1rem" }}>
                    ⚠️ You are about to permanently delete this leave record. This action <strong>cannot be undone</strong>. Please confirm you want to proceed.
                  </div>
                  <div className="form-actions" style={{ marginTop: 0, paddingTop: 0, borderTop: "none" }}>
                    <button className="btn btn-ghost" onClick={cancelDelete}>Cancel</button>
                    <button className="btn btn-warning" onClick={() => setDeleteConfirm(true)}>Yes, Proceed to Delete</button>
                  </div>
                </>
              ) : (
                /* Step 2 */
                <>
                  <div style={{ background: "var(--red-lt)", border: "1px solid var(--red-lt2)", borderRadius: 6, padding: ".8rem 1rem", marginBottom: "1rem" }}>
                    <div style={{ fontWeight: 700, color: "var(--red)", fontSize: ".85rem", marginBottom: ".3rem" }}>🚨 Final Warning</div>
                    <div style={{ fontSize: ".8rem", color: "var(--red)" }}>
                      This will <strong>permanently delete</strong> the leave record for <strong>{userName(deleteTarget.userId)}</strong>. There is no way to recover it.
                    </div>
                  </div>
                  <div className="form-actions" style={{ marginTop: 0, paddingTop: 0, borderTop: "none" }}>
                    <button className="btn btn-ghost" onClick={cancelDelete}>Cancel</button>
                    <button className="btn btn-danger" onClick={confirmDelete}><Icon n="del" size={14} />Delete Permanently</button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {modal === "apply" && (
        <div className="overlay" onClick={e => e.target === e.currentTarget && setModal(null)}>
          <div className="modal">
            <div className="modal-hdr">
              <div className="modal-title">Apply for Leave</div>
              <button className="modal-close" onClick={() => setModal(null)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-grid">
                {isSA && (
                  <div className="form-group full">
                    <label>Apply Leave For</label>
                    <select value={form.userId} onChange={e => setForm(p => ({ ...p, userId: e.target.value }))}>
                      {users.filter(u => u.active).map(u => <option key={u.id} value={u.id}>{u.name} — {u.dept}</option>)}
                    </select>
                  </div>
                )}
                <div className="form-group">
                  <label>Leave Type</label>
                  <select value={form.type} onChange={e => setForm(p => ({ ...p, type: e.target.value }))}>
                    {["Annual","Sick","Casual","Maternity","Paternity","Unpaid"].map(t => <option key={t}>{t}</option>)}
                  </select>
                </div>
                <div className="form-group" />
                <div className="form-group">
                  <label>From Date</label>
                  <input type="date" value={form.from} onChange={e => setForm(p => ({ ...p, from: e.target.value }))} />
                </div>
                <div className="form-group">
                  <label>To Date</label>
                  <input type="date" value={form.to} onChange={e => setForm(p => ({ ...p, to: e.target.value }))} />
                </div>
                <div className="form-group full">
                  <label>Reason *</label>
                  <textarea value={form.reason} onChange={e => setForm(p => ({ ...p, reason: e.target.value }))} placeholder="Please describe the reason for leave…" />
                </div>
              </div>
              <div className="form-actions">
                <button className="btn btn-ghost" onClick={() => setModal(null)}>Cancel</button>
                <button className="btn btn-primary" onClick={apply}>Submit Application</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── SALARY ───────────────────────────────────────────────────────────────────
function SalaryPage({ users, attendance, settings, loggedIn, can, printRequests, setPrintRequests, deductions, setDeductions, incentives, setIncentives }) {
  const now = new Date();
  const [selY, setSelY] = useState(now.getFullYear());
  const [selM, setSelM] = useState(now.getMonth() + 1);
  const [selUser, setSelUser] = useState(null);
  const [reqModal, setReqModal] = useState(null); // { user, year, month } — request confirmation
  const [deductModal, setDeductModal] = useState(null); // { u } — manage deductions for employee
  const [deductForm, setDeductForm] = useState({ label: "Advance", amount: "", note: "" });
  const [incentiveModal, setIncentiveModal] = useState(null); // { u } — manage incentives for employee
  const [incentiveForm, setIncentiveForm] = useState({ label: "Performance", amount: "", note: "" });

  // Role checks
  const isSA     = loggedIn.role === "Super Admin";
  const isHRPlus = can("users"); // SA + HR Manager can see all and approve
  // Self-only: employee can only see their own
  const isSelfOnly = !isHRPlus;

  const allActive = users.filter(u => u.active);
  const activeUsers = isSelfOnly ? allActive.filter(u => u.id === loggedIn.id) : allActive;
  const years = Array.from({ length: 5 }, (_, i) => now.getFullYear() - 2 + i);

  const workDays = settings?.workDays || [1,2,3,4,5,6];
  const calcSalary = (u) => {
    const days = daysInMonth(selY, selM);
    const workingDays = Array.from({ length: days }, (_, i) => i + 1).filter(d => !isOffDay(selY, selM, d, workDays)).length;
    const perDay = u.salary / (workingDays || 1);
    const monthEndStr = `${selY}-${String(selM).padStart(2, "0")}-${String(days).padStart(2, "0")}`;

    // If selected month is completely before joining date, net salary is 0
    if (u.joinDate && monthEndStr < u.joinDate) {
      return { P: 0, A: days, L: 0, H: 0, WO: 0, workingDays, perDay, attDeductions: u.salary, extraDeductions: [], extraTotal: 0, extraIncentives: [], extraIncentivesTotal: 0, deductions: u.salary, netSalary: 0, gross: u.salary, grossTotal: u.salary, notJoined: true };
    }

    let P = 0, A = 0, L = 0, H = 0, WO = 0;
    Array.from({ length: days }, (_, i) => i + 1).forEach(d => {
      const dateStr = `${selY}-${String(selM).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
      const key = `${dateStr}_${u.id}`;
      let v = attendance[key];
      if (!v && u.joinDate && dateStr < u.joinDate) v = "A";
      if (v === "P") P++;
      else if (v === "A") A++;
      else if (v === "L") L++;
      else if (v === "H") H++;
      else if (isOffDay(selY, selM, d, workDays)) WO++;
    });
    let attDeductions = 0;
    if (A > 0) attDeductions += A * perDay;
    const override = u.deductLeaveOverride || "global";
    const shouldDeductLeave = override === "yes" ? true : override === "no" ? false : settings.deductLeave;
    if (shouldDeductLeave && L > 0) attDeductions += L * perDay;
    // Extra deductions (advance, fine, loan, etc.) for this employee/month
    const extraDeductions = (deductions || []).filter(
      d => d.userId === u.id && d.year === selY && d.month === selM
    );
    const extraTotal = extraDeductions.reduce((sum, d) => sum + Number(d.amount || 0), 0);
    const totalDeductions = attDeductions + extraTotal;
    // Extra incentives (performance, overtime, bonus, etc.) for this employee/month
    const extraIncentives = (incentives || []).filter(
      i => i.userId === u.id && i.year === selY && i.month === selM
    );
    const extraIncentivesTotal = extraIncentives.reduce((sum, i) => sum + Number(i.amount || 0), 0);
    const grossTotal = u.salary + extraIncentivesTotal;
    const netSalary = Math.max(0, grossTotal - totalDeductions);
    return { P, A, L, H, WO, workingDays, perDay, attDeductions, extraDeductions, extraTotal, extraIncentives, extraIncentivesTotal, deductions: totalDeductions, netSalary, gross: u.salary, grossTotal, notJoined: false };
  };

  // SA/HR can always print directly
  const printSlip = (u) => {
    const s = calcSalary(u);
    const w = window.open("", "_blank");
    w.document.write(generateSlipHTML(u, s, selY, selM, settings));
    w.document.close();
    w.focus();
    setTimeout(() => w.print(), 500);
  };

  // ── Print Request helpers ──
  // Find a request for a specific user+year+month
  const getRequest = (userId, year, month) =>
    printRequests.find(r => r.userId === userId && r.year === year && r.month === month);

  // Employee submits a print request
  const submitPrintRequest = (u) => {
    const existing = getRequest(u.id, selY, selM);
    if (existing) {
      if (existing.status === "Pending") return showToast("A request is already pending for this month", "err");
      if (existing.status === "Approved") return showToast("Print already approved — use Print Now", "err");
      // Rejected or Used → allow re-request
    }
    const newReq = {
      id: uid(),
      userId: u.id,
      userName: u.name,
      year: selY,
      month: selM,
      status: "Pending",
      requestedOn: today(),
      decidedOn: null,
      decidedBy: null,
    };
    // Single state update: remove any old request + add new one atomically
    setPrintRequests(prev => [
      ...prev.filter(r => !(r.userId === u.id && r.year === selY && r.month === selM)),
      newReq,
    ]);
    showToast("Print permission requested — awaiting Super Admin approval", "ok");
    setReqModal(null);
  };

  // SA/HR: approve or reject
  const decideRequest = (reqId, decision) => {
    setPrintRequests(prev => prev.map(r =>
      r.id === reqId ? { ...r, status: decision, decidedOn: today(), decidedBy: loggedIn.id } : r
    ));
    showToast(`Request ${decision}`, decision === "Approved" ? "ok" : "err");
  };

  // Employee prints an approved slip — one-time only
  // We mark it "Used" FIRST (persisted to Firestore) BEFORE opening the print
  // window so rapid double-clicks cannot trigger a second print while the first
  // is still rendering.
  const printApprovedSlip = async (u, reqId) => {
    // 1. Immediately flip status to "Used" and persist
    setPrintRequests(prev => prev.map(r =>
      r.id === reqId ? { ...r, status: "Used", usedOn: today() } : r
    ));
    // 2. Small tick to let state settle, then open print window
    await new Promise(res => setTimeout(res, 80));
    const s = calcSalary(u);
    const w = window.open("", "_blank");
    if (!w) {
      showToast("Pop-up blocked — please allow pop-ups and try again", "err");
      return;
    }
    w.document.write(generateSlipHTML(u, s, selY, selM, settings));
    w.document.close();
    w.focus();
    setTimeout(() => w.print(), 500);
  };

  // Pending print requests (for SA/HR panel)
  const pendingRequests = printRequests.filter(r => r.status === "Pending");

  // Deduction management helpers (SA/HR only)
  const getExtraDeductions = (u) =>
    (deductions || []).filter(d => d.userId === u.id && d.year === selY && d.month === selM);

  const addDeduction = () => {
    if (!deductModal) return;
    if (!deductForm.label.trim() || !deductForm.amount || Number(deductForm.amount) <= 0)
      return showToast("Enter a valid label and positive amount", "err");
    const entry = {
      id: uid(),
      userId: deductModal.u.id,
      userName: deductModal.u.name,
      year: selY,
      month: selM,
      label: deductForm.label.trim(),
      amount: Number(deductForm.amount),
      note: deductForm.note.trim(),
      addedBy: loggedIn.id,
      addedOn: today(),
    };
    setDeductions(prev => [...prev, entry]);
    setDeductForm({ label: "Advance", amount: "", note: "" });
    showToast("Deduction added", "ok");
  };

  const removeDeduction = (id) => {
    setDeductions(prev => prev.filter(d => d.id !== id));
    showToast("Deduction removed", "ok");
  };

  // Incentive management helpers (SA/HR only)
  const getExtraIncentives = (u) =>
    (incentives || []).filter(i => i.userId === u.id && i.year === selY && i.month === selM);

  const addIncentive = () => {
    if (!incentiveModal) return;
    if (!incentiveForm.label.trim() || !incentiveForm.amount || Number(incentiveForm.amount) <= 0)
      return showToast("Enter a valid label and positive amount", "err");
    const entry = {
      id: uid(),
      userId: incentiveModal.u.id,
      userName: incentiveModal.u.name,
      year: selY,
      month: selM,
      label: incentiveForm.label.trim(),
      amount: Number(incentiveForm.amount),
      note: incentiveForm.note.trim(),
      addedBy: loggedIn.id,
      addedOn: today(),
    };
    setIncentives(prev => [...prev, entry]);
    setIncentiveForm({ label: "Performance", amount: "", note: "" });
    showToast("Incentive added", "ok");
  };

  const removeIncentive = (id) => {
    setIncentives(prev => prev.filter(i => i.id !== id));
    showToast("Incentive removed", "ok");
  };

  // Action cell for a given user row (in table)
  const renderRowActions = (u) => {
    if (isHRPlus) {
      const extraCount = getExtraDeductions(u).length;
      const extraIncCount = getExtraIncentives(u).length;
      // SA / HR: always print directly
      return (
        <div className="tbl-actions">
          <button className="btn btn-ghost btn-xs" onClick={() => setSelUser(u)}><Icon n="eye" size={12} />View</button>
          <button className="btn btn-success btn-xs" style={{ position: "relative" }} onClick={() => { setIncentiveModal({ u }); setIncentiveForm({ label: "Performance", amount: "", note: "" }); }}>
            🎁 Incentive{extraIncCount > 0 && <span style={{ marginLeft: 4, background: "var(--green)", color: "#fff", borderRadius: "50%", padding: "0 5px", fontSize: ".6rem", fontWeight: 700 }}>{extraIncCount}</span>}
          </button>
          <button className="btn btn-gold btn-xs" style={{ position: "relative" }} onClick={() => { setDeductModal({ u }); setDeductForm({ label: "Advance", amount: "", note: "" }); }}>
            ✂ Deductions{extraCount > 0 && <span style={{ marginLeft: 4, background: "var(--red)", color: "#fff", borderRadius: "50%", padding: "0 5px", fontSize: ".6rem", fontWeight: 700 }}>{extraCount}</span>}
          </button>
          <button className="btn btn-primary btn-xs" onClick={() => printSlip(u)}><Icon n="print" size={12} />Slip</button>
        </div>
      );
    }
    // Employee
    const req = getRequest(u.id, selY, selM);
    return (
      <div className="tbl-actions">
        {!req && (
          <button className="btn btn-gold btn-xs" onClick={() => setReqModal({ u, year: selY, month: selM })}>
            <Icon n="print" size={12} />Request Print
          </button>
        )}
        {req && req.status === "Pending" && (
          <span className="badge badge-orange" style={{ fontSize: ".68rem" }}>⏳ Pending</span>
        )}
        {req && req.status === "Approved" && (
          <button className="btn btn-success btn-xs" onClick={() => printApprovedSlip(u, req.id)}>
            <Icon n="print" size={12} />Print Now
          </button>
        )}
        {req && req.status === "Rejected" && (
          <button className="btn btn-ghost btn-xs" onClick={() => setReqModal({ u, year: selY, month: selM })} title="Re-request">
            ❌ Re-request
          </button>
        )}
        {req && req.status === "Used" && (
          <div className="tbl-actions" style={{gap:'.25rem'}}>
            <span className="badge badge-gray" style={{ fontSize: ".68rem" }}>✔ Printed</span>
            <button className="btn btn-gold btn-xs" onClick={() => setReqModal({ u, year: selY, month: selM })} title="Request again">
              <Icon n="print" size={12} />Re-request
            </button>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={isSelfOnly ? "salary-protected" : ""}>
      <div className="page-hdr">
        <div>
          <div className="page-title">{isSelfOnly ? "My Salary" : "Salary Management"}</div>
          <div className="page-sub">{monthLabel(selY, selM)}{!isSelfOnly && ` · ${allActive.length} employees`}</div>
        </div>
        <div className="flex gap-2">
          <select value={selM} onChange={e => setSelM(Number(e.target.value))} style={{ width: 130 }}>
            {Array.from({ length: 12 }, (_, i) => <option key={i} value={i + 1}>{new Date(2000, i).toLocaleString("default", { month: "long" })}</option>)}
          </select>
          <select value={selY} onChange={e => setSelY(Number(e.target.value))} style={{ width: 90 }}>
            {years.map(y => <option key={y}>{y}</option>)}
          </select>
        </div>
      </div>

      {isSelfOnly && (
        <div className="info-box" style={{ marginBottom: "1rem" }}>
          🔒 You have view-only access to your salary details. To print your salary slip, click <strong>"Request Print"</strong> and wait for Super Admin approval.
        </div>
      )}

      {/* ── Print Requests Panel (SA / HR only) ── */}
      {isHRPlus && pendingRequests.length > 0 && (
        <div className="print-req-panel">
          <div className="print-req-header">
            <div className="print-req-header-title">
              <Icon n="print" size={16} col="#fff" />
              Pending Print Requests
              <span className="print-req-badge">{pendingRequests.length}</span>
            </div>
            <div style={{ color: "rgba(255,255,255,.5)", fontSize: ".73rem" }}>Review and approve employee salary slip print requests</div>
          </div>
          {pendingRequests.map(req => {
            const reqUser = users.find(u => u.id === req.userId);
            const mLabel = monthLabel(req.year, req.month);
            return (
              <div key={req.id} className="print-req-row">
                <div className="avatar av-sm" style={{ background: reqUser ? avatarColor(reqUser.id) : "#888" }}>
                  {reqUser ? initials(reqUser.name) : "?"}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: ".88rem" }}>{req.userName}</div>
                  <div className="text-xs text-muted">Requesting print for <strong>{mLabel}</strong> · Applied: {req.requestedOn}</div>
                </div>
                <div className="flex gap-1">
                  <button className="btn btn-success btn-xs" onClick={() => decideRequest(req.id, "Approved")}>
                    ✅ Approve
                  </button>
                  <button className="btn btn-danger btn-xs" onClick={() => decideRequest(req.id, "Rejected")}>
                    ❌ Reject
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <div className="tbl-wrap mb-3">
        <table>
          <thead>
            <tr>
              <th>Employee</th>
              <th>Dept</th>
              {!isSelfOnly && <th>Gross Salary</th>}
              <th>Present</th>
              <th>Absent</th>
              <th>Leave</th>
              {!isSelfOnly && <th>Incentives</th>}
              {!isSelfOnly && <th>Deductions</th>}
              {!isSelfOnly && <th>Net Salary</th>}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {activeUsers.map(u => {
              const s = calcSalary(u);
              return (
                <tr key={u.id}>
                  <td>
                    <div className="flex items-center gap-2">
                      <div className="avatar av-sm" style={{ background: avatarColor(u.id) }}>{initials(u.name)}</div>
                      <div style={{ fontWeight: 600 }}>{u.name}</div>
                    </div>
                  </td>
                  <td>{u.dept}</td>
                  {!isSelfOnly && <td className="font-mono">{fmtCurrency(s.gross)}</td>}
                  <td><span className="badge badge-green">{s.P}</span></td>
                  <td><span className="badge badge-red">{s.A}</span></td>
                  <td><span className="badge badge-orange">{s.L}</span></td>
                  {!isSelfOnly && (
                    <td className="font-mono" style={{ color: s.extraIncentivesTotal > 0 ? "var(--green)" : "var(--text3)" }}>
                      {s.extraIncentivesTotal > 0 ? `+ ${fmtCurrency(s.extraIncentivesTotal)}` : "—"}
                    </td>
                  )}
                  {!isSelfOnly && (
                    <td className="font-mono" style={{ color: s.deductions > 0 ? "var(--red)" : "var(--green)" }}>
                      {s.deductions > 0 ? `- ${fmtCurrency(s.deductions)}` : "—"}
                    </td>
                  )}
                  {!isSelfOnly && <td className="font-mono font-bold">{fmtCurrency(s.netSalary)}</td>}
                  <td>{renderRowActions(u)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* ── Salary Detail Modal ── */}
      {selUser && (() => {
        const s = calcSalary(selUser);
        const req = getRequest(selUser.id, selY, selM);
        return (
          <div className="overlay" onClick={e => e.target === e.currentTarget && setSelUser(null)}>
            <div className="modal">
              <div className="modal-hdr">
                <div>
                  <div className="modal-title">Salary Detail — {selUser.name}</div>
                  <div className="modal-sub">{monthLabel(selY, selM)}</div>
                </div>
                <button className="modal-close" onClick={() => setSelUser(null)}>✕</button>
              </div>
              <div className="modal-body">
                <div className="salary-card">
                  <div className="sal-hdr">
                    <div>
                      <div className="sal-emp-name">{selUser.name}</div>
                      <div className="sal-month">{selUser.dept} · {selUser.role} · {monthLabel(selY, selM)}</div>
                    </div>
                    <div>
                      <div className="sal-gross">{isSelfOnly ? "***" : fmtCurrency(s.netSalary)}</div>
                      <div style={{ color: "rgba(255,255,255,.5)", fontSize: ".72rem", textAlign: "right" }}>Net Payable</div>
                    </div>
                  </div>
                  <div className="sal-body">
                    <div className="sal-row"><span>Gross Base Salary</span><span className="font-mono">{isSelfOnly ? "***" : fmtCurrency(s.gross)}</span></div>
                    {s.extraIncentives && s.extraIncentives.length > 0 && (
                      <>
                        {s.extraIncentives.map(ei => (
                          <div key={ei.id} className="sal-row">
                            <span style={{ color: "var(--green)", fontWeight: 600 }}>🎁 {ei.label}{ei.note ? ` (${ei.note})` : ""}</span>
                            <span className="font-mono" style={{ color: "var(--green)", fontWeight: 600 }}>{isSelfOnly ? "***" : `+ ${fmtCurrency(ei.amount)}`}</span>
                          </div>
                        ))}
                      </>
                    )}
                    <div className="sal-row"><span>Working Days in Month</span><span>{s.workingDays}</span></div>
                    <div className="sal-row"><span>Per Day Rate</span><span className="font-mono">{isSelfOnly ? "***" : fmtCurrency(Math.round(s.perDay))}</span></div>
                    <div className="sal-row"><span>Days Present</span><span className="badge badge-green">{s.P}</span></div>
                    <div className="sal-row"><span>Days Absent</span><span className="badge badge-red">{s.A}</span></div>
                    <div className="sal-row"><span>Days on Leave</span><span className="badge badge-orange">{s.L}</span></div>
                    <div className="sal-row"><span>Holidays / Weekend</span><span>{s.H + s.WO}</span></div>
                    {s.A > 0 && <div className="sal-row"><span className="sal-deduct">Absent Deduction ({s.A} days)</span><span className="sal-deduct font-mono">{isSelfOnly ? "***" : `- ${fmtCurrency(Math.round(s.A * s.perDay))}`}</span></div>}
                    {(() => {
                      const override = selUser.deductLeaveOverride || "global";
                      const shouldDeduct = override === "yes" ? true : override === "no" ? false : settings.deductLeave;
                      if (s.L > 0 && shouldDeduct) return <div className="sal-row"><span className="sal-deduct">Leave Deduction ({s.L} days)</span><span className="sal-deduct font-mono">{isSelfOnly ? "***" : `- ${fmtCurrency(Math.round(s.L * s.perDay))}`}</span></div>;
                      if (s.L > 0 && !shouldDeduct) return <div className="sal-row"><span style={{ color: "var(--green)" }}>Leave ({s.L} days — Paid)</span><span className="badge badge-green">No Deduction</span></div>;
                      return null;
                    })()}
                    {s.extraDeductions && s.extraDeductions.length > 0 && (
                      <>
                        {s.extraDeductions.map(ed => (
                          <div key={ed.id} className="sal-row">
                            <span className="sal-deduct">✂ {ed.label}{ed.note ? ` (${ed.note})` : ""}</span>
                            <span className="sal-deduct font-mono">{isSelfOnly ? "***" : `- ${fmtCurrency(ed.amount)}`}</span>
                          </div>
                        ))}
                      </>
                    )}
                    <div className="sal-row"><span>Net Payable Salary</span><span className="font-mono" style={{ fontSize: "1.1rem", color: "var(--green)" }}>{isSelfOnly ? "***" : fmtCurrency(s.netSalary)}</span></div>
                  </div>
                </div>

                <div className="form-actions">
                  <button className="btn btn-ghost" onClick={() => setSelUser(null)}>Close</button>
                  {isHRPlus && (
                    <button className="btn btn-primary" onClick={() => printSlip(selUser)}>
                      <Icon n="print" size={14} />Print Salary Slip
                    </button>
                  )}
                  {!isHRPlus && !req && (
                    <button className="btn btn-gold" onClick={() => { setSelUser(null); setReqModal({ u: selUser, year: selY, month: selM }); }}>
                      <Icon n="print" size={14} />Request Print Permission
                    </button>
                  )}
                  {!isHRPlus && req && req.status === "Pending" && (
                    <span className="badge badge-orange" style={{ padding: ".4rem .9rem", fontSize: ".78rem" }}>⏳ Approval Pending</span>
                  )}
                  {!isHRPlus && req && req.status === "Approved" && (
                    <button className="btn btn-success" onClick={() => { printApprovedSlip(selUser, req.id); setSelUser(null); }}>
                      <Icon n="print" size={14} />Print Now (Approved)
                    </button>
                  )}
                  {!isHRPlus && req && req.status === "Rejected" && (
                    <button className="btn btn-ghost" onClick={() => { setSelUser(null); setReqModal({ u: selUser, year: selY, month: selM }); }}>
                      <Icon n="print" size={14} />Re-request Print
                    </button>
                  )}
                  {!isHRPlus && req && req.status === "Used" && (
                    <div className="flex gap-2 items-center">
                      <span className="badge badge-gray" style={{ padding: ".4rem .9rem", fontSize: ".78rem" }}>✔ Slip Already Printed</span>
                      <button className="btn btn-gold" onClick={() => { setSelUser(null); setReqModal({ u: selUser, year: selY, month: selM }); }}>
                        <Icon n="print" size={14} />Re-request Print
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── Request Print Permission Modal ── */}
      {reqModal && (
        <div className="overlay" onClick={e => e.target === e.currentTarget && setReqModal(null)}>
          <div className="modal" style={{ maxWidth: 440 }}>
            <div className="modal-hdr">
              <div>
                <div className="modal-title">Request Print Permission</div>
                <div className="modal-sub">Salary Slip · {monthLabel(reqModal.year, reqModal.month)}</div>
              </div>
              <button className="modal-close" onClick={() => setReqModal(null)}>✕</button>
            </div>
            <div className="modal-body">
              <div style={{ background: "var(--bg3)", border: "1px solid var(--border)", borderRadius: 8, padding: "1rem", marginBottom: "1rem" }}>
                <div className="flex items-center gap-2" style={{ marginBottom: ".5rem" }}>
                  <div className="avatar av-sm" style={{ background: avatarColor(reqModal.u.id) }}>{initials(reqModal.u.name)}</div>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: ".88rem" }}>{reqModal.u.name}</div>
                    <div className="text-xs text-muted">{reqModal.u.dept} · {reqModal.u.role}</div>
                  </div>
                </div>
                <div className="text-xs text-muted">Month: <strong>{monthLabel(reqModal.year, reqModal.month)}</strong></div>
              </div>
              <div className="info-box" style={{ marginBottom: "1rem" }}>
                📋 Your request will be sent to the Super Admin for approval. Once approved, you will be able to print your salary slip for <strong>{monthLabel(reqModal.year, reqModal.month)}</strong> once. This action is logged.
              </div>
              {getRequest(reqModal.u.id, reqModal.year, reqModal.month)?.status === "Rejected" && (
                <div className="warning-box" style={{ marginBottom: "1rem" }}>
                  ⚠️ Your previous request for this month was rejected. Submitting again will create a new request.
                </div>
              )}
              {getRequest(reqModal.u.id, reqModal.year, reqModal.month)?.status === "Used" && (
                <div className="warning-box" style={{ marginBottom: "1rem" }}>
                  ⚠️ You have already printed the slip for this month. Submitting a new request will require Super Admin approval again.
                </div>
              )}
              <div className="form-actions" style={{ marginTop: 0, paddingTop: 0, borderTop: "none" }}>
                <button className="btn btn-ghost" onClick={() => setReqModal(null)}>Cancel</button>
                <button className="btn btn-primary" onClick={() => submitPrintRequest(reqModal.u)}>
                  <Icon n="print" size={14} />Submit Request
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Manage Deductions Modal ── */}
      {deductModal && (() => {
        const empDeductions = getExtraDeductions(deductModal.u);
        const DEDUCT_PRESETS = ["Advance", "Fine", "Loan Recovery", "Damage", "Tax", "Other"];
        return (
          <div className="overlay" onClick={e => e.target === e.currentTarget && setDeductModal(null)}>
            <div className="modal" style={{ maxWidth: 520 }}>
              <div className="modal-hdr">
                <div>
                  <div className="modal-title">✂ Salary Deductions — {deductModal.u.name}</div>
                  <div className="modal-sub">{monthLabel(selY, selM)}</div>
                </div>
                <button className="modal-close" onClick={() => setDeductModal(null)}>✕</button>
              </div>
              <div className="modal-body">
                {/* Add new deduction form */}
                <div style={{ background: "var(--bg3)", border: "1px solid var(--border)", borderRadius: 8, padding: "1rem", marginBottom: "1rem" }}>
                  <div style={{ fontWeight: 700, fontSize: ".85rem", marginBottom: ".75rem", color: "var(--navy)" }}>➕ Add New Deduction</div>
                  <div className="form-row" style={{ marginBottom: ".6rem" }}>
                    <div className="form-group" style={{ flex: 1 }}>
                      <label>Type / Label *</label>
                      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 6 }}>
                        {DEDUCT_PRESETS.map(p => (
                          <button key={p} type="button"
                            className={`btn btn-xs ${deductForm.label === p ? "btn-primary" : "btn-ghost"}`}
                            onClick={() => setDeductForm(f => ({ ...f, label: p }))}>
                            {p}
                          </button>
                        ))}
                      </div>
                      <input
                        type="text"
                        value={deductForm.label}
                        onChange={e => setDeductForm(f => ({ ...f, label: e.target.value }))}
                        placeholder="Custom label..."
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group" style={{ flex: 1 }}>
                      <label>Amount (PKR) *</label>
                      <input
                        type="number"
                        min="1"
                        value={deductForm.amount}
                        onChange={e => setDeductForm(f => ({ ...f, amount: e.target.value }))}
                        placeholder="e.g. 5000"
                      />
                    </div>
                    <div className="form-group" style={{ flex: 2 }}>
                      <label>Note (optional)</label>
                      <input
                        type="text"
                        value={deductForm.note}
                        onChange={e => setDeductForm(f => ({ ...f, note: e.target.value }))}
                        placeholder="e.g. Against advance taken on 10 June"
                      />
                    </div>
                  </div>
                  <div className="form-actions" style={{ marginTop: ".75rem", paddingTop: ".5rem", borderTop: "none" }}>
                    <button className="btn btn-primary" onClick={addDeduction}>
                      ✂ Add Deduction
                    </button>
                  </div>
                </div>

                {/* Existing deductions list */}
                {empDeductions.length === 0 ? (
                  <div style={{ textAlign: "center", color: "var(--text4)", padding: "1rem", fontSize: ".82rem" }}>
                    No extra deductions added for this month.
                  </div>
                ) : (
                  <>
                    <div style={{ fontWeight: 700, fontSize: ".82rem", color: "var(--text2)", marginBottom: ".5rem" }}>Current Deductions</div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                      {empDeductions.map(ed => (
                        <div key={ed.id} style={{ display: "flex", alignItems: "center", gap: 10, background: "var(--red-lt)", border: "1px solid var(--red-lt2)", borderRadius: 8, padding: ".6rem 1rem" }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 700, fontSize: ".85rem", color: "var(--red)" }}>✂ {ed.label}</div>
                            <div style={{ fontSize: ".73rem", color: "var(--text3)" }}>{ed.note && <span>{ed.note} · </span>}Added: {ed.addedOn}</div>
                          </div>
                          <div style={{ fontWeight: 800, fontSize: ".9rem", color: "var(--red)", fontFamily: "'JetBrains Mono',monospace", whiteSpace: "nowrap" }}>
                            - {fmtCurrency(ed.amount)}
                          </div>
                          <button className="btn btn-danger btn-xs" onClick={() => removeDeduction(ed.id)} title="Remove">✕</button>
                        </div>
                      ))}
                      <div style={{ display: "flex", justifyContent: "space-between", padding: ".5rem 1rem", background: "var(--red-lt2)", borderRadius: 6, fontWeight: 700, fontSize: ".85rem" }}>
                        <span style={{ color: "var(--text2)" }}>Total Extra Deductions</span>
                        <span style={{ color: "var(--red)", fontFamily: "'JetBrains Mono',monospace" }}>- {fmtCurrency(empDeductions.reduce((s, d) => s + Number(d.amount), 0))}</span>
                      </div>
                    </div>
                  </>
                )}

                <div className="form-actions">
                  <button className="btn btn-ghost" onClick={() => setDeductModal(null)}>Close</button>
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── Manage Incentives Modal ── */}
      {incentiveModal && (() => {
        const empIncentives = getExtraIncentives(incentiveModal.u);
        const INCENTIVE_PRESETS = ["Performance", "Overtime", "Bonus", "Commission", "Project Reward", "Other"];
        return (
          <div className="overlay" onClick={e => e.target === e.currentTarget && setIncentiveModal(null)}>
            <div className="modal" style={{ maxWidth: 520 }}>
              <div className="modal-hdr">
                <div>
                  <div className="modal-title">🎁 Salary Incentives — {incentiveModal.u.name}</div>
                  <div className="modal-sub">{monthLabel(selY, selM)}</div>
                </div>
                <button className="modal-close" onClick={() => setIncentiveModal(null)}>✕</button>
              </div>
              <div className="modal-body">
                {/* Add new incentive form */}
                <div style={{ background: "var(--bg3)", border: "1px solid var(--border)", borderRadius: 8, padding: "1rem", marginBottom: "1rem" }}>
                  <div style={{ fontWeight: 700, fontSize: ".85rem", marginBottom: ".75rem", color: "var(--navy)" }}>➕ Add New Incentive</div>
                  <div className="form-row" style={{ marginBottom: ".6rem" }}>
                    <div className="form-group" style={{ flex: 1 }}>
                      <label>Type / Label *</label>
                      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 6 }}>
                        {INCENTIVE_PRESETS.map(p => (
                          <button key={p} type="button"
                            className={`btn btn-xs ${incentiveForm.label === p ? "btn-success" : "btn-ghost"}`}
                            onClick={() => setIncentiveForm(f => ({ ...f, label: p }))}>
                            {p}
                          </button>
                        ))}
                      </div>
                      <input
                        type="text"
                        value={incentiveForm.label}
                        onChange={e => setIncentiveForm(f => ({ ...f, label: e.target.value }))}
                        placeholder="Custom label..."
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group" style={{ flex: 1 }}>
                      <label>Amount (PKR) *</label>
                      <input
                        type="number"
                        min="1"
                        value={incentiveForm.amount}
                        onChange={e => setIncentiveForm(f => ({ ...f, amount: e.target.value }))}
                        placeholder="e.g. 5000"
                      />
                    </div>
                    <div className="form-group" style={{ flex: 2 }}>
                      <label>Note (optional)</label>
                      <input
                        type="text"
                        value={incentiveForm.note}
                        onChange={e => setIncentiveForm(f => ({ ...f, note: e.target.value }))}
                        placeholder="e.g. Q2 Performance bonus"
                      />
                    </div>
                  </div>
                  <div className="form-actions" style={{ marginTop: ".75rem", paddingTop: ".5rem", borderTop: "none" }}>
                    <button className="btn btn-success" onClick={addIncentive}>
                      🎁 Add Incentive
                    </button>
                  </div>
                </div>

                {/* Existing incentives list */}
                {empIncentives.length === 0 ? (
                  <div style={{ textAlign: "center", color: "var(--text4)", padding: "1rem", fontSize: ".82rem" }}>
                    No extra incentives added for this month.
                  </div>
                ) : (
                  <>
                    <div style={{ fontWeight: 700, fontSize: ".82rem", color: "var(--text2)", marginBottom: ".5rem" }}>Current Incentives</div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                      {empIncentives.map(ei => (
                        <div key={ei.id} style={{ display: "flex", alignItems: "center", gap: 10, background: "var(--green-lt)", border: "1px solid var(--green-lt2)", borderRadius: 8, padding: ".6rem 1rem" }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 700, fontSize: ".85rem", color: "var(--green)" }}>🎁 {ei.label}</div>
                            <div style={{ fontSize: ".73rem", color: "var(--text3)" }}>{ei.note && <span>{ei.note} · </span>}Added: {ei.addedOn}</div>
                          </div>
                          <div style={{ fontWeight: 800, fontSize: ".9rem", color: "var(--green)", fontFamily: "'JetBrains Mono',monospace", whiteSpace: "nowrap" }}>
                            + {fmtCurrency(ei.amount)}
                          </div>
                          <button className="btn btn-danger btn-xs" onClick={() => removeIncentive(ei.id)} title="Remove">✕</button>
                        </div>
                      ))}
                      <div style={{ display: "flex", justifyContent: "space-between", padding: ".5rem 1rem", background: "var(--green-lt2)", borderRadius: 6, fontWeight: 700, fontSize: ".85rem" }}>
                        <span style={{ color: "var(--text2)" }}>Total Extra Incentives</span>
                        <span style={{ color: "var(--green)", fontFamily: "'JetBrains Mono',monospace" }}>+ {fmtCurrency(empIncentives.reduce((s, i) => s + Number(i.amount), 0))}</span>
                      </div>
                    </div>
                  </>
                )}

                <div className="form-actions">
                  <button className="btn btn-ghost" onClick={() => setIncentiveModal(null)}>Close</button>
                </div>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
}

// ─── HELPDESK PAGE ────────────────────────────────────────────────────────────
function HelpdeskPage({ users, loggedIn, chats, setChats, threads, setThreads, loading }) {
  const isSA = loggedIn.role === "Super Admin";
  const [activeThread, setActiveThread] = useState("");
  const [search, setSearch] = useState("");
  const [msgInput, setMsgInput] = useState("");
  const [showInviteDropdown, setShowInviteDropdown] = useState(false);
  const [showRemoveDropdown, setShowRemoveDropdown] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [chatName, setChatName] = useState("");
  const messagesEndRef = useRef(null);

  // Normal employees only see active threads. Super Admins see both active and ended threads.
  const visibleThreads = threads.filter(t =>
    t.participants?.includes(loggedIn.id) &&
    (isSA || !t.ended)
  );

  // Auto scroll to bottom of chat when active thread changes or new messages arrive
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chats, activeThread]);

  // Set default active thread when visible threads are loaded (only on desktop)
  useEffect(() => {
    if (window.innerWidth > 768 && !activeThread && visibleThreads.length > 0) {
      setActiveThread(visibleThreads[0].id);
    }
  }, [visibleThreads, activeThread]);

  // Filter messages in the current active thread
  const threadMessages = chats.filter(m => m.threadId === activeThread);

  const activeThreadObj = threads.find(t => t.id === activeThread);

  const sendMessage = () => {
    if (!msgInput.trim() || !activeThread || activeThreadObj?.ended) return;
    const newMsg = {
      id: uid(),
      threadId: activeThread,
      senderId: loggedIn.id,
      senderName: loggedIn.name,
      senderRole: loggedIn.role,
      text: msgInput.trim(),
      timestamp: new Date().toISOString()
    };
    setChats(prev => [...prev, newMsg]);
    setMsgInput("");
  };

  const deleteMessage = (msgId) => {
    if (window.confirm("Are you sure you want to delete this message?")) {
      setChats(prev => prev.filter(m => m.id !== msgId));
      showToast("Message deleted", "ok");
    }
  };

  const compressImage = (file, callback) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const MAX_WIDTH = 600;
        const MAX_HEIGHT = 600;
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        const dataUrl = canvas.toDataURL("image/jpeg", 0.6);
        callback(dataUrl);
      };
    };
  };

  const sendMediaMessage = (fileName, fileType, dataUrl) => {
    if (!activeThread || activeThreadObj?.ended) return;
    const newMsg = {
      id: uid(),
      threadId: activeThread,
      senderId: loggedIn.id,
      senderName: loggedIn.name,
      senderRole: loggedIn.role,
      text: `Sent a file: ${fileName}`,
      media: {
        name: fileName,
        type: fileType,
        data: dataUrl
      },
      timestamp: new Date().toISOString()
    };
    setChats(prev => [...prev, newMsg]);
    showToast("Media file shared", "ok");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.type.startsWith("image/")) {
      compressImage(file, (dataUrl) => {
        sendMediaMessage(file.name, file.type, dataUrl);
      });
    } else {
      if (file.size > 300 * 1024) {
        return showToast("File too large. Max limit is 300 KB.", "err");
      }
      const reader = new FileReader();
      reader.onload = (event) => {
        sendMediaMessage(file.name, file.type, event.target.result);
      };
      reader.readAsDataURL(file);
    }
    e.target.value = "";
  };

  const getFormatTime = (isoString) => {
    if (!isoString) return "";
    try {
      const d = new Date(isoString);
      return d.toLocaleTimeString("en-PK", { hour: "numeric", minute: "2-digit" });
    } catch {
      return "";
    }
  };

  const getLastMessageInfo = (threadId) => {
    const msgs = chats.filter(m => m.threadId === threadId);
    if (msgs.length === 0) return { text: "No messages yet", time: "" };
    const last = msgs[msgs.length - 1];
    return {
      text: last.text,
      time: getFormatTime(last.timestamp)
    };
  };

  const getThreadName = (t) => {
    if (!t) return "Support Chat";
    const others = t.participants
      .filter(pid => pid !== loggedIn.id)
      .map(pid => users.find(u => u.id === pid)?.name || "Unknown");
    const baseName = others.length > 0 ? others.join(", ") : "Support Chat";
    return t.ended ? `[Ended] ${baseName}` : baseName;
  };

  const getParticipantNames = (t) => {
    if (!t) return "";
    return t.participants
      .map(pid => {
        const u = users.find(x => x.id === pid);
        return u ? `${u.name} (${u.role})` : "Unknown";
      })
      .join(", ");
  };

  // Filter threads based on search input
  const filteredThreads = visibleThreads.filter(t => {
    const name = getThreadName(t).toLowerCase();
    const parts = getParticipantNames(t).toLowerCase();
    const query = search.toLowerCase();
    return name.includes(query) || parts.includes(query);
  });

  // Get active employees who are NOT already in this thread
  const nonParticipants = users.filter(u =>
    u.active &&
    u.role !== "Super Admin" &&
    !activeThreadObj?.participants?.includes(u.id)
  );

  // Get employee participants currently in this thread (for removal dropdown)
  const employeeParticipants = activeThreadObj
    ? activeThreadObj.participants
        .map(pid => users.find(x => x.id === pid))
        .filter(u => u && u.role !== "Super Admin")
    : [];

  const inviteEmployee = (emp) => {
    if (!activeThreadObj) return;
    setThreads(prev => prev.map(t =>
      t.id === activeThread ? { ...t, participants: [...t.participants, emp.id] } : t
    ));
    showToast(`Added ${emp.name} to this chat`, "ok");
    setShowInviteDropdown(false);
  };

  const removeEmployee = (emp) => {
    if (!activeThreadObj) return;
    setThreads(prev => prev.map(t =>
      t.id === activeThread
        ? { ...t, participants: t.participants.filter(pid => pid !== emp.id) }
        : t
    ));
    showToast(`Removed ${emp.name} from this chat`, "ok");
    setShowRemoveDropdown(false);
  };

  const endChat = () => {
    if (!activeThreadObj) return;
    setThreads(prev => prev.map(t =>
      t.id === activeThread ? { ...t, ended: true } : t
    ));
    showToast("Conversation ended", "ok");
  };

  const deleteChat = () => {
    if (!activeThreadObj) return;
    if (window.confirm("Are you sure you want to permanently delete this chat thread and all its messages?")) {
      const threadIdToDelete = activeThread;
      setActiveThread("");
      setThreads(prev => prev.filter(t => t.id !== threadIdToDelete));
      setChats(prev => prev.filter(m => m.threadId !== threadIdToDelete));
      showToast("Chat permanently deleted", "ok");
    }
  };

  const handleCreateChat = () => {
    if (selectedEmployees.length === 0) {
      return showToast("Please select at least one employee", "err");
    }
    const superAdmins = users.filter(u => u.role === "Super Admin");
    const participants = [...selectedEmployees, ...superAdmins.map(sa => sa.id)];
    
    let finalName = chatName.trim();
    if (!finalName) {
      const names = selectedEmployees.map(id => users.find(u => u.id === id)?.name || "Unknown");
      finalName = `Group Support - ${names.join(", ")}`;
    }
    
    const newThread = {
      id: uid(),
      name: finalName,
      participants,
      createdBy: loggedIn.id,
      createdOn: new Date().toISOString(),
      ended: false
    };
    
    setThreads(prev => [...prev, newThread]);
    setActiveThread(newThread.id);
    
    setChatName("");
    setSelectedEmployees([]);
    setShowCreateModal(false);
    showToast("Chat created successfully", "ok");
  };

  const createSupportChat = () => {
    const superAdmins = users.filter(u => u.role === "Super Admin");
    const myAllThreads = threads.filter(t => t.participants?.includes(loggedIn.id));
    const nextNum = myAllThreads.length + 1;
    const newThread = {
      id: uid(),
      name: `Support - ${loggedIn.name}${nextNum > 1 ? ` #${nextNum}` : ""}`,
      participants: [loggedIn.id, ...superAdmins.map(sa => sa.id)],
      createdBy: loggedIn.id,
      createdOn: new Date().toISOString(),
      ended: false
    };
    setThreads(prev => [...prev, newThread]);
    setActiveThread(newThread.id);
    showToast("New support chat started", "ok");
  };

  const eligibleEmployees = users.filter(u => u.active && u.role !== "Super Admin");

  return (
    <div className={`helpdesk-container${activeThread ? " chat-active" : ""}`}>
      {/* Sidebar list of conversations */}
      <div className="helpdesk-sidebar">
        <div style={{ padding: "1rem 1rem 0 1rem", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontWeight: 700, fontSize: "0.95rem" }}>Conversations</span>
          {isSA ? (
            <button className="btn btn-primary btn-xs" onClick={() => setShowCreateModal(true)}>
              ➕ New Chat
            </button>
          ) : (
            !visibleThreads.some(t => !t.ended) && (
              <button className="btn btn-primary btn-xs" onClick={createSupportChat}>
                ➕ New Chat
              </button>
            )
          )}
        </div>
        <div className="sidebar-search">
          <input
            type="text"
            placeholder="Search chats..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
        <div className="employee-list">
          {filteredThreads.map(t => {
            const lastInfo = getLastMessageInfo(t.id);
            const isActive = activeThread === t.id;
            return (
              <div
                key={t.id}
                className={`employee-item${isActive ? " active" : ""}`}
                onClick={() => {
                  setActiveThread(t.id);
                  setShowInviteDropdown(false);
                  setShowRemoveDropdown(false);
                }}
              >
                <div className="avatar av-sm" style={{ background: "var(--navy)" }}>
                  💬
                </div>
                <div className="employee-details">
                  <div className="employee-name-row">
                    <span className="employee-name">{getThreadName(t)}</span>
                    <span className="last-msg-time">{lastInfo.time}</span>
                  </div>
                  <div className="last-msg-preview">{lastInfo.text}</div>
                </div>
              </div>
            );
          })}
          {filteredThreads.length === 0 && (
            <div style={{ padding: "2rem", textAlign: "center", color: "var(--text3)", fontSize: "0.85rem" }}>
              No chats found
            </div>
          )}
        </div>
      </div>

      {/* Main Chat Area */}
      {activeThreadObj ? (
        <div className="chat-window">
          {/* Chat Header */}
          <div className="chat-header">
            <button
              className="btn btn-ghost btn-xs mobile-back-btn"
              onClick={() => {
                setActiveThread("");
                setShowInviteDropdown(false);
                setShowRemoveDropdown(false);
              }}
            >
              <Icon n="arrow_back" size={14} /> Back
            </button>
            <div className="avatar av-md" style={{ background: "var(--navy)" }}>
              💬
            </div>
            <div className="chat-header-info">
              <div className="chat-header-name">
                {getThreadName(activeThreadObj)}
              </div>
              <div className="chat-participants-list">
                Participants: {getParticipantNames(activeThreadObj)}
              </div>
            </div>

            {/* Chat Control Actions (Only for Super Admin, and only if the thread is active) */}
            {isSA && !activeThreadObj.ended && (
              <div className="flex gap-2 items-center">
                {/* Invite Dropdown */}
                <div className="invite-dropdown-wrap">
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => {
                      setShowInviteDropdown(!showInviteDropdown);
                      setShowRemoveDropdown(false);
                    }}
                  >
                    ➕ Invite
                  </button>
                  {showInviteDropdown && (
                    <div className="invite-dropdown">
                      <div className="invite-header">Add to Chat</div>
                      {nonParticipants.map(emp => (
                        <div
                          key={emp.id}
                          className="invite-option"
                          onClick={() => inviteEmployee(emp)}
                        >
                          <div className="avatar av-xs" style={{ background: avatarColor(emp.id) }}>
                            {initials(emp.name)}
                          </div>
                          <div>
                            <div style={{ fontWeight: 600, fontSize: "0.8rem" }}>{emp.name}</div>
                            <div style={{ fontSize: "0.7rem", color: "var(--text3)" }}>{emp.dept} · {emp.role}</div>
                          </div>
                        </div>
                      ))}
                      {nonParticipants.length === 0 && (
                        <div style={{ padding: "1rem", fontSize: "0.75rem", color: "var(--text3)", textAlign: "center" }}>
                          All employees are in chat
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Remove Dropdown */}
                <div className="invite-dropdown-wrap">
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => {
                      setShowRemoveDropdown(!showRemoveDropdown);
                      setShowInviteDropdown(false);
                    }}
                  >
                    ✕ Remove
                  </button>
                  {showRemoveDropdown && (
                    <div className="invite-dropdown" style={{ right: 0 }}>
                      <div className="invite-header" style={{ background: "var(--red-lt)", color: "var(--red)" }}>Remove from Chat</div>
                      {employeeParticipants.map(emp => (
                        <div
                          key={emp.id}
                          className="invite-option"
                          onClick={() => removeEmployee(emp)}
                        >
                          <div className="avatar av-xs" style={{ background: avatarColor(emp.id) }}>
                            {initials(emp.name)}
                          </div>
                          <div>
                            <div style={{ fontWeight: 600, fontSize: "0.8rem" }}>{emp.name}</div>
                            <div style={{ fontSize: "0.7rem", color: "var(--text3)" }}>{emp.dept} · {emp.role}</div>
                          </div>
                        </div>
                      ))}
                      {employeeParticipants.length === 0 && (
                        <div style={{ padding: "1rem", fontSize: "0.75rem", color: "var(--text3)", textAlign: "center" }}>
                          No employees to remove
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* End Chat Button */}
                <button
                  className="btn btn-ghost btn-sm"
                  style={{ color: "var(--red)", border: "1px solid var(--red2)" }}
                  onClick={endChat}
                >
                  🚫 End Chat
                </button>
              </div>
            )}

            {/* Read-Only Status Indicator */}
            {activeThreadObj.ended && (
              <div className="flex gap-2 items-center">
                <span className="badge badge-red" style={{ fontSize: "0.75rem", padding: "0.3rem 0.7rem" }}>
                  🔒 Ended
                </span>
                {isSA && (
                  <button
                    className="btn btn-danger btn-xs"
                    onClick={deleteChat}
                  >
                    🗑️ Delete Chat
                  </button>
                )}
              </div>
            )}
          </div>

          {/* Chat Messages */}
          <div className="chat-messages">
            {threadMessages.map(m => {
              const isSelf = m.senderId === loggedIn.id;
              return (
                <div key={m.id} className={`message-row ${isSelf ? "sent" : "received"}`}>
                  <div className="avatar av-xs" style={{ background: avatarColor(m.senderId) }}>
                    {initials(m.senderName)}
                  </div>
                  <div className="message-content">
                    <div className="message-bubble">
                      {m.media ? (
                        m.media.type.startsWith("image/") ? (
                          <div className="chat-media-wrap">
                            <img
                              src={m.media.data}
                              alt={m.media.name}
                              className="chat-media-image"
                              onClick={() => {
                                const newTab = window.open();
                                if (newTab) {
                                  newTab.document.write(`<img src="${m.media.data}" style="max-width:100%; max-height:100vh; display:block; margin:auto;" />`);
                                }
                              }}
                            />
                            <div className="chat-media-caption">{m.media.name}</div>
                          </div>
                        ) : (
                          <a
                            href={m.media.data}
                            download={m.media.name}
                            className="chat-media-file"
                          >
                            📎 {m.media.name}
                          </a>
                        )
                      ) : (
                        m.text
                      )}
                    </div>
                    <div className="message-meta">
                      {!isSelf && <span style={{ fontWeight: 600 }}>{m.senderName}</span>}
                      <span>{getFormatTime(m.timestamp)}</span>
                      {isSA && (
                        <button
                          onClick={() => deleteMessage(m.id)}
                          className="msg-delete-btn"
                          title="Delete message"
                        >
                          🗑️ Delete
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
            {threadMessages.length === 0 && (
              <div className="chat-window-placeholder" style={{ opacity: 0.5 }}>
                <span>👋 Welcome to Helpdesk Chat</span>
                <p style={{ fontSize: "0.85rem", textAlign: "center" }}>Send a message to start chatting.</p>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          {/* Chat Input / Ended Banner */}
          {activeThreadObj.ended ? (
            <div className="ended-chat-notice">
              🚫 This conversation has been ended by the Super Admin.
            </div>
          ) : (
            <div className="chat-input-area">
              <label className="chat-attach-btn" title="Share Media">
                📎
                <input
                  type="file"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                  accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain"
                />
              </label>
              <input
                type="text"
                placeholder="Type your message here..."
                value={msgInput}
                onChange={e => setMsgInput(e.target.value)}
                onKeyDown={e => e.key === "Enter" && sendMessage()}
              />
              <button onClick={sendMessage}>
                Send
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="chat-window-placeholder">
          <span>💬 Welcome to Helpdesk</span>
          <p>Select a chat from the sidebar to start.</p>
          {!isSA && !visibleThreads.some(t => !t.ended) && (
            <button className="btn btn-primary" onClick={createSupportChat} style={{ marginTop: "1rem" }}>
              ➕ Start a Chat with Support
            </button>
          )}
        </div>
      )}

      {/* Create Chat Modal */}
      {showCreateModal && (
        <div className="overlay" onClick={e => e.target === e.currentTarget && setShowCreateModal(false)}>
          <div className="modal" style={{ maxWidth: "400px" }}>
            <div className="modal-hdr">
              <div>
                <div className="modal-title">Create New Chat</div>
                <div className="modal-sub">Select employees to start a conversation</div>
              </div>
              <button className="modal-close" onClick={() => setShowCreateModal(false)}>✕</button>
            </div>
            <div className="modal-body" style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <div className="form-group">
                <label>Chat Name (Optional)</label>
                <input
                  type="text"
                  placeholder="e.g. Finance Query, Project Support"
                  value={chatName}
                  onChange={e => setChatName(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Select Employees (Choose one or more)</label>
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                  maxHeight: "200px",
                  overflowY: "auto",
                  padding: "0.5rem",
                  border: "1px solid var(--border)",
                  borderRadius: "var(--radius)",
                  background: "var(--bg2)"
                }}>
                  {eligibleEmployees.map(emp => {
                    const isChecked = selectedEmployees.includes(emp.id);
                    return (
                      <label key={emp.id} style={{ display: "flex", alignItems: "center", gap: "0.6rem", cursor: "pointer", fontSize: "0.85rem", padding: "0.25rem", borderRadius: "4px", background: isChecked ? "var(--bg3)" : "transparent" }}>
                        <input
                          type="checkbox"
                          checked={isChecked}
                          onChange={() => {
                            if (isChecked) {
                              setSelectedEmployees(prev => prev.filter(id => id !== emp.id));
                            } else {
                              setSelectedEmployees(prev => [...prev, emp.id]);
                            }
                          }}
                        />
                        <div className="avatar av-xs" style={{ background: avatarColor(emp.id) }}>
                          {initials(emp.name)}
                        </div>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: 600 }}>{emp.name}</div>
                          <div style={{ fontSize: "0.72rem", color: "var(--text3)" }}>{emp.dept} · {emp.role}</div>
                        </div>
                      </label>
                    );
                  })}
                  {eligibleEmployees.length === 0 && (
                    <div style={{ padding: "1rem", textAlign: "center", color: "var(--text3)", fontSize: "0.8rem" }}>
                      No active employees found
                    </div>
                  )}
                </div>
              </div>
              <div className="form-actions" style={{ marginTop: "0.5rem" }}>
                <button className="btn btn-ghost" onClick={() => setShowCreateModal(false)}>Cancel</button>
                <button className="btn btn-primary" onClick={handleCreateChat}>Create Chat</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── REPORTS PAGE ─────────────────────────────────────────────────────────────
function ReportsPage({ users, attendance, leaves, settings, loggedIn, can, deductions, incentives }) {
  const now = new Date();
  const [selY, setSelY] = useState(now.getFullYear());
  const [selM, setSelM] = useState(now.getMonth() + 1);
  const [tab, setTab] = useState("individual");

  // If user lacks admin access (no "users" permission), lock to their own report only
  const isSelfOnly = !can("users");

  const [selUser, setSelUser] = useState(
    isSelfOnly ? loggedIn.id : (users.find(u => u.active)?.id || "")
  );
  const [selDept, setSelDept] = useState("All");
  const [deductLeave, setDeductLeave] = useState(settings.deductLeave);
  const activeUsers = users.filter(u => u.active);
  const years = Array.from({ length: 5 }, (_, i) => now.getFullYear() - 2 + i);

  const workDays = settings?.workDays || [1,2,3,4,5,6];
  const calcSalary = (u) => {
    const days = daysInMonth(selY, selM);
    const workingDays = Array.from({ length: days }, (_, i) => i + 1).filter(d => !isOffDay(selY, selM, d, workDays)).length;
    const perDay = u.salary / (workingDays || 1);
    const monthEndStr = `${selY}-${String(selM).padStart(2, "0")}-${String(days).padStart(2, "0")}`;

    // If selected month is completely before joining date, net salary is 0
    if (u.joinDate && monthEndStr < u.joinDate) {
      return { P: 0, A: days, L: 0, H: 0, workingDays, perDay, attDeductions: u.salary, extraDeductions: [], extraTotal: 0, extraIncentives: [], extraIncentivesTotal: 0, deductions: u.salary, netSalary: 0, gross: u.salary, grossTotal: u.salary, notJoined: true };
    }

    let P = 0, A = 0, L = 0, H = 0;
    Array.from({ length: days }, (_, i) => i + 1).forEach(d => {
      const dateStr = `${selY}-${String(selM).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
      const key = `${dateStr}_${u.id}`;
      let v = attendance[key];
      if (!v && u.joinDate && dateStr < u.joinDate) v = "A";
      if (v === "P") P++;
      else if (v === "A") A++;
      else if (v === "L") L++;
      else if (v === "H") H++;
    });
    let attDeductions = A * perDay;
    const override = u.deductLeaveOverride || "global";
    const shouldDeductLeave = override === "yes" ? true : override === "no" ? false : deductLeave;
    if (shouldDeductLeave && L > 0) attDeductions += L * perDay;
    // Extra deductions (advance, fine, loan, etc.) for this employee/month
    const extraDeductions = (deductions || []).filter(
      d => d.userId === u.id && d.year === selY && d.month === selM
    );
    const extraTotal = extraDeductions.reduce((sum, d) => sum + Number(d.amount || 0), 0);
    const totalDeductions = attDeductions + extraTotal;
    // Extra incentives (performance, overtime, bonus, etc.) for this employee/month
    const extraIncentives = (incentives || []).filter(
      i => i.userId === u.id && i.year === selY && i.month === selM
    );
    const extraIncentivesTotal = extraIncentives.reduce((sum, i) => sum + Number(i.amount || 0), 0);
    const grossTotal = u.salary + extraIncentivesTotal;
    return { P, A, L, H, workingDays, perDay, attDeductions, extraDeductions, extraTotal, extraIncentives, extraIncentivesTotal, deductions: totalDeductions, netSalary: Math.max(0, grossTotal - totalDeductions), gross: u.salary, grossTotal, notJoined: false };
  };

  const printIndividual = () => {
    const u = users.find(x => x.id === selUser);
    if (!u) return;
    const s = calcSalary(u);
    const days = daysInMonth(selY, selM);
    const cols = Array.from({ length: days }, (_, i) => i + 1);
    const getStatus = (d) => {
      const dateStr = `${selY}-${String(selM).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
      const key = `${dateStr}_${u.id}`;
      return attendance[key] || (u.joinDate && dateStr < u.joinDate ? "A" : (isOffDay(selY, selM, d, workDays) ? "WO" : ""));
    };
    const w = window.open("", "_blank");
    w.document.write(generateIndividualReportHTML(u, s, selY, selM, cols, getStatus, settings, deductLeave, isSelfOnly));
    w.document.close();
    w.focus();
    setTimeout(() => w.print(), 500);
  };

  const printGroup = () => {
    const grpUsers = activeUsers.filter(u => selDept === "All" || u.dept === selDept);
    const days = daysInMonth(selY, selM);
    const cols = Array.from({ length: days }, (_, i) => i + 1);
    const getStatus = (uid, d) => {
      const dateStr = `${selY}-${String(selM).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
      const key = `${dateStr}_${uid}`;
      const targetUser = users.find(x => x.id === uid);
      return attendance[key] || (targetUser?.joinDate && dateStr < targetUser.joinDate ? "A" : (isOffDay(selY, selM, d, workDays) ? "WO" : ""));
    };
    const w = window.open("", "_blank");
    w.document.write(generateGroupReportHTML(grpUsers, selY, selM, cols, getStatus, calcSalary, settings, selDept, deductLeave));
    w.document.close();
    w.focus();
    setTimeout(() => w.print(), 500);
  };

  const printSummary = () => {
    const grpUsers = activeUsers.filter(u => selDept === "All" || u.dept === selDept);
    const w = window.open("", "_blank");
    w.document.write(generateSummaryReportHTML(grpUsers, selY, selM, calcSalary, settings, selDept, deductLeave));
    w.document.close();
    w.focus();
    setTimeout(() => w.print(), 500);
  };

  const u = users.find(x => x.id === selUser);
  const sel_s = u ? calcSalary(u) : null;

  return (
    <div>
      <div className="page-hdr">
        <div className="page-title">Reports & Exports</div>
        <div className="flex gap-2">
          <select value={selM} onChange={e => setSelM(Number(e.target.value))} style={{ width: 130 }}>
            {Array.from({ length: 12 }, (_, i) => <option key={i} value={i + 1}>{new Date(2000, i).toLocaleString("default", { month: "long" })}</option>)}
          </select>
          <select value={selY} onChange={e => setSelY(Number(e.target.value))} style={{ width: 90 }}>
            {years.map(y => <option key={y}>{y}</option>)}
          </select>
        </div>
      </div>

      <div className="card mb-3">
        <div className="card-hdr"><div className="card-title">⚙️ Report Settings</div></div>
        <div className="flex items-center gap-3">
          <div className="toggle" onClick={() => setDeductLeave(!deductLeave)}>
            <div className={`toggle-track ${deductLeave ? "on" : ""}`}><div className="toggle-thumb" /></div>
            <span className="toggle-label">Deduct Leave from Salary</span>
          </div>
          <div className="text-xs text-muted">When ON, approved leave days are deducted from salary calculation in reports</div>
        </div>
      </div>

      {isSelfOnly && (
        <div className="info-box" style={{ marginBottom: "1rem" }}>
          🔒 You have access to view your own individual report only.
        </div>
      )}

      <div className="tabs">
        <div className={`tab${tab === "individual" ? " active" : ""}`} onClick={() => setTab("individual")}>Individual Report</div>
        {!isSelfOnly && <div className={`tab${tab === "group" ? " active" : ""}`} onClick={() => setTab("group")}>Group Report</div>}
        {!isSelfOnly && <div className={`tab${tab === "summary" ? " active" : ""}`} onClick={() => setTab("summary")}>Salary Summary</div>}
      </div>

      {tab === "individual" && (
        <div>
          <div className="card mb-3">
            <div className="card-hdr">
              <div className="card-title">Individual Attendance & Salary Report</div>
              <div className="flex gap-2">
                {isSelfOnly ? (
                  <span className="badge badge-blue" style={{ padding: ".35rem .8rem", fontSize: ".8rem" }}>{users.find(u => u.id === loggedIn.id)?.name || loggedIn.name}</span>
                ) : (
                  <select value={selUser} onChange={e => setSelUser(e.target.value)} style={{ width: 220 }}>
                    {activeUsers.map(u => <option key={u.id} value={u.id}>{u.name} — {u.dept}</option>)}
                  </select>
                )}
                <button className="btn btn-primary btn-sm" onClick={printIndividual}><Icon n="print" size={14} />Print / Export PDF</button>
              </div>
            </div>
            {u && sel_s && (
              <div className="grid-2 mt-2">
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <div className="avatar av-lg" style={{ background: avatarColor(u.id) }}>{initials(u.name)}</div>
                    <div>
                      <div className="font-bold">{u.name}</div>
                      <div className="text-xs text-muted">{u.dept} · {u.role}</div>
                      <div className="text-xs text-muted">Joined: {u.joinDate}</div>
                    </div>
                  </div>
                  <div className="flex gap-2 flex-wrap">
                    {[["P","Present","badge-green"],[u.A||sel_s.A,"A","Absent","badge-red"],[sel_s.L,"L","Leave","badge-orange"],[sel_s.H,"H","Holiday","badge-purple"]].map((x, i) => {
                      const val = i === 0 ? sel_s.P : i === 1 ? sel_s.A : i === 2 ? sel_s.L : sel_s.H;
                      const lbl = i === 0 ? "Present" : i === 1 ? "Absent" : i === 2 ? "Leave" : "Holiday";
                      const cls = i === 0 ? "badge-green" : i === 1 ? "badge-red" : i === 2 ? "badge-orange" : "badge-purple";
                      return <span key={i} className={`badge ${cls}`}>{lbl}: {val}</span>;
                    })}
                  </div>
                </div>
                <div className="salary-card">
                  <div className="sal-hdr" style={{ padding: ".9rem 1.1rem" }}>
                    <div>
                      <div style={{ color: "rgba(255,255,255,.6)", fontSize: ".73rem" }}>Net Salary</div>
                      <div className="sal-gross" style={{ fontSize: "1.2rem" }}>{isSelfOnly ? "***" : fmtCurrency(sel_s.netSalary)}</div>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <div style={{ color: "rgba(255,255,255,.5)", fontSize: ".7rem" }}>Gross: {isSelfOnly ? "***" : fmtCurrency(sel_s.gross)}</div>
                      <div style={{ color: "var(--red2)", fontSize: ".7rem" }}>Deductions: {isSelfOnly ? "***" : fmtCurrency(Math.round(sel_s.deductions))}</div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {tab === "group" && (
        <div>
          <div className="card mb-3">
            <div className="card-hdr">
              <div className="card-title">Group Attendance Report</div>
              <div className="flex gap-2">
                <select value={selDept} onChange={e => setSelDept(e.target.value)} style={{ width: 180 }}>
                  <option value="All">All Departments</option>
                  {DEPTS.map(d => <option key={d}>{d}</option>)}
                </select>
                <button className="btn btn-primary btn-sm" onClick={printGroup}><Icon n="print" size={14} />Print Group Report</button>
              </div>
            </div>
            <div className="info-box">
              📊 This will generate a full attendance matrix for {selDept === "All" ? "all departments" : selDept} for {monthLabel(selY, selM)}. Each row is an employee, each column is a day.
            </div>
          </div>

          <div className="tbl-wrap">
            <table>
              <thead>
                <tr><th>Employee</th><th>Dept</th><th>P</th><th>A</th><th>L</th><th>H</th><th>Net Salary</th></tr>
              </thead>
              <tbody>
                {activeUsers.filter(u => selDept === "All" || u.dept === selDept).map(u => {
                  const s = calcSalary(u);
                  return (
                    <tr key={u.id}>
                      <td style={{ fontWeight: 600 }}>{u.name}</td>
                      <td>{u.dept}</td>
                      <td><span className="badge badge-green">{s.P}</span></td>
                      <td><span className="badge badge-red">{s.A}</span></td>
                      <td><span className="badge badge-orange">{s.L}</span></td>
                      <td><span className="badge badge-purple">{s.H}</span></td>
                      <td className="font-mono font-bold">{fmtCurrency(s.netSalary)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {tab === "summary" && (
        <div>
          <div className="card mb-3">
            <div className="card-hdr">
              <div className="card-title">Salary Summary Report</div>
              <div className="flex gap-2">
                <select value={selDept} onChange={e => setSelDept(e.target.value)} style={{ width: 180 }}>
                  <option value="All">All Departments</option>
                  {DEPTS.map(d => <option key={d}>{d}</option>)}
                </select>
                <button className="btn btn-primary btn-sm" onClick={printSummary}><Icon n="print" size={14} />Print Summary</button>
              </div>
            </div>
          </div>

          {(() => {
            const grpUsers = activeUsers.filter(u => selDept === "All" || u.dept === selDept);
            const totalGross = grpUsers.reduce((s, u) => s + calcSalary(u).gross, 0);
            const totalDeduct = grpUsers.reduce((s, u) => s + calcSalary(u).deductions, 0);
            const totalNet = grpUsers.reduce((s, u) => s + calcSalary(u).netSalary, 0);
            return (
              <>
                <div className="stat-grid" style={{ gridTemplateColumns: "repeat(3, 1fr)" }}>
                  <div className="stat-card">
                    <div className="stat-icon" style={{ background: "var(--blue-lt)" }}><Icon n="salary" size={20} col="var(--blue)" /></div>
                    <div><div className="stat-num">{fmtCurrency(totalGross)}</div><div className="stat-lbl">Total Gross</div></div>
                  </div>
                  <div className="stat-card">
                    <div className="stat-icon" style={{ background: "var(--red-lt)" }}><Icon n="info" size={20} col="var(--red)" /></div>
                    <div><div className="stat-num">{fmtCurrency(Math.round(totalDeduct))}</div><div className="stat-lbl">Total Deductions</div></div>
                  </div>
                  <div className="stat-card">
                    <div className="stat-icon" style={{ background: "var(--green-lt)" }}><Icon n="mark" size={20} col="var(--green)" /></div>
                    <div><div className="stat-num">{fmtCurrency(Math.round(totalNet))}</div><div className="stat-lbl">Total Net Payable</div></div>
                  </div>
                </div>
                <div className="tbl-wrap">
                  <table>
                    <thead><tr><th>#</th><th>Employee</th><th>Department</th><th>Gross</th><th>Present Days</th><th>Absent Days</th><th>Deductions</th><th>Net Payable</th></tr></thead>
                    <tbody>
                      {grpUsers.map((u, i) => {
                        const s = calcSalary(u);
                        return (
                          <tr key={u.id}>
                            <td className="text-muted">{i + 1}</td>
                            <td>
                              <div className="flex items-center gap-2">
                                <div className="avatar av-sm" style={{ background: avatarColor(u.id) }}>{initials(u.name)}</div>
                                <div style={{ fontWeight: 600 }}>{u.name}</div>
                              </div>
                            </td>
                            <td>{u.dept}</td>
                            <td className="font-mono">{fmtCurrency(s.gross)}</td>
                            <td><span className="badge badge-green">{s.P}</span></td>
                            <td><span className="badge badge-red">{s.A}</span></td>
                            <td className="font-mono" style={{ color: s.deductions > 0 ? "var(--red)" : "inherit" }}>{s.deductions > 0 ? `- ${fmtCurrency(Math.round(s.deductions))}` : "—"}</td>
                            <td className="font-mono font-bold">{fmtCurrency(s.netSalary)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </>
            );
          })()}
        </div>
      )}
    </div>
  );
}

// ─── SETTINGS PAGE ────────────────────────────────────────────────────────────
function SettingsPage({ settings, setSettings }) {
  const [form, setForm] = useState({ ...settings });
  useEffect(() => { setForm({ ...settings }); }, [settings]);

  // Role permissions editor — stored in form.rolePerms, falls back to PERMS
  const getPerms = () => form.rolePerms || PERMS;
  const setRolePerms = (rolePerms) => setForm(p => ({ ...p, rolePerms }));

  const togglePerm = (role, perm) => {
    const cur = getPerms();
    const roleParms = cur[role] || [];
    const has = roleParms.includes(perm);
    if (!has) {
      setRolePerms({ ...cur, [role]: [...roleParms, perm] });
    } else {
      // Prevent removing dashboard from any role
      if (perm === "dashboard") return showToast("Dashboard access cannot be removed", "err");
      setRolePerms({ ...cur, [role]: roleParms.filter(p => p !== perm) });
    }
  };

  const resetPerms = () => {
    setRolePerms({ ...PERMS });
    showToast("Permissions reset to defaults", "ok");
  };

  const handleProfileChange = (nextProfileId) => {
    const currentActiveId = form.activeProfileId || "civyx";
    const updatedProfiles = (form.profiles || []).map(p => {
      if (p.id === currentActiveId) {
        return {
          ...p,
          companyName: form.companyName || "",
          companyTagline: form.companyTagline || "",
          companyAddress: form.companyAddress || "",
          companyPhone: form.companyPhone || "",
          companyEmail: form.companyEmail || "",
          companyWebsite: form.companyWebsite || "",
          companyGstin: form.companyGstin || "",
          companyBank: form.companyBank || "",
          companyAccountNo: form.companyAccountNo || "",
          companyIfsc: form.companyIfsc || "",
          logo: form.logo || "",
        };
      }
      return p;
    });

    const nextProfile = updatedProfiles.find(p => p.id === nextProfileId);
    if (!nextProfile) return;

    setForm(p => ({
      ...p,
      profiles: updatedProfiles,
      activeProfileId: nextProfileId,
      companyName: nextProfile.companyName || "",
      companyTagline: nextProfile.companyTagline || "",
      companyAddress: nextProfile.companyAddress || "",
      companyPhone: nextProfile.companyPhone || "",
      companyEmail: nextProfile.companyEmail || "",
      companyWebsite: nextProfile.companyWebsite || "",
      companyGstin: nextProfile.companyGstin || "",
      companyBank: nextProfile.companyBank || "",
      companyAccountNo: nextProfile.companyAccountNo || "",
      companyIfsc: nextProfile.companyIfsc || "",
      logo: nextProfile.logo || "",
    }));
  };

  const save = () => {
    const currentActiveId = form.activeProfileId || "civyx";
    const finalProfiles = (form.profiles || []).map(p => {
      if (p.id === currentActiveId) {
        return {
          ...p,
          companyName: form.companyName || "",
          companyTagline: form.companyTagline || "",
          companyAddress: form.companyAddress || "",
          companyPhone: form.companyPhone || "",
          companyEmail: form.companyEmail || "",
          companyWebsite: form.companyWebsite || "",
          companyGstin: form.companyGstin || "",
          companyBank: form.companyBank || "",
          companyAccountNo: form.companyAccountNo || "",
          companyIfsc: form.companyIfsc || "",
          logo: form.logo || "",
        };
      }
      return p;
    });

    const saved = { ...form, profiles: finalProfiles };
    setSettings(saved);
    showToast("Settings saved successfully", "ok");
  };

  const ALL_PERMS = Object.keys(PERM_LABELS);

  return (
    <div>
      <div className="page-hdr"><div className="page-title">System Settings</div></div>
      <div className="grid-2">
        <div className="card">
          <div className="card-hdr"><div className="card-title">Company Information</div></div>
          <div className="form-group" style={{ borderBottom: "1px solid var(--border2)", paddingBottom: "1.2rem", marginBottom: "1.2rem" }}>
            <label style={{ color: "var(--blue)", fontWeight: 700 }}>Select Active Company Profile</label>
            <select
              value={form.activeProfileId || "civyx"}
              onChange={e => handleProfileChange(e.target.value)}
              style={{
                fontSize: ".9rem",
                fontWeight: 600,
                color: "var(--text)",
                padding: ".45rem .8rem",
                borderRadius: 8,
                border: "2px solid var(--blue)",
                background: "var(--blue-lt)",
                cursor: "pointer"
              }}
            >
              {(form.profiles || []).map(p => (
                <option key={p.id} value={p.id}>{p.companyName}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Company Name</label>
            <input value={form.companyName || ""} onChange={e => setForm(p => ({ ...p, companyName: e.target.value }))} />
          </div>
          <div className="form-group">
            <label>Company Logo</label>
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <img src={form.logo || LOGO_B64} alt="Company Logo" style={{ width: 50, height: 50, objectFit: "contain", border: "1px solid var(--border)", borderRadius: 4, padding: 2, background: "#fff" }} />
              <input type="file" accept="image/*" onChange={e => {
                const file = e.target.files[0];
                if (file) {
                  const reader = new FileReader();
                  reader.onloadend = () => {
                    const logoData = reader.result;
                    setForm(p => ({
                      ...p,
                      logo: logoData,
                      profiles: (p.profiles || []).map(prof =>
                        prof.id === (p.activeProfileId || "civyx")
                          ? { ...prof, logo: logoData }
                          : prof
                      )
                    }));
                  };
                  reader.readAsDataURL(file);
                }
              }} style={{ border: "none", padding: 0 }} />
            </div>
          </div>
          <div className="form-group">
            <label>Tagline</label>
            <input value={form.companyTagline || ""} onChange={e => setForm(p => ({ ...p, companyTagline: e.target.value }))} placeholder="Company Tagline" />
          </div>
          <div className="form-group">
            <label>Address</label>
            <input value={form.companyAddress || ""} onChange={e => setForm(p => ({ ...p, companyAddress: e.target.value }))} placeholder="Company Address" />
          </div>
          <div className="form-group">
            <label>Phone</label>
            <input value={form.companyPhone || ""} onChange={e => setForm(p => ({ ...p, companyPhone: e.target.value }))} placeholder="Company Phone" />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input value={form.companyEmail || ""} onChange={e => setForm(p => ({ ...p, companyEmail: e.target.value }))} placeholder="Company Email" />
          </div>
          <div className="form-group">
            <label>Website</label>
            <input value={form.companyWebsite || ""} onChange={e => setForm(p => ({ ...p, companyWebsite: e.target.value }))} placeholder="Company Website" />
          </div>
          <div className="form-group">
            <label>GSTIN</label>
            <input value={form.companyGstin || ""} onChange={e => setForm(p => ({ ...p, companyGstin: e.target.value }))} placeholder="Company GSTIN" />
          </div>
          <div className="form-group">
            <label>Bank Name</label>
            <input value={form.companyBank || ""} onChange={e => setForm(p => ({ ...p, companyBank: e.target.value }))} placeholder="Bank Name" />
          </div>
          <div className="form-group">
            <label>Account Number</label>
            <input value={form.companyAccountNo || ""} onChange={e => setForm(p => ({ ...p, companyAccountNo: e.target.value }))} placeholder="Account Number" />
          </div>
          <div className="form-group">
            <label>IFSC Code</label>
            <input value={form.companyIfsc || ""} onChange={e => setForm(p => ({ ...p, companyIfsc: e.target.value }))} placeholder="IFSC Code" />
          </div>
        </div>

        <div className="card">
          <div className="card-hdr"><div className="card-title">Working Days</div><div className="card-sub">Select which days employees are required to work</div></div>
          <div style={{ display: "flex", gap: ".5rem", flexWrap: "wrap", marginBottom: ".8rem" }}>
            {[
              { d: 1, label: "Mon" }, { d: 2, label: "Tue" }, { d: 3, label: "Wed" },
              { d: 4, label: "Thu" }, { d: 5, label: "Fri" }, { d: 6, label: "Sat" }, { d: 0, label: "Sun" }
            ].map(({ d, label }) => {
              const active = (form.workDays || [1,2,3,4,5,6]).includes(d);
              return (
                <button key={d} onClick={() => {
                  const cur = form.workDays || [1,2,3,4,5,6];
                  const next = active ? cur.filter(x => x !== d) : [...cur, d];
                  if (next.length === 0) return showToast("At least one working day required", "err");
                  setForm(p => ({ ...p, workDays: next }));
                }} style={{
                  padding: ".45rem .9rem", borderRadius: 6, border: "2px solid",
                  borderColor: active ? "var(--blue)" : "var(--border2)",
                  background: active ? "var(--blue)" : "var(--white)",
                  color: active ? "#fff" : "var(--text3)",
                  fontWeight: 700, fontSize: ".8rem", cursor: "pointer", transition: "all .15s",
                  fontFamily: "inherit"
                }}>
                  {label}
                </button>
              );
            })}
          </div>
          <div style={{ marginTop: ".5rem" }}>
            <div style={{ fontSize: ".72rem", color: "var(--text3)", marginBottom: ".5rem" }}>Quick presets:</div>
            <div style={{ display: "flex", gap: ".5rem", flexWrap: "wrap" }}>
              {[
                { label: "Mon – Fri (5 days)", days: [1,2,3,4,5] },
                { label: "Mon – Sat (6 days)", days: [1,2,3,4,5,6] },
                { label: "All 7 days", days: [0,1,2,3,4,5,6] },
              ].map(({ label, days }) => (
                <button key={label} onClick={() => setForm(p => ({ ...p, workDays: days }))}
                  style={{ padding: ".3rem .75rem", borderRadius: 5, border: "1px solid var(--border2)", background: "var(--bg)", color: "var(--text2)", fontSize: ".75rem", cursor: "pointer", fontFamily: "inherit", fontWeight: 500 }}>
                  {label}
                </button>
              ))}
            </div>
          </div>
          <div className="info-box" style={{ marginTop: ".8rem" }}>
            📅 <strong>{(form.workDays || [1,2,3,4,5,6]).length} working days/week</strong> — Off days show as <strong>WO</strong> in attendance and are excluded from salary calculation.
          </div>
        </div>

        <div className="card">
          <div className="card-hdr"><div className="card-title">Salary & Attendance Policy</div></div>
          <div className="flex flex-col gap-3">
            <div className="toggle" onClick={() => setForm(p => ({ ...p, deductLeave: !p.deductLeave }))}>
              <div className={`toggle-track ${form.deductLeave ? "on" : ""}`}><div className="toggle-thumb" /></div>
              <span className="toggle-label">Deduct salary on approved leave</span>
            </div>
            <div className="toggle" onClick={() => setForm(p => ({ ...p, weekOffPaid: !p.weekOffPaid }))}>
              <div className={`toggle-track ${form.weekOffPaid ? "on" : ""}`}><div className="toggle-thumb" /></div>
              <span className="toggle-label">Weekend Off considered paid</span>
            </div>
            <div className="toggle" onClick={() => setForm(p => ({ ...p, holidayPaid: !p.holidayPaid }))}>
              <div className={`toggle-track ${form.holidayPaid ? "on" : ""}`}><div className="toggle-thumb" /></div>
              <span className="toggle-label">Public Holidays considered paid</span>
            </div>
          </div>
        </div>
      </div>

      {/* ── ROLE ACCESS CONTROL — full width, interactive ── */}
      <div className="card mt-3">
        <div className="card-hdr">
          <div>
            <div className="card-title">Role Access Control</div>
            <div className="card-sub">Click any permission badge to grant or revoke it for a role</div>
          </div>
          <button className="btn btn-ghost btn-sm" onClick={resetPerms}>Reset to Defaults</button>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          {ROLES.map(r => {
            const rolePerms = getPerms()[r] || [];
            const roleBadge = r === "Super Admin" ? "badge-purple" : r === "HR Manager" ? "badge-blue" : r === "Supervisor" ? "badge-gold" : "badge-gray";
            const roleBg = r === "Super Admin" ? "var(--purple-lt)" : r === "HR Manager" ? "var(--blue-lt)" : r === "Supervisor" ? "var(--gold-lt)" : "var(--bg2)";
            return (
              <div key={r} style={{ border: "1px solid var(--border)", borderRadius: 10, overflow: "hidden" }}>
                {/* Role header */}
                <div style={{ background: roleBg, padding: ".65rem 1rem", display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid var(--border)" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: ".6rem" }}>
                    <span className={`badge ${roleBadge}`}>{r}</span>
                    <span style={{ fontSize: ".72rem", color: "var(--text3)" }}>{rolePerms.length} permissions granted</span>
                  </div>
                  {r !== "Super Admin" && (
                    <span style={{ fontSize: ".68rem", color: "var(--text4)" }}>Click a permission to toggle it</span>
                  )}
                  {r === "Super Admin" && (
                    <span style={{ fontSize: ".68rem", color: "var(--purple)", fontWeight: 600 }}>🔒 All permissions always granted</span>
                  )}
                </div>

                {/* Permission grid */}
                <div style={{ padding: ".8rem 1rem", display: "flex", flexWrap: "wrap", gap: ".45rem" }}>
                  {ALL_PERMS.map(perm => {
                    const info = PERM_LABELS[perm];
                    const has = rolePerms.includes(perm);
                    const isSA = r === "Super Admin";
                    const isDashboard = perm === "dashboard";
                    return (
                      <button
                        key={perm}
                        onClick={() => !isSA && togglePerm(r, perm)}
                        title={isSA ? "Super Admin always has all permissions" : has ? `Revoke "${info.label}" from ${r}` : `Grant "${info.label}" to ${r}`}
                        style={{
                          display: "inline-flex", alignItems: "center", gap: ".3rem",
                          padding: ".28rem .7rem",
                          borderRadius: 20,
                          border: `2px solid ${has ? "transparent" : "var(--border2)"}`,
                          background: has
                            ? (info.color === "badge-blue" ? "var(--blue-lt)" :
                               info.color === "badge-purple" ? "var(--purple-lt)" :
                               info.color === "badge-green" ? "var(--green-lt)" :
                               info.color === "badge-gold" ? "var(--gold-lt)" :
                               info.color === "badge-orange" ? "var(--orange-lt)" :
                               info.color === "badge-red" ? "var(--red-lt)" :
                               "var(--bg2)")
                            : "var(--white)",
                          color: has
                            ? (info.color === "badge-blue" ? "var(--blue)" :
                               info.color === "badge-purple" ? "var(--purple)" :
                               info.color === "badge-green" ? "var(--green)" :
                               info.color === "badge-gold" ? "var(--gold)" :
                               info.color === "badge-orange" ? "var(--orange)" :
                               info.color === "badge-red" ? "var(--red)" :
                               "var(--text3)")
                            : "var(--text4)",
                          fontSize: ".7rem", fontWeight: 700, cursor: isSA ? "default" : "pointer",
                          opacity: has ? 1 : 0.5,
                          transition: "all .15s",
                          fontFamily: "inherit",
                          letterSpacing: ".01em",
                        }}
                      >
                        {has ? (
                          <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                        ) : (
                          <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" style={{ opacity: 0.4 }}><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
                        )}
                        {info.label}
                      </button>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>

        <div className="info-box mt-3">
          ⚠️ <strong>Note:</strong> Permission changes take effect after the user logs out and back in. Super Admin always has all permissions regardless of this setting.
        </div>
      </div>

      <div className="flex justify-end mt-3">
        <button className="btn btn-primary" onClick={save}>Save Settings</button>
      </div>
    </div>
  );
}

// ─── PRINT HTML GENERATORS ────────────────────────────────────────────────────
function generateSlipHTML(u, s, y, m, settings) {
  const override = u.deductLeaveOverride || "global";
  const shouldDeductLeave = override === "yes" ? true : override === "no" ? false : settings.deductLeave;
  return `<!DOCTYPE html><html><head><title>Salary Slip - ${u.name}</title>
<style>
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:'Segoe UI',Arial,sans-serif;color:#0f172a;background:#fff;padding:0}
.slip{max-width:700px;margin:0 auto;padding:30px}
.hdr{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #0d1b2e;padding-bottom:15px;margin-bottom:20px}
.co{font-size:22px;font-weight:800;color:#0d1b2e}
.slip-title{text-align:right;font-size:13px;color:#64748b}
.slip-title strong{display:block;font-size:16px;color:#0d1b2e;font-weight:700}
.emp-hdr{background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:15px;display:flex;justify-content:space-between;margin-bottom:20px}
.emp-info{font-size:13px}
.emp-name{font-size:17px;font-weight:700;margin-bottom:5px}
.ep{color:#64748b;margin-bottom:3px}
.net-box{text-align:right}
.net-lbl{font-size:12px;color:#64748b}
.net-amt{font-size:24px;font-weight:800;color:#059669;font-family:'Courier New',monospace}
table{width:100%;border-collapse:collapse;margin-bottom:15px}
th{background:#0d1b2e;color:#fff;padding:8px 12px;text-align:left;font-size:12px;letter-spacing:.05em}
td{padding:9px 12px;border-bottom:1px solid #f1f5f9;font-size:13px}
tr:last-child td{border-bottom:none}
.deduct{color:#dc2626;font-weight:600}
.total-row td{border-top:2px solid #0d1b2e;font-weight:700;font-size:14px;background:#f0fdf4}
.footer{margin-top:30px;display:flex;justify-content:space-between;font-size:11px;color:#94a3b8;border-top:1px solid #e2e8f0;padding-top:12px}
.sig-box{margin-top:40px;display:flex;justify-content:space-between}
.sig{text-align:center;width:180px}
.sig-line{border-top:1px solid #94a3b8;padding-top:6px;font-size:12px;color:#64748b}
@media print{body{padding:0}.slip{padding:15px}}
</style></head><body>
<div class="slip">
<div class="hdr">
  <div style="display:flex;align-items:center;gap:12px">
    <img src="${settings.logo || LOGO_B64}" alt="Logo" style="width:60px;height:60px;object-fit:contain" />
    <div>
      <div class="co">${settings.companyName}</div>
      <div style="font-size:13px;color:#64748b;margin-top:3px">Human Resource Department</div>
    </div>
  </div>
  <div class="slip-title"><strong>SALARY SLIP</strong>${new Date(y, m - 1).toLocaleString("default", { month: "long", year: "numeric" })}</div>
</div>
<div class="emp-hdr">
  <div class="emp-info">
    <div class="emp-name">${u.name}</div>
    <div class="ep">Department: ${u.dept}</div>
    <div class="ep">Designation: ${u.role}</div>
    <div class="ep">Joined: ${u.joinDate}</div>
    <div class="ep">Email: ${u.email}</div>
  </div>
  <div class="net-box">
    <div class="net-lbl">NET PAYABLE</div>
    <div class="net-amt">${fmtCurrency(s.netSalary)}</div>
    <div style="font-size:11px;color:#64748b;margin-top:4px">For ${new Date(y, m - 1).toLocaleString("default", { month: "long", year: "numeric" })}</div>
  </div>
</div>
<table>
  <thead><tr><th>Earnings</th><th style="text-align:right">Amount</th></tr></thead>
  <tbody>
    <tr><td>Basic / Gross Base Salary</td><td style="text-align:right;font-family:'Courier New',monospace">${fmtCurrency(s.gross)}</td></tr>
    ${(s.extraIncentives || []).map(ei => `<tr><td style="color:#059669">🎁 ${ei.label}${ei.note ? ` (${ei.note})` : ""}</td><td style="text-align:right;font-family:'Courier New',monospace;color:#059669">+ ${fmtCurrency(ei.amount)}</td></tr>`).join("")}
    ${s.extraIncentivesTotal > 0 ? `<tr style="font-weight:700;background:#f0fdf4"><td>Total Earnings</td><td style="text-align:right;font-family:'Courier New',monospace;color:#059669">${fmtCurrency(s.grossTotal || (s.gross + s.extraIncentivesTotal))}</td></tr>` : ""}
  </tbody>
</table>
<table>
  <thead><tr><th>Attendance Summary</th><th style="text-align:right">Days</th></tr></thead>
  <tbody>
    <tr><td>Working Days in Month</td><td style="text-align:right">${s.workingDays}</td></tr>
    <tr><td>Days Present</td><td style="text-align:right">${s.P}</td></tr>
    <tr><td>Days Absent</td><td style="text-align:right">${s.A}</td></tr>
    <tr><td>Days on Leave</td><td style="text-align:right">${s.L}</td></tr>
    <tr><td>Per Day Rate</td><td style="text-align:right;font-family:'Courier New',monospace">${fmtCurrency(Math.round(s.perDay))}</td></tr>
  </tbody>
</table>
<table>
  <thead><tr><th>Deductions</th><th style="text-align:right">Amount</th></tr></thead>
  <tbody>
    ${s.A > 0 ? `<tr><td class="deduct">Absent Deduction (${s.A} days × ${fmtCurrency(Math.round(s.perDay))})</td><td style="text-align:right;font-family:'Courier New',monospace" class="deduct">- ${fmtCurrency(Math.round(s.A * s.perDay))}</td></tr>` : ""}
    ${shouldDeductLeave && s.L > 0 ? `<tr><td class="deduct">Leave Deduction (${s.L} days × ${fmtCurrency(Math.round(s.perDay))})</td><td style="text-align:right;font-family:'Courier New',monospace" class="deduct">- ${fmtCurrency(Math.round(s.L * s.perDay))}</td></tr>` : ""}
    ${!shouldDeductLeave && s.L > 0 ? `<tr><td style="color:#059669">Leave (${s.L} days — Paid, No Deduction)</td><td style="text-align:right;color:#059669">—</td></tr>` : ""}
    ${(s.extraDeductions || []).map(ed => `<tr><td class="deduct">✂ ${ed.label}${ed.note ? ` (${ed.note})` : ""}</td><td style="text-align:right;font-family:'Courier New',monospace" class="deduct">- ${fmtCurrency(ed.amount)}</td></tr>`).join("")}
    ${s.deductions === 0 ? `<tr><td style="color:#059669">No deductions</td><td style="text-align:right;color:#059669">—</td></tr>` : ""}
    <tr class="total-row"><td>NET PAYABLE SALARY</td><td style="text-align:right;font-family:'Courier New',monospace;color:#059669;font-size:16px">${fmtCurrency(s.netSalary)}</td></tr>
  </tbody>
</table>
<div style="background:#f0f9ff;border:1px solid #bae6fd;border-radius:6px;padding:10px 16px;font-size:11px;color:#0369a1;text-align:center;margin-top:20px">\n  ✦ This is a system-generated document. No physical signature is required for authenticity. ✦\n</div>
<div class="footer">
  <span>Generated: ${new Date().toLocaleString()}</span>
  <span>${settings.companyName} — Confidential Document</span>
</div>
</div></body></html>`;
}

function generateIndividualReportHTML(u, s, y, m, cols, getStatus, settings, deductLeave, hideSalary) {
  const override = u.deductLeaveOverride || "global";
  const shouldDeductLeave = override === "yes" ? true : override === "no" ? false : deductLeave;
  const statusColor = { P: "#dcfce7", A: "#fee2e2", L: "#fef3c7", H: "#ede9fe", WO: "#f1f5f9", "": "#fff" };
  const statusTextColor = { P: "#15803d", A: "#b91c1c", L: "#b45309", H: "#6d28d9", WO: "#94a3b8", "": "#ccc" };
  const rows = cols.map(d => {
    const st = getStatus(d);
    return `<td style="background:${statusColor[st]||"#fff"};color:${statusTextColor[st]||"#ccc"};font-weight:${st&&st!=="WO"?"700":"400"};text-align:center;padding:4px 3px;border:1px solid #e2e8f0;font-size:10px">${st || "·"}</td>`;
  }).join("");

  return `<!DOCTYPE html><html><head><title>Attendance Report - ${u.name}</title>
<style>
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:'Segoe UI',Arial,sans-serif;color:#0f172a;padding:20px;font-size:12px}
.hdr{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #0d1b2e;padding-bottom:12px;margin-bottom:16px}
.co{font-size:20px;font-weight:800;color:#0d1b2e}
h2{font-size:15px;color:#0d1b2e;text-align:right}
.emp-box{background:#f8fafc;border:1px solid #e2e8f0;border-radius:6px;padding:12px;margin-bottom:14px;display:flex;justify-content:space-between}
table{width:100%;border-collapse:collapse;margin-bottom:12px;font-size:10px}
th{background:#0d1b2e;color:#fff;padding:5px 4px;text-align:center}
th:first-child{text-align:left;min-width:140px}
td:first-child{font-weight:600;padding:5px 6px;border:1px solid #e2e8f0;font-size:11px}
.sum-tbl td{padding:7px 10px;border:none;border-bottom:1px solid #f1f5f9;font-size:12px}
.sum-tbl .total{font-weight:700;background:#f0fdf4;border-top:2px solid #0d1b2e}
.footer{margin-top:20px;font-size:10px;color:#94a3b8;border-top:1px solid #e2e8f0;padding-top:8px;display:flex;justify-content:space-between}
</style></head><body>
<div class="hdr">
  <div style="display:flex;align-items:center;gap:10px">
    <img src="${settings.logo || LOGO_B64}" alt="Logo" style="width:52px;height:52px;object-fit:contain" />
    <div><div class="co">${settings.companyName}</div><div style="color:#64748b">Individual Attendance & Salary Report</div></div>
  </div>
  <div><h2>${new Date(y, m - 1).toLocaleString("default", { month: "long", year: "numeric" })}</h2></div>
</div>
<div class="emp-box">
  <div>
    <div style="font-size:16px;font-weight:700">${u.name}</div>
    <div style="color:#64748b;margin-top:3px">${u.dept} · ${u.role} · Joined: ${u.joinDate}</div>
  </div>
  <div style="text-align:right">
    <div style="font-size:12px;color:#64748b">Net Payable Salary</div>
    <div style="font-size:22px;font-weight:800;color:#059669;font-family:'Courier New',monospace">${hideSalary ? "***" : fmtCurrency(s.netSalary)}</div>
    <div style="font-size:11px;color:#94a3b8">Gross: ${hideSalary ? "***" : fmtCurrency(s.gross)} | Deductions: ${hideSalary ? "***" : fmtCurrency(Math.round(s.deductions))}</div>
  </div>
</div>
<div style="font-weight:700;margin-bottom:6px;font-size:12px">ATTENDANCE CALENDAR</div>
<table>
  <thead>
    <tr>
      <th style="text-align:left">Employee</th>
      ${cols.map(d => `<th style="${isOffDay(y, m, d, settings.workDays) ? "background:#374151" : ""}">${d}<br/><span style="font-size:7px;opacity:.7">${dayName(y, m, d)}</span></th>`).join("")}
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>${u.name}<br/><span style="font-size:9px;color:#64748b">${u.dept}</span></td>
      ${rows}
    </tr>
  </tbody>
</table>
<div style="display:flex;gap:16px">
  <div style="flex:1">
    <div style="font-weight:700;margin-bottom:6px;font-size:12px">ATTENDANCE SUMMARY</div>
    <table class="sum-tbl">
      <tr><td>Working Days</td><td style="text-align:right;font-weight:600">${s.workingDays}</td></tr>
      <tr><td>Days Present</td><td style="text-align:right;color:#15803d;font-weight:600">${s.P}</td></tr>
      <tr><td>Days Absent</td><td style="text-align:right;color:#b91c1c;font-weight:600">${s.A}</td></tr>
      <tr><td>Days on Leave</td><td style="text-align:right;color:#b45309;font-weight:600">${s.L}</td></tr>
      <tr><td>Holidays</td><td style="text-align:right;color:#6d28d9;font-weight:600">${s.H}</td></tr>
    </table>
  </div>
  <div style="flex:1">
    <div style="font-weight:700;margin-bottom:6px;font-size:12px">SALARY BREAKDOWN</div>
    <table class="sum-tbl">
      <tr><td>Gross Salary</td><td style="text-align:right;font-family:'Courier New',monospace">${hideSalary ? "***" : fmtCurrency(s.gross)}</td></tr>
      <tr><td>Per Day Rate</td><td style="text-align:right;font-family:'Courier New',monospace">${hideSalary ? "***" : fmtCurrency(Math.round(s.perDay))}</td></tr>
      ${s.A > 0 ? `<tr><td style="color:#b91c1c">Absent Deduction (${s.A}d)</td><td style="text-align:right;color:#b91c1c;font-family:'Courier New',monospace">${hideSalary ? "***" : `- ${fmtCurrency(Math.round(s.A * s.perDay))}`}</td></tr>` : ""}
      ${shouldDeductLeave && s.L > 0 ? `<tr><td style="color:#b45309">Leave Deduction (${s.L}d)</td><td style="text-align:right;color:#b45309;font-family:'Courier New',monospace">${hideSalary ? "***" : `- ${fmtCurrency(Math.round(s.L * s.perDay))}`}</td></tr>` : ""}
      ${!shouldDeductLeave && s.L > 0 ? `<tr><td style="color:#059669">Leave (${s.L}d — Paid)</td><td style="text-align:right;color:#059669">—</td></tr>` : ""}
      ${(s.extraDeductions || []).map(ed => `<tr><td style="color:#dc2626">✂ ${ed.label}${ed.note ? ` (${ed.note})` : ""}</td><td style="text-align:right;color:#dc2626;font-family:'Courier New',monospace">${hideSalary ? "***" : `- ${fmtCurrency(ed.amount)}`}</td></tr>`).join("")}
      <tr class="total"><td>NET PAYABLE</td><td style="text-align:right;color:#059669;font-family:'Courier New',monospace;font-size:14px">${hideSalary ? "***" : fmtCurrency(s.netSalary)}</td></tr>
    </table>
  </div>
</div>
<div style="margin-top:25px;display:flex;justify-content:space-between">
  <div style="background:#f0f9ff;border:1px solid #bae6fd;border-radius:6px;padding:8px 14px;font-size:10px;color:#0369a1;text-align:center;width:100%">✦ System-generated document — No signature required ✦</div>
</div>
<div class="footer"><span>Generated: ${new Date().toLocaleString()}</span><span>CONFIDENTIAL — ${settings.companyName}</span></div>
</body></html>`;
}

function generateGroupReportHTML(grpUsers, y, m, cols, getStatus, calcSalary, settings, dept, deductLeave) {
  const statusColor = { P: "#dcfce7", A: "#fee2e2", L: "#fef3c7", H: "#ede9fe", WO: "#f1f5f9", "": "#fff" };
  const statusTextColor = { P: "#15803d", A: "#b91c1c", L: "#b45309", H: "#6d28d9", WO: "#94a3b8", "": "#ccc" };

  const rows = grpUsers.map(u => {
    const s = calcSalary(u);
    const cells = cols.map(d => {
      const st = getStatus(u.id, d);
      return `<td style="background:${statusColor[st]||"#fff"};color:${statusTextColor[st]||"#ccc"};font-weight:${st&&st!=="WO"?"700":"400"};text-align:center;padding:3px 2px;border:1px solid #e2e8f0;font-size:9px">${st || "·"}</td>`;
    }).join("");
    return `<tr>
      <td style="font-weight:600;padding:5px 6px;border:1px solid #e2e8f0;white-space:nowrap;font-size:10px">${u.name}<br/><span style="font-size:8px;color:#64748b">${u.dept}</span></td>
      ${cells}
      <td style="text-align:center;background:#dcfce7;color:#15803d;font-weight:700;font-size:10px;border:1px solid #e2e8f0">${s.P}</td>
      <td style="text-align:center;background:#fee2e2;color:#b91c1c;font-weight:700;font-size:10px;border:1px solid #e2e8f0">${s.A}</td>
      <td style="text-align:center;font-family:'Courier New',monospace;font-size:10px;font-weight:700;border:1px solid #e2e8f0">${fmtCurrency(s.netSalary)}</td>
    </tr>`;
  }).join("");

  return `<!DOCTYPE html><html><head><title>Group Report</title>
<style>
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:'Segoe UI',Arial,sans-serif;color:#0f172a;padding:15px;font-size:11px}
.hdr{display:flex;justify-content:space-between;border-bottom:3px solid #0d1b2e;padding-bottom:10px;margin-bottom:12px}
.co{font-size:18px;font-weight:800;color:#0d1b2e}
table{width:100%;border-collapse:collapse;font-size:9px}
th{background:#0d1b2e;color:#fff;padding:4px 3px;text-align:center;white-space:nowrap}
th:first-child{text-align:left;min-width:120px}
.footer{margin-top:15px;font-size:9px;color:#94a3b8;border-top:1px solid #e2e8f0;padding-top:8px;display:flex;justify-content:space-between}
@page{size:A3 landscape;margin:10mm}
</style></head><body>
<div class="hdr">
  <div style="display:flex;align-items:center;gap:10px">
    <img src="${settings.logo || LOGO_B64}" alt="Logo" style="width:46px;height:46px;object-fit:contain" />
    <div><div class="co">${settings.companyName}</div><div style="color:#64748b">Group Attendance Report · ${dept === "All" ? "All Departments" : dept}</div></div>
  </div>
  <div style="text-align:right"><div style="font-size:14px;font-weight:700">${new Date(y, m - 1).toLocaleString("default", { month: "long", year: "numeric" })}</div><div style="color:#64748b;font-size:10px">Total: ${grpUsers.length} employees</div></div>
</div>
<table>
  <thead>
    <tr>
      <th style="text-align:left">Employee / Dept</th>
      ${cols.map(d => `<th style="${isOffDay(y, m, d, settings.workDays) ? "background:#374151" : ""}">${d}<br/><span style="font-size:6px">${dayName(y, m, d)}</span></th>`).join("")}
      <th style="background:#065f46">P</th><th style="background:#991b1b">A</th><th>Net Salary</th>
    </tr>
  </thead>
  <tbody>${rows}</tbody>
</table>
<div class="footer"><span>Generated: ${new Date().toLocaleString()}</span><span>CONFIDENTIAL — ${settings.companyName}</span></div>
</body></html>`;
}

function generateSummaryReportHTML(grpUsers, y, m, calcSalary, settings, dept, deductLeave) {
  const totalGross = grpUsers.reduce((s, u) => s + calcSalary(u).gross, 0);
  const totalNet = grpUsers.reduce((s, u) => s + calcSalary(u).netSalary, 0);
  const totalDeduct = grpUsers.reduce((s, u) => s + calcSalary(u).deductions, 0);

  const rows = grpUsers.map((u, i) => {
    const s = calcSalary(u);
    return `<tr style="${i % 2 === 0 ? "" : "background:#f8fafc"}">
      <td style="padding:7px 10px">${i + 1}</td>
      <td style="padding:7px 10px;font-weight:600">${u.name}</td>
      <td style="padding:7px 10px">${u.dept}</td>
      <td style="padding:7px 10px">${u.role}</td>
      <td style="padding:7px 10px;text-align:center;background:#dcfce7;color:#15803d;font-weight:700">${s.P}</td>
      <td style="padding:7px 10px;text-align:center;background:#fee2e2;color:#b91c1c;font-weight:700">${s.A}</td>
      <td style="padding:7px 10px;text-align:center;background:#fef3c7;color:#b45309;font-weight:700">${s.L}</td>
      <td style="padding:7px 10px;text-align:right;font-family:'Courier New',monospace">${fmtCurrency(s.gross)}</td>
      <td style="padding:7px 10px;text-align:right;color:#b91c1c;font-family:'Courier New',monospace">${s.deductions > 0 ? `- ${fmtCurrency(Math.round(s.deductions))}` : "—"}</td>
      <td style="padding:7px 10px;text-align:right;font-family:'Courier New',monospace;font-weight:700;color:#059669">${fmtCurrency(s.netSalary)}</td>
    </tr>`;
  }).join("");

  return `<!DOCTYPE html><html><head><title>Salary Summary</title>
<style>
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:'Segoe UI',Arial,sans-serif;color:#0f172a;padding:25px;font-size:12px}
.hdr{display:flex;justify-content:space-between;border-bottom:3px solid #0d1b2e;padding-bottom:12px;margin-bottom:16px}
.co{font-size:20px;font-weight:800;color:#0d1b2e}
.sum-box{display:flex;gap:16px;margin-bottom:16px}
.sum-card{flex:1;background:#f8fafc;border:1px solid #e2e8f0;border-radius:6px;padding:12px}
.sum-num{font-size:18px;font-weight:800;font-family:'Courier New',monospace}
.sum-lbl{font-size:11px;color:#64748b;margin-top:2px}
table{width:100%;border-collapse:collapse}
th{background:#0d1b2e;color:#fff;padding:8px 10px;text-align:left;font-size:11px;letter-spacing:.03em}
td{border-bottom:1px solid #e2e8f0;font-size:12px}
.total-row td{font-weight:700;background:#f0fdf4;border-top:2px solid #0d1b2e;padding:9px 10px}
.footer{margin-top:20px;font-size:10px;color:#94a3b8;border-top:1px solid #e2e8f0;padding-top:10px;display:flex;justify-content:space-between}
.sig-box{margin-top:30px;display:flex;justify-content:space-between}
.sig{text-align:center;width:160px}
.sig-line{border-top:1px solid #94a3b8;padding-top:5px;font-size:10px;color:#64748b}
@media print{body{padding:15px}}
</style></head><body>
<div class="hdr">
  <div style="display:flex;align-items:center;gap:10px">
    <img src="${settings.logo || LOGO_B64}" alt="Logo" style="width:52px;height:52px;object-fit:contain" />
    <div><div class="co">${settings.companyName}</div><div style="color:#64748b">Monthly Salary Summary — ${dept === "All" ? "All Departments" : dept}</div></div>
  </div>
  <div style="text-align:right"><div style="font-size:14px;font-weight:700">${new Date(y, m - 1).toLocaleString("default", { month: "long", year: "numeric" })}</div><div style="color:#94a3b8;font-size:11px">${grpUsers.length} employees · Leave deduction: ${deductLeave ? "Yes" : "No"}</div></div>
</div>
<div class="sum-box">
  <div class="sum-card"><div class="sum-num">${fmtCurrency(totalGross)}</div><div class="sum-lbl">Total Gross Payroll</div></div>
  <div class="sum-card" style="border-color:#fee2e2"><div class="sum-num" style="color:#dc2626">${fmtCurrency(Math.round(totalDeduct))}</div><div class="sum-lbl">Total Deductions</div></div>
  <div class="sum-card" style="border-color:#d1fae5"><div class="sum-num" style="color:#059669">${fmtCurrency(Math.round(totalNet))}</div><div class="sum-lbl">Total Net Payable</div></div>
</div>
<table>
  <thead><tr><th>#</th><th>Employee Name</th><th>Department</th><th>Designation</th><th style="text-align:center">P</th><th style="text-align:center">A</th><th style="text-align:center">L</th><th style="text-align:right">Gross</th><th style="text-align:right">Deductions</th><th style="text-align:right">Net Payable</th></tr></thead>
  <tbody>
    ${rows}
    <tr class="total-row">
      <td colspan="7">TOTAL (${grpUsers.length} Employees)</td>
      <td style="text-align:right;font-family:'Courier New',monospace">${fmtCurrency(totalGross)}</td>
      <td style="text-align:right;color:#dc2626;font-family:'Courier New',monospace">- ${fmtCurrency(Math.round(totalDeduct))}</td>
      <td style="text-align:right;color:#059669;font-family:'Courier New',monospace;font-size:14px">${fmtCurrency(Math.round(totalNet))}</td>
    </tr>
  </tbody>
</table>
<div style="background:#f0f9ff;border:1px solid #bae6fd;border-radius:6px;padding:10px 16px;font-size:11px;color:#0369a1;text-align:center;margin-top:20px">\n  ✦ This is a system-generated document. No physical signature is required for authenticity. ✦\n</div>
<div class="footer"><span>Generated: ${new Date().toLocaleString()} · Leave Deduction: ${deductLeave ? "Enabled" : "Disabled"}</span><span>CONFIDENTIAL — ${settings.companyName}</span></div>
</body></html>`;
}
// ─── HELPER: generate serial number ──────────────────────────────────────────
function genSerial(prefix, list, year) {
  const y = year || new Date().getFullYear();
  const count = (list || []).length + 1;
  return `${prefix}-${y}-${String(count).padStart(4, "0")}`;
}

// ─── DEFAULT ROW for WO/Quotation ────────────────────────────────────────────
const defaultRow = (extraKeys = []) => {
  const base = { id: uid(), srNo: "", workSpec: "", hsnSac: "", unit: "", qty: "", rate: "", amount: "" };
  extraKeys.forEach(k => { base[k] = ""; });
  return base;
};

// ─── APPOINTMENT LETTER PAGE ──────────────────────────────────────────────────
function AppointmentLetterPage({ appointmentLetters, setAppointmentLetters, loggedIn, users, settings }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [editingLetter, setEditingLetter] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [newLineText, setNewLineText] = useState("");
  const [printingLetter, setPrintingLetter] = useState(null);
  const [selectedPrintProfileId, setSelectedPrintProfileId] = useState("civyx");
  const [showPrintDateTime, setShowPrintDateTime] = useState(false);
  
  const canEdit = loggedIn.role !== "Supervisor";

  const openPrintSelection = (letter) => {
    setPrintingLetter(letter);
    setSelectedPrintProfileId(settings.activeProfileId || "civyx");
  };

  const handlePrintConfirm = () => {
    const chosenProfile = (settings.profiles || []).find(p => p.id === selectedPrintProfileId) || settings;
    const w = window.open("", "_blank");
    w.document.write(generateALHTML(printingLetter, chosenProfile, showPrintDateTime));
    w.document.close();
    setTimeout(() => w.print(), 500);
    setPrintingLetter(null);
  };

  const openEditLetter = (letter) => {
    const compName = settings.companyName || "Civyx Infra";
    const fmtSal = letter.salary ? new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(letter.salary) : "Negotiable";
    setEditingLetter(letter);
    setEditForm({
      issuedDate: letter.issuedDate || today(),
      openingLine: letter.openingLine !== undefined ? letter.openingLine : `We are pleased to offer you the position of <strong>${letter.designation}</strong> in the <strong>${letter.dept}</strong> department at <strong>${compName}</strong>. Your date of joining is confirmed as <strong>${letter.issuedDate}</strong>.`,
      compensationLine: letter.compensationLine !== undefined ? letter.compensationLine : `You will receive a monthly gross salary of <strong>${fmtSal}</strong>, subject to statutory deductions. Details of the salary breakdown will be shared separately by the HR department.`,
      probationLine: letter.probationLine !== undefined ? letter.probationLine : "You will be on probation for a period of fifteen (15) days from your joining date. Upon successful performance review, your employment will be confirmed in writing.",
      dutiesLine: letter.dutiesLine !== undefined ? letter.dutiesLine : "You are expected to perform your duties diligently and maintain high standards of discipline, confidentiality, and professional integrity in line with the company handbook.",
      terminationLine: letter.terminationLine !== undefined ? letter.terminationLine : "Either party can terminate the employment by giving a sixty (60) days written notice or salary in lieu thereof.",
      closingLine: letter.closingLine !== undefined ? letter.closingLine : `We welcome you to our team and wish you a successful career ahead with ${compName}.`,
      customLines: letter.customLines || [],
    });
    setNewLineText("");
  };

  const saveLetter = () => {
    if (!editForm.issuedDate) return showToast("Please select a date", "err");
    setAppointmentLetters(prev => prev.map(al => al.id === editingLetter.id ? { ...al, ...editForm } : al));
    showToast("Appointment letter updated successfully", "ok");
    setEditingLetter(null);
  };

  const addCustomLine = () => {
    if (!newLineText.trim()) return showToast("Please enter some text", "err");
    setEditForm(f => ({ ...f, customLines: [...(f.customLines || []), { id: uid(), text: newLineText.trim() }] }));
    setNewLineText("");
  };

  const removeCustomLine = (id) => {
    setEditForm(f => ({ ...f, customLines: (f.customLines || []).filter(l => l.id !== id) }));
  };

  const [selectedYear, setSelectedYear] = useState("All");

  // Derive unique sorted years from all letters
  const letterYears = useMemo(() => {
    const years = new Set();
    appointmentLetters.forEach(al => {
      const user = users.find(u => u.id === al.userId);
      const y = user?.joinDate
        ? new Date(user.joinDate).getFullYear()
        : new Date(al.issuedDate || today()).getFullYear();
      years.add(y);
    });
    return Array.from(years).sort((a, b) => b - a); // newest first
  }, [appointmentLetters, users]);

  const filteredLetters = appointmentLetters.filter(al => {
    const search = searchTerm.toLowerCase();
    const matchSearch =
      al.userName.toLowerCase().includes(search) ||
      al.serialNo.toLowerCase().includes(search) ||
      (al.designation && al.designation.toLowerCase().includes(search)) ||
      (al.dept && al.dept.toLowerCase().includes(search));
    if (!matchSearch) return false;
    if (selectedYear === "All") return true;
    const user = users.find(u => u.id === al.userId);
    const y = user?.joinDate
      ? new Date(user.joinDate).getFullYear()
      : new Date(al.issuedDate || today()).getFullYear();
    return y === selectedYear;
  });

  return (
    <div>
      <div className="page-hdr">
        <div>
          <div className="page-title">Appointment Letters</div>
          <div className="page-sub">Auto-generated for all employees. Click "Edit Letter" to customize content & add lines. Supervisors have view-only access.</div>
        </div>
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <div style={{ position: "relative" }}>
            <input
              type="text"
              placeholder="Search by name, serial, design…"
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              style={{
                fontSize: ".85rem",
                padding: ".4rem .8rem .4rem 2rem",
                border: "1px solid var(--border2)",
                borderRadius: 8,
                background: "var(--white)",
                width: 250
              }}
            />
            <span style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "var(--text4)", fontSize: 13 }}>🔍</span>
          </div>
        </div>
      </div>

      {/* YEAR TABS */}
      {letterYears.length > 0 && (
        <div style={{
          display: "flex", gap: "4px", flexWrap: "wrap",
          margin: "0 0 16px 0", borderBottom: "2px solid var(--border)", paddingBottom: "0"
        }}>
          {["All", ...letterYears].map(yr => {
            const isActive = selectedYear === yr;
            const count = yr === "All"
              ? appointmentLetters.length
              : appointmentLetters.filter(al => {
                  const u = users.find(u => u.id === al.userId);
                  const y = u?.joinDate ? new Date(u.joinDate).getFullYear() : new Date(al.issuedDate || today()).getFullYear();
                  return y === yr;
                }).length;
            return (
              <button
                key={yr}
                onClick={() => setSelectedYear(yr)}
                style={{
                  padding: ".42rem 1.1rem",
                  fontSize: ".83rem",
                  fontWeight: isActive ? 700 : 500,
                  border: "none",
                  borderBottom: isActive ? "2.5px solid var(--blue)" : "2.5px solid transparent",
                  background: "none",
                  color: isActive ? "var(--blue)" : "var(--text3)",
                  cursor: "pointer",
                  borderRadius: "6px 6px 0 0",
                  transition: "all .15s",
                  display: "flex", alignItems: "center", gap: ".4rem",
                  marginBottom: "-2px"
                }}
              >
                {yr === "All" ? "📋 All Years" : `📅 ${yr}`}
                <span style={{
                  fontSize: ".7rem", fontWeight: 700,
                  background: isActive ? "var(--blue)" : "var(--bg2)",
                  color: isActive ? "#fff" : "var(--text3)",
                  borderRadius: 10, padding: ".05rem .45rem", minWidth: 18, textAlign: "center"
                }}>{count}</span>
              </button>
            );
          })}
        </div>
      )}

      {filteredLetters.length === 0 ? (
        <div className="empty">
          <div className="empty-ic">✉️</div>
          <div className="empty-txt">No appointment letters found.</div>
        </div>
      ) : (
        <div className="tbl-wrap">
          <table>
            <thead>
              <tr>
                <th>Serial No</th>
                <th>Employee Name</th>
                <th>Department</th>
                <th>Designation</th>
                <th>Gross Salary</th>
                <th>Appointment Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredLetters.map(al => (
                <tr key={al.id}>
                  <td className="font-mono" style={{ fontWeight: 700, color: "var(--blue)" }}>{al.serialNo}</td>
                  <td style={{ fontWeight: 600 }}>{al.userName}</td>
                  <td className="text-muted text-sm">{al.dept || "—"}</td>
                  <td className="text-muted text-sm">{al.designation || "—"}</td>
                  <td className="font-mono text-sm">
                    {al.salary ? new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(al.salary) : "Negotiable"}
                  </td>
                  <td style={{ fontWeight: 600, color: "var(--text)" }}>{al.issuedDate}</td>
                  <td>
                    <span className="badge badge-green">{al.status}</span>
                  </td>
                  <td>
                    <div className="tbl-actions">
                      <button className="btn btn-primary btn-xs" onClick={() => openPrintSelection(al)}>
                        <Icon n="print" size={12} /> Print
                      </button>
                      {canEdit ? (
                        <button className="btn btn-ghost btn-xs" onClick={() => openEditLetter(al)}>
                          <Icon n="edit" size={12} /> Edit Letter
                        </button>
                      ) : (
                        <button className="btn btn-ghost btn-xs" disabled style={{ cursor: "not-allowed", opacity: 0.6 }}>
                          <Icon n="lock" size={12} /> View Only
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* EDIT LETTER MODAL */}
      {editingLetter && (
        <div style={{
          position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
          background: "rgba(15, 23, 42, 0.65)", display: "flex",
          alignItems: "center", justifyContent: "center", zIndex: 9999, backdropFilter: "blur(4px)"
        }}>
          <div className="card" style={{
            width: "100%", maxWidth: 680, maxHeight: "92vh", overflowY: "auto",
            boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)", margin: 16
          }}>
            {/* Modal Header */}
            <div className="card-hdr" style={{ borderBottom: "1px solid var(--border)", position: "sticky", top: 0, background: "var(--white)", zIndex: 1 }}>
              <div>
                <div className="card-title" style={{ fontSize: "1.05rem" }}>✏️ Edit Appointment Letter</div>
                <div className="card-sub">{editingLetter.userName} · {editingLetter.serialNo}</div>
              </div>
              <button className="btn btn-ghost btn-xs" onClick={() => setEditingLetter(null)}>✕</button>
            </div>

            <div style={{ padding: "1.2rem", display: "flex", flexDirection: "column", gap: "1.2rem" }}>
              {/* Date */}
              <div className="form-group">
                <label>📅 Date of Appointment</label>
                <input type="date" value={editForm.issuedDate} onChange={e => setEditForm(f => ({ ...f, issuedDate: e.target.value }))} />
              </div>

              {/* Opening Line */}
              <div className="form-group">
                <label style={{ display: "flex", alignItems: "center", gap: ".4rem" }}>
                  📝 Opening Paragraph
                  <span style={{ fontSize: ".68rem", background: "var(--blue-lt)", color: "var(--blue)", borderRadius: 10, padding: ".1rem .5rem", fontWeight: 600 }}>Editable</span>
                </label>
                <textarea
                  value={editForm.openingLine}
                  onChange={e => setEditForm(f => ({ ...f, openingLine: e.target.value }))}
                  rows={3}
                  style={{ width: "100%", fontSize: ".83rem", border: "1px solid var(--border2)", borderRadius: 6, padding: ".55rem .75rem", fontFamily: "inherit", resize: "vertical", lineHeight: 1.6 }}
                />
                <div style={{ fontSize: ".7rem", color: "var(--text3)", marginTop: 3 }}>Tip: Use HTML like &lt;strong&gt;text&lt;/strong&gt; for bold</div>
              </div>

              {/* Compensation Line */}
              <div className="form-group">
                <label style={{ display: "flex", alignItems: "center", gap: ".4rem" }}>
                  💰 Compensation Clause
                  <span style={{ fontSize: ".68rem", background: "var(--green-lt)", color: "var(--green)", borderRadius: 10, padding: ".1rem .5rem", fontWeight: 600 }}>Editable</span>
                </label>
                <textarea
                  value={editForm.compensationLine}
                  onChange={e => setEditForm(f => ({ ...f, compensationLine: e.target.value }))}
                  rows={2}
                  style={{ width: "100%", fontSize: ".83rem", border: "1px solid var(--border2)", borderRadius: 6, padding: ".55rem .75rem", fontFamily: "inherit", resize: "vertical", lineHeight: 1.6 }}
                />
              </div>

              {/* Probation Line */}
              <div className="form-group">
                <label style={{ display: "flex", alignItems: "center", gap: ".4rem" }}>
                  🕐 Probation Clause
                  <span style={{ fontSize: ".68rem", background: "var(--gold-lt)", color: "var(--gold)", borderRadius: 10, padding: ".1rem .5rem", fontWeight: 600 }}>Editable</span>
                </label>
                <textarea
                  value={editForm.probationLine}
                  onChange={e => setEditForm(f => ({ ...f, probationLine: e.target.value }))}
                  rows={2}
                  style={{ width: "100%", fontSize: ".83rem", border: "1px solid var(--border2)", borderRadius: 6, padding: ".55rem .75rem", fontFamily: "inherit", resize: "vertical", lineHeight: 1.6 }}
                />
              </div>

              {/* Duties Line */}
              <div className="form-group">
                <label style={{ display: "flex", alignItems: "center", gap: ".4rem" }}>
                  📋 Duties & Conduct Clause
                  <span style={{ fontSize: ".68rem", background: "var(--purple-lt)", color: "var(--purple)", borderRadius: 10, padding: ".1rem .5rem", fontWeight: 600 }}>Editable</span>
                </label>
                <textarea
                  value={editForm.dutiesLine}
                  onChange={e => setEditForm(f => ({ ...f, dutiesLine: e.target.value }))}
                  rows={2}
                  style={{ width: "100%", fontSize: ".83rem", border: "1px solid var(--border2)", borderRadius: 6, padding: ".55rem .75rem", fontFamily: "inherit", resize: "vertical", lineHeight: 1.6 }}
                />
              </div>

              {/* Termination Line */}
              <div className="form-group">
                <label style={{ display: "flex", alignItems: "center", gap: ".4rem" }}>
                  ⚠️ Notice Period / Termination Clause
                  <span style={{ fontSize: ".68rem", background: "var(--red-lt)", color: "var(--red)", borderRadius: 10, padding: ".1rem .5rem", fontWeight: 600 }}>Editable</span>
                </label>
                <textarea
                  value={editForm.terminationLine}
                  onChange={e => setEditForm(f => ({ ...f, terminationLine: e.target.value }))}
                  rows={2}
                  style={{ width: "100%", fontSize: ".83rem", border: "1px solid var(--border2)", borderRadius: 6, padding: ".55rem .75rem", fontFamily: "inherit", resize: "vertical", lineHeight: 1.6 }}
                />
              </div>

              {/* Closing Line */}
              <div className="form-group">
                <label style={{ display: "flex", alignItems: "center", gap: ".4rem" }}>
                  🎉 Closing Line
                  <span style={{ fontSize: ".68rem", background: "var(--blue-lt)", color: "var(--blue)", borderRadius: 10, padding: ".1rem .5rem", fontWeight: 600 }}>Editable</span>
                </label>
                <textarea
                  value={editForm.closingLine}
                  onChange={e => setEditForm(f => ({ ...f, closingLine: e.target.value }))}
                  rows={2}
                  style={{ width: "100%", fontSize: ".83rem", border: "1px solid var(--border2)", borderRadius: 6, padding: ".55rem .75rem", fontFamily: "inherit", resize: "vertical", lineHeight: 1.6 }}
                />
              </div>

              {/* Custom Additional Lines */}
              <div>
                <div style={{ fontWeight: 700, fontSize: ".85rem", color: "var(--text2)", marginBottom: ".6rem", display: "flex", alignItems: "center", gap: ".5rem" }}>
                  ➕ Additional Custom Clauses
                  <span style={{ fontSize: ".7rem", background: "var(--navy)", color: "#fff", borderRadius: 10, padding: ".1rem .5rem" }}>
                    {(editForm.customLines || []).length} added
                  </span>
                </div>

                {/* Existing Custom Lines */}
                {(editForm.customLines || []).length > 0 && (
                  <div style={{ display: "flex", flexDirection: "column", gap: ".5rem", marginBottom: ".8rem" }}>
                    {(editForm.customLines || []).map((line, idx) => (
                      <div key={line.id} style={{
                        display: "flex", alignItems: "flex-start", gap: ".5rem",
                        background: "var(--bg3)", border: "1px solid var(--border)", borderRadius: 7, padding: ".55rem .75rem"
                      }}>
                        <span style={{ color: "var(--blue)", fontWeight: 700, fontSize: ".75rem", minWidth: 20, marginTop: 2 }}>{idx + 1}.</span>
                        <textarea
                          value={line.text}
                          onChange={e => {
                            const updated = (editForm.customLines || []).map(l => l.id === line.id ? { ...l, text: e.target.value } : l);
                            setEditForm(f => ({ ...f, customLines: updated }));
                          }}
                          rows={2}
                          style={{ flex: 1, fontSize: ".82rem", border: "1px solid var(--border2)", borderRadius: 5, padding: ".4rem .6rem", fontFamily: "inherit", resize: "vertical", lineHeight: 1.6 }}
                        />
                        <button
                          onClick={() => removeCustomLine(line.id)}
                          style={{ background: "none", border: "none", cursor: "pointer", color: "var(--red)", fontSize: ".9rem", padding: ".2rem", marginTop: 2 }}
                          title="Remove this clause"
                        >✕</button>
                      </div>
                    ))}
                  </div>
                )}

                {/* Add New Custom Line */}
                <div style={{ display: "flex", gap: ".5rem", alignItems: "flex-start" }}>
                  <textarea
                    value={newLineText}
                    onChange={e => setNewLineText(e.target.value)}
                    placeholder="Type a new custom clause or paragraph to add to the letter…"
                    rows={2}
                    style={{ flex: 1, fontSize: ".82rem", border: "1px dashed var(--border2)", borderRadius: 6, padding: ".5rem .7rem", fontFamily: "inherit", resize: "vertical", lineHeight: 1.6 }}
                  />
                  <button className="btn btn-primary btn-sm" onClick={addCustomLine} style={{ marginTop: 2, whiteSpace: "nowrap" }}>
                    + Add Clause
                  </button>
                </div>
              </div>

              {/* Actions */}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: ".5rem", paddingTop: "1rem", borderTop: "1px solid var(--border)" }}>
                <button className="btn btn-ghost" onClick={() => setEditingLetter(null)}>Cancel</button>
                <button className="btn btn-primary" onClick={saveLetter}><Icon n="mark" size={13} /> Save Letter</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* SELECT PROFILE AND PRINT MODAL */}
      {printingLetter && (
        <div style={{
          position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
          background: "rgba(15, 23, 42, 0.6)", display: "flex",
          alignItems: "center", justifyContent: "center", zIndex: 9999, backdropFilter: "blur(4px)"
        }}>
          <div className="card" style={{ width: "100%", maxWidth: 420, boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)", margin: 20 }}>
            <div className="card-hdr" style={{ borderBottom: "1px solid var(--border)" }}>
              <div className="card-title" style={{ fontSize: "1.1rem" }}>Print Appointment Letter</div>
              <div className="card-sub">Choose a company profile for printing this document</div>
            </div>
            <div style={{ padding: "1.2rem" }}>
              <div className="form-group mb-3">
                <label>Employee Name</label>
                <div style={{ fontWeight: 600, fontSize: "1rem", color: "var(--blue)" }}>{printingLetter.userName}</div>
              </div>
              <div className="form-group mb-3">
                <label>Select Company Profile</label>
                <select
                  value={selectedPrintProfileId}
                  onChange={e => setSelectedPrintProfileId(e.target.value)}
                  style={{
                    fontSize: ".85rem", padding: ".45rem .8rem", borderRadius: 6,
                    border: "1px solid var(--border2)", background: "var(--white)", width: "100%", cursor: "pointer"
                  }}
                >
                  {(settings.profiles || []).map(p => (
                    <option key={p.id} value={p.id}>{p.companyName}</option>
                  ))}
                </select>
              </div>

              {/* Print Date/Time Toggle */}
              <div style={{
                display: "flex", alignItems: "center", gap: ".65rem",
                marginTop: "1rem", padding: ".65rem .85rem",
                background: "var(--bg3)", borderRadius: 8, border: "1px solid var(--border)"
              }}>
                <input
                  type="checkbox"
                  id="chk-print-datetime"
                  checked={showPrintDateTime}
                  onChange={e => setShowPrintDateTime(e.target.checked)}
                  style={{ width: 16, height: 16, cursor: "pointer", accentColor: "var(--blue)" }}
                />
                <label htmlFor="chk-print-datetime" style={{ fontSize: ".85rem", fontWeight: 500, color: "var(--text2)", cursor: "pointer", userSelect: "none" }}>
                  🖨️ Show print date &amp; time on letter footer
                </label>
              </div>

              <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "1.2rem" }}>
                <button className="btn btn-ghost" onClick={() => setPrintingLetter(null)}>Cancel</button>
                <button className="btn btn-primary" onClick={handlePrintConfirm}>
                  <Icon n="print" size={13} /> Print Now
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
// ─── WORK ORDER PAGE ──────────────────────────────────────────────────────────
function WorkOrderPage({ workOrders, setWorkOrders, loggedIn, settings }) {
  const [view, setView] = useState("list"); // list | create | edit
  const [current, setCurrent] = useState(null);
  const canEdit = loggedIn.role !== "Supervisor" && loggedIn.role !== "HR Manager";

  const openNew = () => {
    setCurrent({
      id: uid(),
      serialNo: genSerial("WO", workOrders),
      issuedTo: "",
      issuedDate: today(),
      subject: "",
      vendorGstin: "",
      vendorContactName: "",
      vendorContactNo: "",
      vendorRemarks: "",
      showAmount: true,
      columns: ["srNo", "workSpec", "hsnSac", "unit", "qty", "rate", "amount"],
      customCols: [],
      customColLabels: {},
      rows: [defaultRow()],
      notes: "",
      status: "Draft",
      gstEnabled: false,
      gstPercent: 18,
      gstType: "igst",
      createdBy: loggedIn.name,
      createdAt: today(),
    });
    setView("create");
  };

  const openEdit = (wo) => { setCurrent({ ...wo, rows: wo.rows.map(r => ({ ...r })) }); setView("edit"); };

  const save = () => {
    if (!current.issuedTo) return showToast("Issued To is required", "err");
    if (view === "create") {
      setWorkOrders(prev => [...prev, current]);
      showToast("Work Order saved", "ok");
    } else {
      setWorkOrders(prev => prev.map(w => w.id === current.id ? current : w));
      showToast("Work Order updated", "ok");
    }
    setView("list");
    setCurrent(null);
  };

  const del = (id) => { setWorkOrders(prev => prev.filter(w => w.id !== id)); showToast("Deleted"); };

  const print = (wo) => {
    const w = window.open("", "_blank");
    w.document.write(generateWOHTML(wo, settings));
    w.document.close();
    setTimeout(() => w.print(), 500);
  };

  if (view === "list") return (
    <div>
      <div className="page-hdr">
        <div>
          <div className="page-title">Work Orders</div>
          <div className="page-sub">{workOrders.length} total work orders</div>
        </div>
        {canEdit && <button className="btn btn-primary" onClick={openNew}><Icon n="add" size={15}/>New Work Order</button>}
      </div>
      {workOrders.length === 0 ? (
        <div className="empty"><div className="empty-ic">📋</div><div className="empty-txt">No work orders yet. Create your first one.</div></div>
      ) : (
        <div className="tbl-wrap">
          <table>
            <thead><tr><th>Serial No</th><th>Issued To</th><th>Date</th><th>Subject</th><th>Status</th><th>Created By</th><th>Actions</th></tr></thead>
            <tbody>
              {workOrders.map(wo => (
                <tr key={wo.id}>
                  <td className="font-mono" style={{fontWeight:700,color:"var(--blue)"}}>{wo.serialNo}</td>
                  <td style={{fontWeight:600}}>{wo.issuedTo}</td>
                  <td className="text-muted text-sm">{wo.issuedDate}</td>
                  <td className="text-sm">{wo.subject || "—"}</td>
                  <td><span className={`badge ${wo.status === "Final" ? "badge-green" : wo.status === "Cancelled" ? "badge-red" : "badge-orange"}`}>{wo.status}</span></td>
                  <td className="text-muted text-sm">{wo.createdBy}</td>
                  <td>
                    <div className="tbl-actions">
                      <button className="btn btn-ghost btn-xs" onClick={() => openEdit(wo)}><Icon n={canEdit ? "edit" : "eye"} size={12}/>{canEdit ? "Edit" : "View"}</button>
                      <button className="btn btn-primary btn-xs" onClick={() => print(wo)}><Icon n="print" size={12}/>Print</button>
                      {canEdit && <button className="btn btn-danger btn-xs" onClick={() => del(wo.id)}><Icon n="del" size={12}/></button>}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );

  return <DocEditor type="workorder" doc={current} setDoc={setCurrent} onSave={save} onCancel={() => setView("list")} readOnly={!canEdit} />;}

// ─── QUOTATION PAGE ───────────────────────────────────────────────────────────
function QuotationPage({ quotations, setQuotations, loggedIn, settings }) {
  const [view, setView] = useState("list");
  const [current, setCurrent] = useState(null);
  const canEdit = loggedIn.role !== "Supervisor" && loggedIn.role !== "HR Manager";

  const openNew = () => {
    setCurrent({
      id: uid(),
      serialNo: genSerial("QT", quotations),
      issuedTo: "",
      issuedDate: today(),
      subject: "",
      vendorGstin: "",
      vendorContactName: "",
      vendorContactNo: "",
      vendorRemarks: "",
      showAmount: true,
      columns: ["srNo", "workSpec", "hsnSac", "unit", "qty", "rate", "amount"],
      customCols: [],
      customColLabels: {},
      rows: [defaultRow()],
      notes: "",
      status: "Draft",
      gstEnabled: false,
      gstPercent: 18,
      gstType: "igst",
      createdBy: loggedIn.name,
      createdAt: today(),
    });
    setView("create");
  };

  const openEdit = (q) => { setCurrent({ ...q, rows: q.rows.map(r => ({ ...r })) }); setView("edit"); };
  const save = () => {
    if (!current.issuedTo) return showToast("Issued To is required", "err");
    if (view === "create") {
      setQuotations(prev => [...prev, current]);
      showToast("Quotation saved", "ok");
    } else {
      setQuotations(prev => prev.map(q => q.id === current.id ? current : q));
      showToast("Quotation updated", "ok");
    }
    setView("list");
    setCurrent(null);
  };

  const del = (id) => { setQuotations(prev => prev.filter(q => q.id !== id)); showToast("Deleted"); };

  const print = (q) => {
    const w = window.open("", "_blank");
    w.document.write(generateQTHTML(q, settings));
    w.document.close();
    setTimeout(() => w.print(), 500);
  };

  if (view === "list") return (
    <div>
      <div className="page-hdr">
        <div>
          <div className="page-title">Quotations</div>
          <div className="page-sub">{quotations.length} total quotations</div>
        </div>
        {canEdit && <button className="btn btn-primary" onClick={openNew}><Icon n="add" size={15}/>New Quotation</button>}
      </div>
      {quotations.length === 0 ? (
        <div className="empty"><div className="empty-ic">📄</div><div className="empty-txt">No quotations yet. Create your first one.</div></div>
      ) : (
        <div className="tbl-wrap">
          <table>
            <thead><tr><th>Serial No</th><th>Issued To</th><th>Date</th><th>Subject</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>
              {quotations.map(q => (
                <tr key={q.id}>
                  <td className="font-mono" style={{fontWeight:700,color:"var(--purple)"}}>{q.serialNo}</td>
                  <td style={{fontWeight:600}}>{q.issuedTo}</td>
                  <td className="text-muted text-sm">{q.issuedDate}</td>
                  <td className="text-sm">{q.subject || "—"}</td>
                  <td><span className={`badge ${q.status === "Accepted" ? "badge-green" : q.status === "Rejected" ? "badge-red" : q.status === "Sent" ? "badge-blue" : "badge-orange"}`}>{q.status}</span></td>
                  <td>
                    <div className="tbl-actions">
                      <button className="btn btn-ghost btn-xs" onClick={() => openEdit(q)}><Icon n={canEdit ? "edit" : "eye"} size={12}/>{canEdit ? "Edit" : "View"}</button>
                      <button className="btn btn-primary btn-xs" onClick={() => print(q)}><Icon n="print" size={12}/>Print</button>
                      {canEdit && <button className="btn btn-danger btn-xs" onClick={() => del(q.id)}><Icon n="del" size={12}/></button>}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );

  return <DocEditor type="quotation" doc={current} setDoc={setCurrent} onSave={save} onCancel={() => setView("list")} readOnly={!canEdit} />;
}

// ─── SHARED DOC EDITOR (Work Order + Quotation) ────────────────────────────────
const BASE_COL_LABELS = { srNo: "Sr. No", workSpec: "Work Specifications", hsnSac: "HSN/SAC Code", unit: "Unit", qty: "Qty", rate: "Rate", amount: "Amount" };
const COL_LABELS = BASE_COL_LABELS; // kept for compat; custom cols use doc.customColLabels
const ALL_COLS = ["srNo", "workSpec", "hsnSac", "unit", "qty", "rate", "amount"];

// ─── RICH TEXT TOOLBAR ───────────────────────────────────────────────────────
function RichToolbar({ onFormat }) {
  // execCommand fontSize uses 1-7 scale; map to readable labels
  const FONT_SIZES = [
    { label: "10px", val: "1" }, { label: "12px", val: "2" }, { label: "14px", val: "3" },
    { label: "16px", val: "4" }, { label: "18px", val: "5" }, { label: "24px", val: "6" }, { label: "32px", val: "7" },
  ];
  const COLORS = ["#0f172a","#1854d4","#059669","#dc2626","#d97706","#7c3aed","#0891b2","#be185d"];
  const [selSize, setSelSize] = useState("3");
  const [selColor, setSelColor] = useState("#0f172a");
  return (
    <div style={{ display:"flex", alignItems:"center", gap:".4rem", flexWrap:"wrap", background:"var(--bg3)", border:"1px solid var(--border)", borderRadius:"6px 6px 0 0", padding:".4rem .7rem", borderBottom:"none" }}>
      <button onClick={() => onFormat("bold")} title="Bold" style={{ fontWeight:800, width:28, height:28, borderRadius:4, border:"1px solid var(--border2)", background:"var(--white)", cursor:"pointer", fontSize:"1rem", color:"var(--text)", display:"flex", alignItems:"center", justifyContent:"center" }}>B</button>
      <button onClick={() => onFormat("italic")} title="Italic" style={{ fontStyle:"italic", width:28, height:28, borderRadius:4, border:"1px solid var(--border2)", background:"var(--white)", cursor:"pointer", fontSize:"1rem", color:"var(--text)", display:"flex", alignItems:"center", justifyContent:"center" }}>I</button>
      <button onClick={() => onFormat("underline")} title="Underline" style={{ textDecoration:"underline", width:28, height:28, borderRadius:4, border:"1px solid var(--border2)", background:"var(--white)", cursor:"pointer", fontSize:"1rem", color:"var(--text)", display:"flex", alignItems:"center", justifyContent:"center" }}>U</button>
      <div style={{ width:1, height:20, background:"var(--border2)", margin:"0 .2rem" }} />
      <select value={selSize} onChange={e => { setSelSize(e.target.value); onFormat("size", e.target.value); }} style={{ fontSize:".75rem", padding:".2rem .4rem", border:"1px solid var(--border2)", borderRadius:4, background:"var(--white)", width:70, cursor:"pointer" }}>
        {FONT_SIZES.map(s => <option key={s.val} value={s.val}>{s.label}</option>)}
      </select>
      <div style={{ width:1, height:20, background:"var(--border2)", margin:"0 .2rem" }} />
      <div style={{ display:"flex", gap:".2rem", alignItems:"center" }}>
        {COLORS.map(c => (
          <button key={c} onClick={() => { setSelColor(c); onFormat("color", c); }} title={c}
            style={{ width:18, height:18, borderRadius:"50%", background:c, border: selColor === c ? "2.5px solid #0f172a" : "1px solid var(--border2)", cursor:"pointer", padding:0, flexShrink:0 }} />
        ))}
      </div>
      <span style={{ fontSize:".68rem", color:"var(--text3)", marginLeft:".3rem" }}>Select text first, then format</span>
    </div>
  );
}

function DocEditor({ type, doc, setDoc, onSave, onCancel, readOnly = false }) {
  const isWO = type === "workorder";
  const [newColName, setNewColName] = useState("");
  const [dragCol, setDragCol] = useState(null);
  const [tableMode, setTableMode] = useState("builtin"); // "builtin" | "excel"
  const [excelPasteText, setExcelPasteText] = useState("");
  const [excelPreview, setExcelPreview] = useState(null); // array of arrays
  const [headerRowIdx, setHeaderRowIdx] = useState(null); // null = no header, 0+ = index of header row
  const [detectedColMap, setDetectedColMap] = useState(null); // { excelIdx -> colKey }
  const [addItemModal, setAddItemModal] = useState(false);
  const [addItemDraft, setAddItemDraft] = useState({ srNo: "", workSpec: "", hsnSac: "", unit: "", qty: "", rate: "" });

  // ── PROPER TSV parser: handles quoted fields with embedded newlines/tabs ──
  const parseTSV = (text) => {
    const rows = [];
    let row = [];
    let cell = '';
    let inQuotes = false;
    for (let i = 0; i < text.length; i++) {
      const ch = text[i];
      const next = text[i + 1];
      if (inQuotes) {
        if (ch === '"' && next === '"') { cell += '"'; i++; }      // escaped quote ""
        else if (ch === '"') { inQuotes = false; }                  // end quote
        else { cell += ch; }                                         // content inside quotes
      } else {
        if (ch === '"') { inQuotes = true; }
        else if (ch === '\t') { row.push(cell); cell = ''; }
        else if (ch === '\n' || (ch === '\r' && next === '\n')) {
          if (ch === '\r') i++;
          row.push(cell); rows.push(row); row = []; cell = '';
        } else if (ch === '\r') { row.push(cell); rows.push(row); row = []; cell = ''; }
        else { cell += ch; }
      }
    }
    if (cell !== '' || row.length > 0) { row.push(cell); rows.push(row); }
    return rows.filter(r => r.length > 0); // remove fully-empty rows
  };

  // ── Clean number values: remove commas, currency symbols ──
  const cleanNum = (val) => {
    if (!val) return '';
    const s = val.replace(/[,₹$€£\s]/g, '').trim();
    return s === '' ? '' : s;
  };

  // ── Column label alias map ──
  const buildLabelMap = () => {
    const map = {};
    Object.entries(BASE_COL_LABELS).forEach(([key, label]) => {
      map[label.toLowerCase()] = key;
      map[key.toLowerCase()] = key;
    });
    Object.entries(doc.customColLabels || {}).forEach(([key, label]) => {
      map[(label || '').toLowerCase()] = key;
    });
    const aliases = {
      // Sr No
      "sr": "srNo", "sr no": "srNo", "sr.no": "srNo", "s.no": "srNo", "s. no": "srNo",
      "no.": "srNo", "no": "srNo", "#": "srNo", "sl no": "srNo", "sl.no": "srNo", "sn": "srNo",
      // Work Spec
      "description": "workSpec", "item description": "workSpec", "work description": "workSpec",
      "work": "workSpec", "spec": "workSpec", "item": "workSpec", "particulars": "workSpec",
      "details": "workSpec", "scope": "workSpec", "scope of work": "workSpec",
      "material": "workSpec", "material description": "workSpec", "product": "workSpec",
      // HSN/SAC
      "hsn": "hsnSac", "sac": "hsnSac", "hsn code": "hsnSac", "sac code": "hsnSac",
      "hsn/sac": "hsnSac", "hsn sac": "hsnSac", "hsn no": "hsnSac",
      // Unit
      "uom": "unit", "units": "unit", "unit of measure": "unit",
      // Qty
      "quantity": "qty", "nos": "qty", "no. of items": "qty", "number": "qty",
      "count": "qty", "total qty": "qty",
      // Rate
      "price": "rate", "unit price": "rate", "rate/unit": "rate", "unit rate": "rate",
      "per unit": "rate", "basic rate": "rate", "cost": "rate", "unit cost": "rate",
      // Amount
      "total": "amount", "total amount": "amount", "total price": "amount",
      "value": "amount", "amt": "amount", "amount (rs.)": "amount",
      "total value": "amount", "gross": "amount", "net amount": "amount",
    };
    Object.entries(aliases).forEach(([alias, key]) => { map[alias] = key; });
    return map;
  };

  // ── Detect column mapping from a header row ──
  const detectColsFromHeader = (headerCells) => {
    const labelMap = buildLabelMap();
    const activeCols = doc.columns.filter(c => ALL_COLS.includes(c) || (doc.customCols || []).includes(c));
    const colMap = {};
    const usedDocCols = new Set();
    headerCells.forEach((cell, i) => {
      // normalize: collapse whitespace and newlines, lowercase
      const norm = (cell || '').replace(/[\r\n]+/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
      const matched = labelMap[norm];
      if (matched && activeCols.includes(matched) && !usedDocCols.has(matched)) {
        colMap[i] = matched;
        usedDocCols.add(matched);
      }
    });
    return colMap;
  };

  // ── Auto-find best header row index (first row that has the most column matches) ──
  const autoFindHeaderRow = (parsedRows) => {
    let bestIdx = -1;
    let bestScore = 0;
    parsedRows.slice(0, 5).forEach((row, i) => { // check first 5 rows only
      const colMap = detectColsFromHeader(row);
      const score = Object.keys(colMap).length;
      if (score > bestScore) { bestScore = score; bestIdx = i; }
    });
    return bestScore > 0 ? bestIdx : -1; // -1 = no header detected
  };

  const handleExcelTextChange = (text) => {
    setExcelPasteText(text);
    if (!text.trim()) {
      setExcelPreview(null); setDetectedColMap(null); setHeaderRowIdx(null); return;
    }
    const parsed = parseTSV(text);
    setExcelPreview(parsed);
    // Auto-detect header row
    const hdrIdx = autoFindHeaderRow(parsed);
    if (hdrIdx >= 0) {
      setHeaderRowIdx(hdrIdx);
      setDetectedColMap(detectColsFromHeader(parsed[hdrIdx]));
    } else {
      setHeaderRowIdx(null);
      setDetectedColMap(null);
    }
  };

  // ── Import: apply mapping, clean numbers, skip header/title rows ──
  const importExcelData = () => {
    if (!excelPreview || excelPreview.length === 0) return showToast("No data to import", "err");

    const dataStartIdx = headerRowIdx !== null ? headerRowIdx + 1 : 0;
    const dataRows = excelPreview.slice(dataStartIdx).filter(r => r.some(c => (c || '').trim() !== ''));
    if (dataRows.length === 0) return showToast("No data rows found", "err");

    const activeCols = doc.columns.filter(c => ALL_COLS.includes(c) || (doc.customCols || []).includes(c));
    const useAutoMap = headerRowIdx !== null && detectedColMap && Object.keys(detectedColMap).length > 0;
    const numericCols = new Set(["qty", "rate", "amount", "srNo"]);

    const newRows = dataRows.map(cells => {
      const row = defaultRow(doc.customCols || []);
      if (useAutoMap) {
        Object.entries(detectedColMap).forEach(([excelIdx, colKey]) => {
          const raw = (cells[parseInt(excelIdx)] || '').trim();
          row[colKey] = numericCols.has(colKey) ? cleanNum(raw) : raw;
        });
      } else {
        activeCols.forEach((col, i) => {
          const raw = (cells[i] || '').trim();
          row[col] = numericCols.has(col) ? cleanNum(raw) : raw;
        });
      }
      // Auto-calc amount
      if (doc.showAmount) {
        const q = parseFloat(row.qty) || 0;
        const rt = parseFloat(row.rate) || 0;
        if (q && rt) row.amount = (q * rt).toFixed(2);
      }
      return row;
    });

    if (newRows.length === 0) return showToast("No valid rows found", "err");
    setDoc(p => ({ ...p, rows: newRows }));
    showToast(`✅ Imported ${newRows.length} rows from Excel`, "ok");
    setExcelPasteText(""); setExcelPreview(null); setDetectedColMap(null); setHeaderRowIdx(null);
    setTableMode("builtin");
  };


  const setField = (k, v) => setDoc(p => ({ ...p, [k]: v }));
  const setRow = (rowId, field, val) => setDoc(p => ({
    ...p,
    rows: p.rows.map(r => {
      if (r.id !== rowId) return r;
      const updated = { ...r, [field]: val };
      if ((field === "qty" || field === "rate") && p.showAmount) {
        const q = parseFloat(field === "qty" ? val : r.qty) || 0;
        const rt = parseFloat(field === "rate" ? val : r.rate) || 0;
        updated.amount = q && rt ? (q * rt).toFixed(2) : "";
      }
      return updated;
    })
  }));

  const addRow = () => {
    setAddItemDraft({ srNo: "", workSpec: "", hsnSac: "", unit: "", qty: "", rate: "" });
    setAddItemModal(true);
  };
  const confirmAddRow = () => {
    const base = defaultRow(doc.customCols || []);
    const qty = parseFloat(addItemDraft.qty) || 0;
    const rate = parseFloat(addItemDraft.rate) || 0;
    const amount = qty && rate ? (qty * rate).toFixed(2) : "";
    setDoc(p => ({ ...p, rows: [...p.rows, { ...base, ...addItemDraft, amount: doc.showAmount ? amount : base.amount }] }));
    setAddItemModal(false);
  };
  const removeRow = (rowId) => setDoc(p => ({ ...p, rows: p.rows.filter(r => r.id !== rowId) }));

  const toggleCol = (col) => {
    setDoc(p => {
      const cols = p.columns.includes(col)
        ? p.columns.filter(c => c !== col)
        : [...p.columns, col]; // append without re-sorting so user order is preserved
      return { ...p, columns: cols };
    });
  };

  const reorderCols = (fromCol, toCol) => {
    if (fromCol === toCol) return;
    setDoc(p => {
      const cols = [...p.columns];
      const fromIdx = cols.indexOf(fromCol);
      const toIdx = cols.indexOf(toCol);
      if (fromIdx === -1 || toIdx === -1) return p;
      cols.splice(fromIdx, 1);
      cols.splice(toIdx, 0, fromCol);
      return { ...p, columns: cols };
    });
  };

  // Add a custom column
  const addCustomCol = () => {
    const trimmed = newColName.trim();
    if (!trimmed) return showToast("Enter a column name", "err");
    const key = "cc_" + trimmed.toLowerCase().replace(/\s+/g, "_") + "_" + uid().slice(0, 4);
    setDoc(p => ({
      ...p,
      customCols: [...(p.customCols || []), key],
      customColLabels: { ...(p.customColLabels || {}), [key]: trimmed },
      columns: [...p.columns, key],
      rows: p.rows.map(r => ({ ...r, [key]: "" })),
    }));
    setNewColName("");
    showToast(`Column "${trimmed}" added`, "ok");
  };

  const removeCustomCol = (key) => {
    setDoc(p => ({
      ...p,
      customCols: (p.customCols || []).filter(c => c !== key),
      customColLabels: Object.fromEntries(Object.entries(p.customColLabels || {}).filter(([k]) => k !== key)),
      columns: p.columns.filter(c => c !== key),
      rows: p.rows.map(r => { const rr = { ...r }; delete rr[key]; return rr; }),
    }));
  };

  const renameCustomCol = (key, newLabel) => {
    setDoc(p => ({
      ...p,
      customColLabels: { ...(p.customColLabels || {}), [key]: newLabel },
    }));
  };

  // Respect the user-defined order stored in doc.columns
  const allDocCols = doc.columns.filter(c =>
    ALL_COLS.includes(c) || (doc.customCols || []).includes(c)
  );

  const getColLabel = (col) => {
    if (doc.customColLabels && doc.customColLabels[col]) return doc.customColLabels[col];
    return COL_LABELS[col] || col;
  };

  const totalAmount = doc.rows.reduce((s, r) => s + (parseFloat(r.amount) || 0), 0);

  // GST calculations
  const gstEnabled = doc.gstEnabled || false;
  const gstPercent = parseFloat(doc.gstPercent) || 0;
  const gstType = doc.gstType || "igst";
  const gstAmount = gstEnabled ? (totalAmount * gstPercent / 100) : 0;
  const cgstAmount = gstAmount / 2;
  const sgstAmount = gstAmount / 2;
  const grandTotal = totalAmount + gstAmount;

  const statusOptions = isWO
    ? ["Draft", "Issued", "In Progress", "Completed", "Cancelled", "Final"]
    : ["Draft", "Sent", "Accepted", "Rejected", "Expired"];

  return (
    <div>
      {/* ── ADD ITEM MODAL ── */}
      {addItemModal && (
        <div className="overlay" onClick={() => setAddItemModal(false)}>
          <div className="modal modal-lg" onClick={e => e.stopPropagation()} style={{maxWidth:520}}>
            <div className="modal-hdr">
              <div>
                <div className="modal-title">✚ Add Item</div>
                <div className="modal-sub">Fill in item details before adding to the table</div>
              </div>
              <button className="modal-close" onClick={() => setAddItemModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-grid" style={{gridTemplateColumns:"1fr 1fr"}}>
                {doc.columns.includes("srNo") && (
                  <div className="form-group">
                    <label>Sr. No</label>
                    <input
                      value={addItemDraft.srNo}
                      onChange={e => setAddItemDraft(d => ({...d, srNo: e.target.value}))}
                      placeholder="e.g. 1"
                    />
                  </div>
                )}
                {doc.columns.includes("workSpec") && (
                  <div className="form-group full">
                    <label>Work Specifications / Description <span style={{color:"var(--red)"}}>*</span></label>
                    <textarea
                      value={addItemDraft.workSpec}
                      onChange={e => setAddItemDraft(d => ({...d, workSpec: e.target.value}))}
                      placeholder="Enter item description, scope of work, materials, etc."
                      style={{minHeight:100}}
                      autoFocus
                    />
                  </div>
                )}
                {doc.columns.includes("hsnSac") && (
                  <div className="form-group">
                    <label>HSN/SAC Code</label>
                    <input
                      value={addItemDraft.hsnSac}
                      onChange={e => setAddItemDraft(d => ({...d, hsnSac: e.target.value}))}
                      placeholder="e.g. 9954"
                    />
                  </div>
                )}
                {doc.columns.includes("unit") && (
                  <div className="form-group">
                    <label>Unit</label>
                    <input
                      value={addItemDraft.unit}
                      onChange={e => setAddItemDraft(d => ({...d, unit: e.target.value}))}
                      placeholder="e.g. Nos, Sqft, Kg"
                    />
                  </div>
                )}
                {doc.columns.includes("qty") && (
                  <div className="form-group">
                    <label>Qty</label>
                    <input
                      type="number"
                      value={addItemDraft.qty}
                      onChange={e => setAddItemDraft(d => ({...d, qty: e.target.value}))}
                      placeholder="0"
                    />
                  </div>
                )}
                {doc.columns.includes("rate") && (
                  <div className="form-group">
                    <label>Rate</label>
                    <input
                      type="number"
                      value={addItemDraft.rate}
                      onChange={e => setAddItemDraft(d => ({...d, rate: e.target.value}))}
                      placeholder="0.00"
                    />
                  </div>
                )}
                {doc.columns.includes("qty") && doc.columns.includes("rate") && doc.showAmount && (
                  <div className="form-group">
                    <label>Amount (auto)</label>
                    <input
                      readOnly
                      value={
                        (parseFloat(addItemDraft.qty)||0) && (parseFloat(addItemDraft.rate)||0)
                          ? ((parseFloat(addItemDraft.qty)||0) * (parseFloat(addItemDraft.rate)||0)).toFixed(2)
                          : ""
                      }
                      placeholder="Auto-calculated"
                      style={{background:"var(--bg3)",color:"var(--text3)"}}
                    />
                  </div>
                )}
              </div>
              <div className="form-actions">
                <button className="btn btn-ghost" onClick={() => setAddItemModal(false)}>Cancel</button>
                <button
                  className="btn btn-primary"
                  onClick={confirmAddRow}
                  disabled={doc.columns.includes("workSpec") && !addItemDraft.workSpec.trim()}
                >
                  <Icon n="add" size={14}/> Add Item
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="page-hdr">
        <div>
          <div className="page-title">{isWO ? "Work Order" : "Quotation"} Editor</div>
          <div className="page-sub">Serial: <strong>{doc.serialNo}</strong></div>
        </div>
        <div className="flex gap-2">
          <button className="btn btn-ghost" onClick={onCancel}>{readOnly ? "Back" : "Cancel"}</button>
          {!readOnly && <button className="btn btn-primary" onClick={onSave}><Icon n="mark" size={14}/>Save</button>}
        </div>
      </div>

      {/* Header Details */}
      <div className="card mb-3">
        <div className="card-hdr"><div className="card-title">Document Details</div></div>
        <div className="form-grid">
          <div className="form-group">
            <label>Serial Number (Auto)</label>
            <input value={doc.serialNo} onChange={e => setField("serialNo", e.target.value)} disabled={readOnly} />
          </div>
          <div className="form-group">
            <label>Status</label>
            <select value={doc.status} onChange={e => setField("status", e.target.value)} disabled={readOnly}>
              {statusOptions.map(s => <option key={s}>{s}</option>)}
            </select>
          </div>
          <div className="form-group full">
            <label>Issued To (Vendor/Client Name & Address) *</label>
            <input value={doc.issuedTo} onChange={e => setField("issuedTo", e.target.value)} placeholder="Company / Person name, address…" disabled={readOnly} />
          </div>
          <div className="form-group">
            <label>{isWO ? "Issue Date" : "Quotation Date"}</label>
            <input type="date" value={doc.issuedDate} onChange={e => setField("issuedDate", e.target.value)} disabled={readOnly} />
          </div>
          <div className={`form-group ${isWO ? "" : "full"}`}>
            <label>Subject / Reference</label>
            <input value={doc.subject || ""} onChange={e => setField("subject", e.target.value)} placeholder="Brief description of the work…" disabled={readOnly} />
          </div>
        </div>
      </div>

      {/* Vendor / Client Details */}
      <div className="card mb-3">
        <div className="card-hdr">
          <div>
            <div className="card-title">Vendor / Client Details <span style={{ fontSize:".72rem", fontWeight:400, color:"var(--text3)" }}>(Optional — only filled fields will appear on printed document)</span></div>
          </div>
        </div>
        <div className="form-grid">
          <div className="form-group">
            <label>GSTIN / Tax No.</label>
            <input value={doc.vendorGstin || ""} onChange={e => setField("vendorGstin", e.target.value)} placeholder="e.g. 09ASVPK6249E1Z6" disabled={readOnly} />
          </div>
          <div className="form-group">
            <label>Contact Person Name</label>
            <input value={doc.vendorContactName || ""} onChange={e => setField("vendorContactName", e.target.value)} placeholder="e.g. Ramesh Kumar" disabled={readOnly} />
          </div>
          <div className="form-group">
            <label>Contact Number</label>
            <input value={doc.vendorContactNo || ""} onChange={e => setField("vendorContactNo", e.target.value)} placeholder="e.g. +91 98765 43210" disabled={readOnly} />
          </div>
          <div className="form-group">
            <label>Remarks</label>
            <input value={doc.vendorRemarks || ""} onChange={e => setField("vendorRemarks", e.target.value)} placeholder="Any special note or remark about vendor…" disabled={readOnly} />
          </div>
        </div>
      </div>

      {/* Column Config */}
      <div className="card mb-3" style={{ pointerEvents: readOnly ? "none" : "auto" }}>
        <div className="card-hdr">
          <div>
            <div className="card-title">Table Columns</div>
            <div className="card-sub">{readOnly ? "Active columns printed in this document" : "Drag ⠿ to reorder · Click active column to hide · Click inactive to show"}</div>
          </div>
          <div className="toggle" onClick={() => !readOnly && setField("showAmount", !doc.showAmount)}>
            <div className={`toggle-track ${doc.showAmount ? "on" : ""}`}><div className="toggle-thumb"/></div>
            <span className="toggle-label" style={{fontSize:".78rem"}}>Auto-calc Amount</span>
          </div>
        </div>

        {/* ACTIVE columns — draggable to reorder */}
        <div style={{marginBottom:".6rem"}}>
          <div style={{fontSize:".7rem",fontWeight:700,color:"var(--text3)",letterSpacing:".06em",textTransform:"uppercase",marginBottom:".4rem"}}>Active Columns {!readOnly && "(drag to reorder)"}</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:".4rem",minHeight:36,padding:".3rem",borderRadius:8,border:readOnly ? "1px solid var(--border)" : "2px dashed var(--border2)",background:readOnly ? "var(--white)" : "var(--bg3)"}}>
            {allDocCols.length === 0 && <span style={{fontSize:".78rem",color:"var(--text4)",padding:".3rem .5rem"}}>No columns selected</span>}
            {allDocCols.map(col => {
              const isCustom = (doc.customCols || []).includes(col);
              const isDragging = dragCol === col;
              return (
                <div
                  key={col}
                  draggable={!readOnly}
                  onDragStart={() => !readOnly && setDragCol(col)}
                  onDragEnd={() => !readOnly && setDragCol(null)}
                  onDragOver={e => { e.preventDefault(); }}
                  onDrop={e => { e.preventDefault(); if (!readOnly && dragCol && dragCol !== col) reorderCols(dragCol, col); setDragCol(null); }}
                  style={{
                    display:"flex",alignItems:"center",gap:".3rem",
                    padding:".3rem .6rem .3rem .4rem",borderRadius:6,
                    border:`2px solid ${isCustom ? "var(--gold)" : "var(--blue)"}`,
                    background: isDragging ? "var(--bg2)" : isCustom ? "var(--gold-lt)" : "var(--blue-lt)",
                    opacity: isDragging ? 0.45 : 1,
                    cursor: readOnly ? "default" : "grab",userSelect:"none",transition:"opacity .15s",
                  }}
                >
                  {/* Drag handle */}
                  {!readOnly && <span style={{color:"var(--text4)",fontSize:"1rem",lineHeight:1,cursor:"grab",marginRight:".1rem"}}>⠿</span>}
                  {/* Label — editable for custom cols */}
                  {isCustom ? (
                    <input
                      value={(doc.customColLabels || {})[col] || ""}
                      onChange={e => !readOnly && renameCustomCol(col, e.target.value)}
                      onClick={e => e.stopPropagation()}
                      disabled={readOnly}
                      style={{fontSize:".78rem",fontWeight:700,border:"none",background:"transparent",color:"var(--gold)",width:Math.max(56, ((doc.customColLabels||{})[col]||col).length * 8),outline:"none",fontFamily:"inherit",cursor: readOnly ? "default" : "text"}}
                      title={readOnly ? "" : "Click to rename"}
                    />
                  ) : (
                    <span style={{fontSize:".78rem",fontWeight:700,color:"var(--blue)"}}>{COL_LABELS[col]}</span>
                  )}
                  {/* Remove button */}
                  {!readOnly && (
                    <button
                      onClick={e => { e.stopPropagation(); isCustom ? removeCustomCol(col) : toggleCol(col); }}
                      style={{background:"none",border:"none",cursor:"pointer",color:"var(--text4)",fontSize:".8rem",padding:".1rem",lineHeight:1,marginLeft:".1rem"}}
                      title={isCustom ? "Remove column" : "Hide column"}
                    >✕</button>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* INACTIVE built-in columns — click to add back */}
        {!readOnly && ALL_COLS.filter(c => !doc.columns.includes(c)).length > 0 && (
          <div style={{marginBottom:".6rem"}}>
            <div style={{fontSize:".7rem",fontWeight:700,color:"var(--text3)",letterSpacing:".06em",textTransform:"uppercase",marginBottom:".4rem"}}>Hidden Columns (click to show)</div>
            <div style={{display:"flex",flexWrap:"wrap",gap:".4rem"}}>
              {ALL_COLS.filter(c => !doc.columns.includes(c)).map(col => (
                <button key={col} onClick={() => toggleCol(col)}
                  style={{
                    padding:".3rem .75rem",borderRadius:6,fontSize:".78rem",fontWeight:600,
                    fontFamily:"inherit",cursor:"pointer",border:"2px dashed var(--border2)",
                    background:"var(--white)",color:"var(--text4)",transition:"all .15s",
                  }}>
                  + {COL_LABELS[col]}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Add custom column UI */}
        {!readOnly && (
          <div style={{display:"flex",alignItems:"center",gap:".5rem",borderTop:"1px solid var(--border)",paddingTop:".75rem",marginTop:".25rem"}}>
            <span style={{fontSize:".75rem",fontWeight:600,color:"var(--text3)",whiteSpace:"nowrap"}}>➕ Add Custom Column:</span>
            <input
              value={newColName}
              onChange={e => setNewColName(e.target.value)}
              onKeyDown={e => e.key === "Enter" && addCustomCol()}
              placeholder="e.g. Material Code, Discount…"
              style={{flex:1,maxWidth:240,fontSize:".82rem",padding:".35rem .7rem",border:"1px solid var(--border2)",borderRadius:6}}
            />
            <button className="btn btn-gold btn-sm" onClick={addCustomCol}>Add Column</button>
          </div>
        )}
      </div>

      {/* GST Settings */}
      <div className="card mb-3" style={{ pointerEvents: readOnly ? "none" : "auto", opacity: readOnly ? 0.8 : 1 }}>
        <div className="card-hdr">
          <div className="card-title">GST / Tax Settings</div>
          <div className="card-sub">Configure tax applicability for this document</div>
        </div>
        <div style={{display:"flex",flexWrap:"wrap",gap:"1.2rem",alignItems:"flex-start"}}>
          {/* GST On/Off */}
          <div style={{display:"flex",flexDirection:"column",gap:".5rem"}}>
            <div style={{fontSize:".73rem",fontWeight:700,color:"var(--text2)",letterSpacing:".04em",textTransform:"uppercase"}}>GST Applicable</div>
            <div className="toggle" onClick={() => setField("gstEnabled", !gstEnabled)}>
              <div className={`toggle-track ${gstEnabled ? "on" : ""}`}><div className="toggle-thumb"/></div>
              <span className="toggle-label">{gstEnabled ? "Yes — GST Applied" : "No — No Tax"}</span>
            </div>
          </div>

          {gstEnabled && (
            <>
              {/* GST % */}
              <div style={{display:"flex",flexDirection:"column",gap:".5rem"}}>
                <div style={{fontSize:".73rem",fontWeight:700,color:"var(--text2)",letterSpacing:".04em",textTransform:"uppercase"}}>GST Rate (%)</div>
                <div style={{display:"flex",gap:".4rem",flexWrap:"wrap"}}>
                  {[5, 12, 18, 28].map(p => (
                    <button key={p} onClick={() => setField("gstPercent", p)}
                      style={{
                        padding:".3rem .8rem",borderRadius:6,fontSize:".82rem",fontWeight:700,
                        fontFamily:"inherit",cursor:"pointer",border:"2px solid",
                        borderColor: gstPercent === p ? "var(--blue)" : "var(--border2)",
                        background: gstPercent === p ? "var(--blue)" : "var(--white)",
                        color: gstPercent === p ? "#fff" : "var(--text3)",
                        transition:"all .15s"
                      }}>{p}%</button>
                  ))}
                  <div style={{display:"flex",alignItems:"center",gap:".3rem"}}>
                    <input
                      type="number" min={0} max={100} step={0.5}
                      value={doc.gstPercent}
                      onChange={e => setField("gstPercent", e.target.value)}
                      style={{width:72,fontSize:".82rem",padding:".3rem .5rem",border:"1px solid var(--border2)",borderRadius:6}}
                    />
                    <span style={{fontSize:".78rem",color:"var(--text3)"}}>% custom</span>
                  </div>
                </div>
              </div>

              {/* GST Type */}
              <div style={{display:"flex",flexDirection:"column",gap:".5rem"}}>
                <div style={{fontSize:".73rem",fontWeight:700,color:"var(--text2)",letterSpacing:".04em",textTransform:"uppercase"}}>GST Type</div>
                <div style={{display:"flex",gap:".5rem"}}>
                  {[
                    { val:"igst", label:"IGST", sub:"Inter-state (single)" },
                    { val:"cgst_sgst", label:"CGST + SGST", sub:"Intra-state (split)" },
                  ].map(opt => (
                    <div key={opt.val} onClick={() => setField("gstType", opt.val)}
                      style={{
                        padding:".5rem .9rem",borderRadius:8,cursor:"pointer",
                        border:`2px solid ${gstType === opt.val ? "var(--blue)" : "var(--border2)"}`,
                        background: gstType === opt.val ? "var(--blue-lt)" : "var(--white)",
                        transition:"all .15s"
                      }}>
                      <div style={{fontWeight:700,fontSize:".8rem",color: gstType === opt.val ? "var(--blue)" : "var(--text2)"}}>{opt.label}</div>
                      <div style={{fontSize:".68rem",color:"var(--text3)"}}>{opt.sub}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* GST Preview */}
              {totalAmount > 0 && (
                <div style={{background:"var(--blue-lt)",border:"1px solid var(--blue-lt2)",borderRadius:8,padding:".8rem 1.1rem",minWidth:220}}>
                  <div style={{fontSize:".72rem",fontWeight:700,color:"var(--blue)",marginBottom:".45rem",letterSpacing:".05em",textTransform:"uppercase"}}>Tax Preview</div>
                  <div style={{display:"flex",justifyContent:"space-between",fontSize:".8rem",marginBottom:".2rem"}}>
                    <span style={{color:"var(--text2)"}}>Sub-total</span>
                    <span style={{fontFamily:"'JetBrains Mono',monospace",fontWeight:600}}>₹{totalAmount.toFixed(2)}</span>
                  </div>
                  {gstType === "igst" ? (
                    <div style={{display:"flex",justifyContent:"space-between",fontSize:".8rem",marginBottom:".2rem"}}>
                      <span style={{color:"var(--blue)"}}>IGST @ {gstPercent}%</span>
                      <span style={{fontFamily:"'JetBrains Mono',monospace",fontWeight:600,color:"var(--blue)"}}>₹{gstAmount.toFixed(2)}</span>
                    </div>
                  ) : (
                    <>
                      <div style={{display:"flex",justifyContent:"space-between",fontSize:".8rem",marginBottom:".2rem"}}>
                        <span style={{color:"var(--blue)"}}>CGST @ {gstPercent/2}%</span>
                        <span style={{fontFamily:"'JetBrains Mono',monospace",fontWeight:600,color:"var(--blue)"}}>₹{cgstAmount.toFixed(2)}</span>
                      </div>
                      <div style={{display:"flex",justifyContent:"space-between",fontSize:".8rem",marginBottom:".2rem"}}>
                        <span style={{color:"var(--blue)"}}>SGST @ {gstPercent/2}%</span>
                        <span style={{fontFamily:"'JetBrains Mono',monospace",fontWeight:600,color:"var(--blue)"}}>₹{sgstAmount.toFixed(2)}</span>
                      </div>
                    </>
                  )}
                  <div style={{display:"flex",justifyContent:"space-between",fontSize:".88rem",fontWeight:800,borderTop:"1px solid var(--blue-lt2)",paddingTop:".35rem",marginTop:".35rem"}}>
                    <span>Grand Total</span>
                    <span style={{fontFamily:"'JetBrains Mono',monospace",color:"var(--blue)"}}>₹{grandTotal.toFixed(2)}</span>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>


      {/* Table Editor */}
      <div className="card mb-3">
        <div className="card-hdr">
          <div>
            <div className="card-title">Work Items</div>
            <div className="card-sub">{readOnly ? "List of work items in this document" : "Choose how to fill the table — edit row by row or paste directly from Excel"}</div>
          </div>
          {/* Mode Toggle */}
          {!readOnly && (
            <div style={{display:"flex",gap:0,border:"1px solid var(--border2)",borderRadius:8,overflow:"hidden",flexShrink:0}}>
              <button
                onClick={() => setTableMode("builtin")}
                style={{
                  padding:".4rem 1rem",fontFamily:"inherit",fontSize:".78rem",fontWeight:700,
                  cursor:"pointer",border:"none",transition:"all .15s",
                  background: tableMode === "builtin" ? "var(--blue)" : "var(--white)",
                  color: tableMode === "builtin" ? "#fff" : "var(--text3)",
                }}
              >
                ✏️ Built-in Editor
              </button>
              <button
                onClick={() => setTableMode("excel")}
                style={{
                  padding:".4rem 1rem",fontFamily:"inherit",fontSize:".78rem",fontWeight:700,
                  cursor:"pointer",border:"none",transition:"all .15s",
                  background: tableMode === "excel" ? "var(--green)" : "var(--white)",
                  color: tableMode === "excel" ? "#fff" : "var(--text3)",
                  borderLeft:"1px solid var(--border2)",
                }}
              >
                📋 Paste from Excel
              </button>
            </div>
          )}
        </div>

        {/* ── EXCEL PASTE MODE ── */}
        {tableMode === "excel" && (
          <div style={{padding:"0 0 .5rem"}}>
            {/* Instructions */}
            <div style={{background:"var(--blue-lt)",border:"1px solid var(--blue-lt2)",borderRadius:8,padding:".85rem 1rem",marginBottom:".9rem",fontSize:".82rem",color:"var(--blue2)"}}>
              <div style={{fontWeight:700,marginBottom:".35rem"}}>📋 How to paste from Excel:</div>
              <ol style={{paddingLeft:"1.2rem",lineHeight:1.9,margin:0}}>
                <li>Select the cells in Excel — <strong>include headers</strong> and all data rows</li>
                <li>Press <strong>Ctrl+C</strong> to copy</li>
                <li>Click in the paste area below and press <strong>Ctrl+V</strong></li>
                <li><strong>Headers are auto-detected</strong> — columns like "Description", "Unit Price", "Qty", "Total Price" etc. will be matched automatically</li>
                <li>Merged cells, extra columns, and title rows are handled — only matching columns are imported</li>
                <li>Numbers like <code>1,40,800</code> are cleaned automatically</li>
              </ol>
            </div>

            {/* Paste area */}
            <textarea
              value={excelPasteText}
              onChange={e => handleExcelTextChange(e.target.value)}
              placeholder={"Paste your Excel data here (Ctrl+V)…\n\nWorks with:\n• Simple tables\n• Tables with title rows at top\n• Tables with merged cells\n• Indian number format (1,40,800)\n• Any columns — matching is auto-detected from headers"}
              style={{
                width:"100%",minHeight:200,fontSize:".82rem",
                border:"2px dashed var(--border2)",borderRadius:8,
                padding:".75rem .9rem",fontFamily:"'JetBrains Mono',monospace",
                resize:"vertical",background:"var(--bg3)",color:"var(--text)",lineHeight:1.7,
              }}
            />

            {/* Preview */}
            {excelPreview && excelPreview.length > 0 && (() => {
              const dataStartIdx = headerRowIdx !== null ? headerRowIdx + 1 : 0;
              const dataRows = excelPreview.slice(dataStartIdx).filter(r => r.some(c => (c || '').trim()));
              const headerCells = headerRowIdx !== null ? excelPreview[headerRowIdx] : null;
              const useAutoMap = headerRowIdx !== null && detectedColMap && Object.keys(detectedColMap).length > 0;

              let previewCols;
              if (useAutoMap) {
                previewCols = Object.entries(detectedColMap)
                  .sort(([a],[b]) => parseInt(a) - parseInt(b))
                  .map(([ei, colKey]) => ({
                    label: getColLabel(colKey), excelIdx: parseInt(ei), docCol: colKey, matched: true
                  }));
                if (headerCells) {
                  headerCells.forEach((hdr, i) => {
                    if (!detectedColMap[i]) {
                      previewCols.push({ label: (hdr||'').replace(/[\r\n]+/g,' ').trim() || `Col ${i+1}`, excelIdx: i, docCol: null, matched: false });
                    }
                  });
                }
              } else {
                previewCols = allDocCols.map((col, i) => ({ label: getColLabel(col), excelIdx: i, docCol: col, matched: true }));
              }

              return (
                <div style={{marginTop:".9rem"}}>
                  {/* Header row indicator */}
                  {headerRowIdx !== null ? (
                    <div style={{display:"flex",alignItems:"center",gap:".6rem",marginBottom:".6rem",flexWrap:"wrap"}}>
                      <span style={{background:"var(--green-lt)",color:"var(--green)",fontWeight:700,fontSize:".75rem",padding:".25rem .8rem",borderRadius:20,border:"1px solid var(--green-lt2)"}}>
                        ✅ Header auto-detected on row {headerRowIdx + 1} — {Object.keys(detectedColMap||{}).length} column{Object.keys(detectedColMap||{}).length !== 1 ? "s" : ""} matched
                      </span>
                      {headerRowIdx > 0 && (
                        <span style={{background:"var(--orange-lt)",color:"var(--orange)",fontSize:".72rem",padding:".15rem .6rem",borderRadius:20,border:"1px solid var(--orange-lt2)"}}>
                          ⤷ Skipping {headerRowIdx} title row{headerRowIdx > 1 ? "s" : ""} above header
                        </span>
                      )}
                      {allDocCols.filter(c => !Object.values(detectedColMap||{}).includes(c)).map(c => (
                        <span key={c} style={{background:"#fef3c7",color:"#92400e",fontSize:".7rem",padding:".15rem .55rem",borderRadius:20,border:"1px solid #fde68a"}}>
                          ⚠ {getColLabel(c)} not found
                        </span>
                      ))}
                      <button onClick={() => { setHeaderRowIdx(null); setDetectedColMap(null); }}
                        style={{marginLeft:"auto",fontSize:".7rem",color:"var(--text3)",background:"none",border:"1px solid var(--border2)",borderRadius:6,padding:".15rem .5rem",cursor:"pointer"}}>
                        Clear header
                      </button>
                    </div>
                  ) : (
                    <div style={{display:"flex",alignItems:"center",gap:".6rem",marginBottom:".6rem"}}>
                      <span style={{background:"var(--blue-lt)",color:"var(--blue)",fontWeight:700,fontSize:".75rem",padding:".25rem .8rem",borderRadius:20,border:"1px solid var(--blue-lt2)"}}>
                        📐 No header detected — positional mapping (col 1 → {allDocCols[0] ? getColLabel(allDocCols[0]) : "—"}, col 2 → {allDocCols[1] ? getColLabel(allDocCols[1]) : "—"}, …)
                      </span>
                    </div>
                  )}

                  {/* Manual header row picker */}
                  {excelPreview.length > 1 && (
                    <div style={{marginBottom:".6rem",display:"flex",alignItems:"center",gap:".5rem",flexWrap:"wrap"}}>
                      <span style={{fontSize:".73rem",color:"var(--text3)",fontWeight:600}}>Set header row manually:</span>
                      {excelPreview.slice(0, Math.min(6, excelPreview.length)).map((row, i) => (
                        <button key={i}
                          onClick={() => { setHeaderRowIdx(i); setDetectedColMap(detectColsFromHeader(row)); }}
                          style={{
                            fontSize:".7rem",padding:".15rem .55rem",borderRadius:6,cursor:"pointer",fontFamily:"inherit",
                            border:`1px solid ${headerRowIdx === i ? "var(--blue)" : "var(--border2)"}`,
                            background: headerRowIdx === i ? "var(--blue)" : "var(--white)",
                            color: headerRowIdx === i ? "#fff" : "var(--text3)",
                          }}>
                          Row {i+1}
                        </button>
                      ))}
                    </div>
                  )}

                  <div style={{fontSize:".73rem",fontWeight:700,color:"var(--text3)",letterSpacing:".06em",textTransform:"uppercase",marginBottom:".4rem"}}>
                    Preview — {dataRows.length} data row{dataRows.length !== 1 ? "s" : ""} to import
                  </div>

                  <div style={{overflowX:"auto",border:"1px solid var(--border)",borderRadius:8}}>
                    <table style={{width:"100%",borderCollapse:"collapse",fontSize:".75rem"}}>
                      <thead>
                        <tr>
                          {previewCols.map((pc, i) => (
                            <th key={i} style={{
                              background: pc.matched ? "var(--navy)" : "#374151",
                              color: pc.matched ? "#fff" : "#9ca3af",
                              padding:".4rem .6rem",textAlign:"left",whiteSpace:"nowrap",fontWeight:700,
                              borderRight:"1px solid rgba(255,255,255,.1)"
                            }}>
                              {pc.label}
                              {pc.matched && <span style={{display:"block",fontWeight:400,opacity:.6,fontSize:".63rem"}}>Excel col {pc.excelIdx + 1}</span>}
                              {!pc.matched && <span style={{display:"block",fontWeight:400,fontSize:".63rem",color:"#f87171"}}>not imported</span>}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {dataRows.slice(0, 10).map((row, ri) => (
                          <tr key={ri} style={{borderBottom:"1px solid var(--border)"}}>
                            {previewCols.map((pc, ci) => {
                              const raw = (row[pc.excelIdx] || '').trim();
                              // Show cleaned number for numeric cols
                              const numCols = new Set(["qty","rate","amount","srNo"]);
                              const displayVal = pc.docCol && numCols.has(pc.docCol) ? (raw.replace(/[,₹$€£]/g,'') || '') : raw;
                              return (
                                <td key={ci} style={{
                                  padding:".3rem .6rem",maxWidth:180,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",
                                  background: !pc.matched ? "#1f2937" : raw ? "var(--white)" : "var(--bg3)",
                                  color: !pc.matched ? "#6b7280" : raw ? "var(--text)" : "var(--text4)",
                                  fontStyle: !pc.matched ? "italic" : "normal",
                                  borderRight:"1px solid var(--border)",
                                }}>
                                  {displayVal || <em style={{opacity:.35}}>—</em>}
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {dataRows.length > 10 && (
                      <div style={{padding:".45rem .8rem",background:"var(--bg3)",fontSize:".72rem",color:"var(--text3)",textAlign:"center",borderTop:"1px solid var(--border)"}}>
                        …and {dataRows.length - 10} more rows
                      </div>
                    )}
                  </div>
                </div>
              );
            })()}


            {/* Actions */}
            <div style={{display:"flex",gap:".6rem",alignItems:"center",marginTop:".9rem",flexWrap:"wrap"}}>
              <button
                className="btn btn-success"
                onClick={importExcelData}
                disabled={!excelPreview || excelPreview.length === 0}
              >
                <Icon n="mark" size={14}/> Import {excelPreview ? (headerRowIdx !== null ? excelPreview.length - headerRowIdx - 1 : excelPreview.length) : 0} Rows → Replace Table
              </button>
              <button
                className="btn btn-ghost"
                onClick={() => { setExcelPasteText(""); setExcelPreview(null); setHeaderRowIdx(null); setDetectedColMap(null); setTableMode("builtin"); }}
              >
                Cancel
              </button>
              {doc.rows.length > 0 && (
                <span style={{fontSize:".75rem",color:"var(--text3)",marginLeft:".3rem"}}>
                  ⚠️ This will replace {doc.rows.length} existing row{doc.rows.length !== 1 ? "s" : ""}
                </span>
              )}
            </div>
          </div>
        )}

        {/* ── BUILT-IN EDITOR MODE ── */}
        {tableMode === "builtin" && (
          <>
            {!readOnly && (
              <div style={{display:"flex",justifyContent:"flex-end",marginBottom:".5rem"}}>
                <button className="btn btn-success btn-sm" onClick={addRow}><Icon n="add" size={13}/>Add Item</button>
              </div>
            )}
            <div style={{overflowX:"auto"}}>
              <table style={{width:"100%",borderCollapse:"collapse",minWidth:600}}>
                <thead>
                  <tr>
                    {allDocCols.map(col => (
                      <th key={col} style={{background:"var(--navy)",color:"#fff",padding:".5rem .7rem",fontSize:".72rem",textAlign:"left",whiteSpace:"nowrap"}}>
                        {getColLabel(col)}
                      </th>
                    ))}
                    {!readOnly && <th style={{background:"var(--navy)",color:"#fff",padding:".5rem .7rem",fontSize:".72rem",width:40}}></th>}
                  </tr>
                </thead>
                <tbody>
                  {doc.rows.map((row, idx) => (
                    <tr key={row.id} style={{borderBottom:"1px solid var(--border)",verticalAlign:"top"}}>
                      {allDocCols.map(col => {
                        const isCustomCol = (doc.customCols || []).includes(col);
                        const editorId = `cell-rich-${row.id}-${col}`;
                        return (
                          <td key={col} style={{padding:".3rem .4rem"}}>
                            {col === "workSpec" || isCustomCol ? (
                              <>
                                {/* Mini rich-text toolbar for text cells */}
                                {!readOnly && (
                                  <div className="cell-rich-toolbar">
                                    <button
                                      onMouseDown={e => { e.preventDefault(); const el=document.getElementById(editorId); if(el){el.focus();document.execCommand("bold",false,null);} }}
                                      title="Bold" style={{fontWeight:800}}
                                    >B</button>
                                    <button
                                      onMouseDown={e => { e.preventDefault(); const el=document.getElementById(editorId); if(el){el.focus();document.execCommand("italic",false,null);} }}
                                      title="Italic" style={{fontStyle:"italic"}}
                                    >I</button>
                                    <button
                                      onMouseDown={e => { e.preventDefault(); const el=document.getElementById(editorId); if(el){el.focus();document.execCommand("underline",false,null);} }}
                                      title="Underline" style={{textDecoration:"underline"}}
                                    >U</button>
                                    <div style={{width:1,height:16,background:"var(--border2)",margin:"0 .1rem"}} />
                                    <select
                                      defaultValue="3"
                                      onChange={e => { const el=document.getElementById(editorId); if(el){el.focus();document.execCommand("fontSize",false,e.target.value);} }}
                                      style={{fontSize:".68rem",padding:".1rem .25rem",border:"1px solid var(--border2)",borderRadius:3,background:"var(--white)",width:58,cursor:"pointer"}}
                                    >
                                      {[{l:"10px",v:"1"},{l:"12px",v:"2"},{l:"14px",v:"3"},{l:"16px",v:"4"},{l:"18px",v:"5"},{l:"24px",v:"6"},{l:"32px",v:"7"}].map(s=>(
                                        <option key={s.v} value={s.v}>{s.l}</option>
                                      ))}
                                    </select>
                                    <div style={{width:1,height:16,background:"var(--border2)",margin:"0 .1rem"}} />
                                    {["#0f172a","#1854d4","#059669","#dc2626","#d97706","#7c3aed"].map(c=>(
                                      <div key={c} className="color-dot" style={{background:c}}
                                        onMouseDown={e=>{ e.preventDefault(); const el=document.getElementById(editorId); if(el){el.focus();document.execCommand("foreColor",false,c);} }}
                                        title={c}
                                      />
                                    ))}
                                  </div>
                                )}
                                <div
                                  id={editorId}
                                  contentEditable={!readOnly}
                                  suppressContentEditableWarning
                                  className="cell-rich-editor"
                                  onInput={e => setRow(row.id, col, e.currentTarget.innerHTML)}
                                  ref={el => {
                                    if (el && document.activeElement !== el) {
                                      el.innerHTML = row[col] || "";
                                    }
                                  }}
                                  data-placeholder={col === "workSpec" ? "Describe work specifications…" : "Enter value…"}
                                  style={{minHeight: col === "workSpec" ? 70 : 42, background: readOnly ? "var(--bg3)" : "var(--white)"}}
                                />
                              </>
                            ) : (
                              <input
                                value={row[col] || ""}
                                onChange={e => setRow(row.id, col, e.target.value)}
                                disabled={readOnly}
                                style={{width:"100%",fontSize:".82rem",border:"1px solid var(--border2)",borderRadius:4,padding:".3rem .5rem",fontFamily:"inherit",background: readOnly ? "var(--bg3)" : "var(--white)"}}
                                placeholder={col === "srNo" ? String(idx + 1) : ""}
                                type={["qty","rate","amount"].includes(col) ? "number" : "text"}
                                readOnly={(col === "amount" && doc.showAmount) || readOnly}
                              />
                            )}
                          </td>
                        );
                      })}
                      {!readOnly && (
                        <td style={{padding:".3rem .4rem",textAlign:"center"}}>
                          <button onClick={() => removeRow(row.id)} style={{background:"none",border:"none",cursor:"pointer",color:"var(--red)",fontSize:".9rem",padding:".2rem"}}>✕</button>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>

                {doc.columns.includes("amount") && (
                  <tfoot>
                    <tr>
                      <td colSpan={allDocCols.length - 1} style={{padding:".6rem .7rem",textAlign:"right",fontWeight:700,fontSize:".88rem",background:"var(--bg3)"}}>Sub-total:</td>
                      <td style={{padding:".6rem .7rem",fontWeight:800,fontFamily:"'JetBrains Mono',monospace",color:"var(--green)",background:"var(--green-lt)"}}>
                        {totalAmount > 0 ? totalAmount.toFixed(2) : "—"}
                      </td>
                      {!readOnly && <td style={{background:"var(--bg3)"}}></td>}
                    </tr>
                    {gstEnabled && totalAmount > 0 && (
                      gstType === "igst" ? (
                        <tr>
                          <td colSpan={allDocCols.length - 1} style={{padding:".45rem .7rem",textAlign:"right",fontSize:".83rem",background:"var(--blue-lt)",color:"var(--blue)",fontWeight:600}}>IGST @ {gstPercent}%:</td>
                          <td style={{padding:".45rem .7rem",fontFamily:"'JetBrains Mono',monospace",color:"var(--blue)",fontWeight:700,background:"var(--blue-lt)"}}>{gstAmount.toFixed(2)}</td>
                          {!readOnly && <td style={{background:"var(--blue-lt)"}}></td>}
                        </tr>
                      ) : (
                        <>
                          <tr>
                            <td colSpan={allDocCols.length - 1} style={{padding:".35rem .7rem",textAlign:"right",fontSize:".83rem",background:"var(--blue-lt)",color:"var(--blue)",fontWeight:600}}>CGST @ {gstPercent/2}%:</td>
                            <td style={{padding:".35rem .7rem",fontFamily:"'JetBrains Mono',monospace",color:"var(--blue)",fontWeight:700,background:"var(--blue-lt)"}}>{cgstAmount.toFixed(2)}</td>
                            {!readOnly && <td style={{background:"var(--blue-lt)"}}></td>}
                          </tr>
                          <tr>
                            <td colSpan={allDocCols.length - 1} style={{padding:".35rem .7rem",textAlign:"right",fontSize:".83rem",background:"var(--blue-lt)",color:"var(--blue)",fontWeight:600}}>SGST @ {gstPercent/2}%:</td>
                            <td style={{padding:".35rem .7rem",fontFamily:"'JetBrains Mono',monospace",color:"var(--blue)",fontWeight:700,background:"var(--blue-lt)"}}>{sgstAmount.toFixed(2)}</td>
                            {!readOnly && <td style={{background:"var(--blue-lt)"}}></td>}
                          </tr>
                        </>
                      )
                    )}
                    {gstEnabled && totalAmount > 0 && (
                      <tr>
                        <td colSpan={allDocCols.length - 1} style={{padding:".6rem .7rem",textAlign:"right",fontWeight:800,fontSize:".9rem",background:"var(--navy)",color:"#fff"}}>Grand Total:</td>
                        <td style={{padding:".6rem .7rem",fontWeight:800,fontFamily:"'JetBrains Mono',monospace",color:"var(--gold2)",background:"var(--navy)",fontSize:".95rem"}}>{grandTotal.toFixed(2)}</td>
                        {!readOnly && <td style={{background:"var(--navy)"}}></td>}
                      </tr>
                    )}
                  </tfoot>
                )}
              </table>
            </div>
          </>
        )}
      </div>

      {/* Notes with Rich Text Toolbar */}
      <div className="card mb-3">
        <div className="card-hdr">
          <div className="card-title">Notes / Terms & Conditions</div>
          <div className="card-sub">{readOnly ? "Special terms and notes for this document" : "Select text, then use the toolbar to format — No character limit"}</div>
        </div>
        {!readOnly && (
          <RichToolbar onFormat={(tag, val) => {
            const el = document.getElementById("notes-editor");
            if (!el) return;
            el.focus();
            if (tag === "bold") document.execCommand("bold", false, null);
            else if (tag === "italic") document.execCommand("italic", false, null);
            else if (tag === "underline") document.execCommand("underline", false, null);
            else if (tag === "size") document.execCommand("fontSize", false, val);
            else if (tag === "color") document.execCommand("foreColor", false, val);
          }} />
        )}
        <div
          id="notes-editor"
          contentEditable={!readOnly}
          suppressContentEditableWarning
          onInput={e => setField("notes", e.currentTarget.innerHTML)}
          ref={el => {
            if (el && document.activeElement !== el) {
              el.innerHTML = doc.notes || "";
            }
          }}
          style={{
            width:"100%", minHeight:140, fontSize:".85rem",
            border:"1px solid var(--border2)", borderRadius: readOnly ? "6px" : "0 0 6px 6px",
            padding:".7rem .9rem", fontFamily:"inherit", lineHeight:1.6,
            outline:"none", background: readOnly ? "var(--bg3)" : "var(--white)", color:"var(--text)",
            wordBreak:"break-word"
          }}
        />
      </div>

      {/* Actions */}
      <div className="flex justify-end gap-2">
        <button className="btn btn-ghost" onClick={onCancel}>{readOnly ? "Back" : "Cancel"}</button>
        {!readOnly && <button className="btn btn-primary" onClick={onSave}><Icon n="mark" size={14}/>Save {isWO ? "Work Order" : "Quotation"}</button>}
      </div>
    </div>
  );
}

// ─── PRINT: WORK ORDER HTML ────────────────────────────────────────────────────
function generateWOHTML(wo, settings) {
  const compName = settings?.companyName || COMPANY_INFO.name;
  const compLogo = settings?.logo !== undefined ? settings.logo : LOGO_B64;
  const compTagline = settings?.companyTagline !== undefined ? settings.companyTagline : COMPANY_INFO.tagline;
  const compAddress = settings?.companyAddress !== undefined ? settings.companyAddress : COMPANY_INFO.address;
  const compPhone = settings?.companyPhone !== undefined ? settings.companyPhone : COMPANY_INFO.phone;
  const compEmail = settings?.companyEmail !== undefined ? settings.companyEmail : COMPANY_INFO.email;
  const compWebsite = settings?.companyWebsite !== undefined ? settings.companyWebsite : COMPANY_INFO.website;
  const compGstin = settings?.companyGstin !== undefined ? settings.companyGstin : COMPANY_INFO.gstin;

  const detailsLines = [];
  if (compAddress && compAddress.trim()) detailsLines.push(compAddress);
  const contacts = [];
  if (compPhone && compPhone.trim()) contacts.push(`Ph: ${compPhone}`);
  if (compEmail && compEmail.trim()) contacts.push(`Email: ${compEmail}`);
  if (contacts.length > 0) detailsLines.push(contacts.join(" &nbsp;|&nbsp; "));
  if (compWebsite && compWebsite.trim()) detailsLines.push(`Website: ${compWebsite}`);
  if (compGstin && compGstin.trim()) detailsLines.push(`GSTIN: ${compGstin}`);
  const companyDetailsHtml = detailsLines.join("<br/>");

  const totalAmount = wo.rows.reduce((s, r) => s + (parseFloat(r.amount) || 0), 0);
  const allCols = wo.columns.filter(c => ALL_COLS.includes(c) || (wo.customCols || []).includes(c));
  const getLabel = col => (wo.customColLabels && wo.customColLabels[col]) ? wo.customColLabels[col] : (COL_LABELS[col] || col);
  const colsHtml = allCols.map(col => `<th>${getLabel(col)}</th>`).join("");
  const rowsHtml = wo.rows.map((row, idx) => {
    const cells = allCols.map(col => {
      const val = col === "srNo" ? (row[col] || idx + 1) : (row[col] || "");
      return `<td style="vertical-align:top;${col === "workSpec" ? "text-align:left;min-width:200px;" : "text-align:center;"}">${val}</td>`;
    }).join("");
    return `<tr style="border-bottom:1px solid #e2e8f0">${cells}</tr>`;
  }).join("");

  const gstEnabled = wo.gstEnabled || false;
  const gstPercent = parseFloat(wo.gstPercent) || 0;
  const gstType = wo.gstType || "igst";
  const gstAmount = gstEnabled ? (totalAmount * gstPercent / 100) : 0;
  const grandTotal = totalAmount + gstAmount;
  const numCols = allCols.length;

  const gstRows = gstEnabled && totalAmount > 0 ? (
    gstType === "igst"
      ? `<tr style="background:#eff6ff"><td colspan="${numCols - 1}" style="text-align:right;padding:7px 12px;font-weight:600;color:#1854d4">IGST @ ${gstPercent}%</td><td style="text-align:center;padding:7px 12px;color:#1854d4;font-family:'Courier New',monospace;font-weight:700">${gstAmount.toFixed(2)}</td></tr>`
      : `<tr style="background:#eff6ff"><td colspan="${numCols - 1}" style="text-align:right;padding:6px 12px;font-weight:600;color:#1854d4">CGST @ ${gstPercent/2}%</td><td style="text-align:center;padding:6px 12px;color:#1854d4;font-family:'Courier New',monospace;font-weight:700">${(gstAmount/2).toFixed(2)}</td></tr>
         <tr style="background:#eff6ff"><td colspan="${numCols - 1}" style="text-align:right;padding:6px 12px;font-weight:600;color:#1854d4">SGST @ ${gstPercent/2}%</td><td style="text-align:center;padding:6px 12px;color:#1854d4;font-family:'Courier New',monospace;font-weight:700">${(gstAmount/2).toFixed(2)}</td></tr>`
  ) : "";

  const subTotalRow = wo.columns.includes("amount") && totalAmount > 0
    ? `<tr style="background:#f0fdf4;font-weight:700"><td colspan="${numCols - 1}" style="text-align:right;padding:7px 12px;border-top:2px solid #0d1b2e">${gstEnabled ? "SUB-TOTAL" : "TOTAL AMOUNT"}</td><td style="text-align:center;padding:7px 12px;border-top:2px solid #0d1b2e;color:#059669;font-family:'Courier New',monospace">${totalAmount.toFixed(2)}</td></tr>`
    : "";

  const grandTotalRow = gstEnabled && wo.columns.includes("amount") && totalAmount > 0
    ? `<tr style="background:#0d1b2e;font-weight:800;font-size:13px"><td colspan="${numCols - 1}" style="text-align:right;padding:9px 12px;color:#fff">GRAND TOTAL (incl. GST)</td><td style="text-align:center;padding:9px 12px;color:#c9922a;font-family:'Courier New',monospace;font-size:14px">${grandTotal.toFixed(2)}</td></tr>`
    : "";

  const totalRow = subTotalRow + gstRows + grandTotalRow;

  return `<!DOCTYPE html><html><head><title>Work Order ${wo.serialNo}</title>
<style>
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:'Segoe UI',Arial,sans-serif;color:#0f172a;background:#fff;font-size:12px}
.page{max-width:800px;margin:0 auto;padding:30px}
.top-bar{background:#0d1b2e;color:#fff;padding:8px 20px;font-size:11px;letter-spacing:.05em;text-align:right;border-radius:0 0 6px 6px}
.header{display:flex;justify-content:space-between;align-items:flex-start;padding:20px 0 16px;border-bottom:3px solid #0d1b2e;margin-bottom:18px}
.company-block{display:flex;align-items:flex-start;gap:14px}
.company-name{font-size:22px;font-weight:800;color:#0d1b2e;letter-spacing:-.5px}
.company-tagline{font-size:10px;color:#64748b;margin-top:2px;font-style:italic}
.company-details{font-size:10px;color:#64748b;margin-top:6px;line-height:1.7}
.doc-block{text-align:right}
.doc-type{font-size:22px;font-weight:900;color:#1854d4;letter-spacing:2px;text-transform:uppercase}
.doc-serial{font-size:14px;font-weight:700;font-family:'Courier New',monospace;color:#0d1b2e;margin-top:4px}
.doc-date{font-size:11px;color:#64748b;margin-top:3px}
.issued-box{display:flex;gap:20px;margin-bottom:16px}
.issued-card{flex:1;background:#f8fafc;border:1px solid #e2e8f0;border-radius:6px;padding:12px 16px}
.issued-label{font-size:10px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#94a3b8;margin-bottom:4px}
.issued-value{font-size:13px;font-weight:600;color:#0f172a;line-height:1.5}
.subject-bar{background:#1854d4;color:#fff;padding:8px 16px;border-radius:4px;font-size:12px;font-weight:600;margin-bottom:16px;letter-spacing:.02em}
table{width:100%;border-collapse:collapse;margin-bottom:14px}
thead{background:#0d1b2e}
th{color:#fff;padding:8px 12px;font-size:11px;letter-spacing:.05em;text-transform:uppercase;text-align:center}
th:first-child{text-align:left}
td{padding:8px 12px;border-bottom:1px solid #f1f5f9;font-size:12px}
tbody tr:hover{background:#f8fafc}
.notes-section{background:#fffbeb;border:1px solid #fde68a;border-radius:6px;padding:14px 16px;margin-bottom:16px}
.notes-label{font-size:10px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#b45309;margin-bottom:6px}
.notes-text{font-size:12px;color:#0f172a;line-height:1.7}
.footer-bar{display:flex;justify-content:space-between;font-size:10px;color:#94a3b8;border-top:1px solid #e2e8f0;padding-top:10px;margin-top:10px}
.auto-gen-box{background:#f0f9ff;border:1px solid #bae6fd;border-radius:6px;padding:8px 14px;font-size:10px;color:#0369a1;text-align:center;margin-top:14px}
.status-badge{display:inline-block;padding:3px 10px;border-radius:20px;font-size:10px;font-weight:700;background:#dbeafe;color:#1d4ed8;margin-left:8px}
@media print{body{padding:0}.page{padding:15px}.top-bar{display:none}@page{margin:10mm}}
</style></head><body>
<div class="top-bar">${compName.toUpperCase()} · OFFICIAL DOCUMENT · ${new Date().toLocaleDateString()}</div>
<div class="page">
<div class="header">
  <div class="company-block">
    ${compLogo ? `<img src="${compLogo}" alt="${compName}" style="width:64px;height:64px;object-fit:contain"/>` : ""}
    <div>
      <div class="company-name">${compName}</div>
      ${compTagline && compTagline.trim() ? `<div class="company-tagline">${compTagline}</div>` : ""}
      <div class="company-details">
        ${companyDetailsHtml}
      </div>
    </div>
  </div>
  <div class="doc-block">
    <div class="doc-type">Work Order</div>
    <div class="doc-serial">${wo.serialNo}</div>
    <div class="doc-date">Date: ${wo.issuedDate}</div>
    <div class="doc-date" style="margin-top:6px"><span class="status-badge">${wo.status}</span></div>
  </div>
</div>

${wo.subject ? `<div class="subject-bar">Re: ${wo.subject}</div>` : ""}

<div class="issued-box">
  <div class="issued-card">
    <div class="issued-label">Issued To (Vendor / Client)</div>
    <div class="issued-value">${wo.issuedTo}</div>
    ${wo.vendorGstin ? `<div style="font-size:11px;color:#64748b;margin-top:4px"><strong>GSTIN:</strong> ${wo.vendorGstin}</div>` : ""}
    ${wo.vendorContactName ? `<div style="font-size:11px;color:#64748b;margin-top:2px"><strong>Contact:</strong> ${wo.vendorContactName}</div>` : ""}
    ${wo.vendorContactNo ? `<div style="font-size:11px;color:#64748b;margin-top:2px"><strong>Phone:</strong> ${wo.vendorContactNo}</div>` : ""}
    ${wo.vendorRemarks ? `<div style="font-size:11px;color:#b45309;margin-top:4px;background:#fffbeb;padding:4px 8px;border-radius:4px;border:1px solid #fde68a"><strong>Remarks:</strong> ${wo.vendorRemarks}</div>` : ""}
  </div>
  <div class="issued-card" style="flex:0 0 220px">
    <div class="issued-label">Issued By</div>
    <div class="issued-value">${compName}</div>
    <div style="font-size:11px;color:#64748b;margin-top:2px">${wo.createdBy} · ${wo.createdAt}</div>
  </div>
</div>

<table>
  <thead><tr>${colsHtml}</tr></thead>
  <tbody>${rowsHtml}</tbody>
  ${totalRow}
</table>

${wo.notes ? `<div class="notes-section"><div class="notes-label">Notes / Terms & Conditions</div><div class="notes-text">${wo.notes}</div></div>` : ""}

<div class="auto-gen-box">✦ This is a system-generated Work Order. No physical signature is required for authenticity. Reference: ${wo.serialNo} ✦</div>
<div class="footer-bar">
  <span>Generated: ${new Date().toLocaleString()} · ${compName} ERP System</span>
  <span>OFFICIAL DOCUMENT — ${wo.serialNo}</span>
</div>
</div></body></html>`;
}

// ─── PRINT: QUOTATION HTML ─────────────────────────────────────────────────────
function generateQTHTML(q, settings) {
  const compName = settings?.companyName || COMPANY_INFO.name;
  const compLogo = settings?.logo !== undefined ? settings.logo : LOGO_B64;
  const compTagline = settings?.companyTagline !== undefined ? settings.companyTagline : COMPANY_INFO.tagline;
  const compAddress = settings?.companyAddress !== undefined ? settings.companyAddress : COMPANY_INFO.address;
  const compPhone = settings?.companyPhone !== undefined ? settings.companyPhone : COMPANY_INFO.phone;
  const compEmail = settings?.companyEmail !== undefined ? settings.companyEmail : COMPANY_INFO.email;
  const compWebsite = settings?.companyWebsite !== undefined ? settings.companyWebsite : COMPANY_INFO.website;
  const compGstin = settings?.companyGstin !== undefined ? settings.companyGstin : COMPANY_INFO.gstin;

  const detailsLines = [];
  if (compAddress && compAddress.trim()) detailsLines.push(compAddress);
  const contacts = [];
  if (compPhone && compPhone.trim()) contacts.push(`Ph: ${compPhone}`);
  if (compEmail && compEmail.trim()) contacts.push(`Email: ${compEmail}`);
  if (contacts.length > 0) detailsLines.push(contacts.join(" &nbsp;|&nbsp; "));
  if (compWebsite && compWebsite.trim()) detailsLines.push(`Website: ${compWebsite}`);
  if (compGstin && compGstin.trim()) detailsLines.push(`GSTIN: ${compGstin}`);
  const companyDetailsHtml = detailsLines.join("<br/>");

  const totalAmount = q.rows.reduce((s, r) => s + (parseFloat(r.amount) || 0), 0);
  const allCols = q.columns.filter(c => ALL_COLS.includes(c) || (q.customCols || []).includes(c));
  const getLabel = col => (q.customColLabels && q.customColLabels[col]) ? q.customColLabels[col] : (COL_LABELS[col] || col);
  const colsHtml = allCols.map(col => `<th>${getLabel(col)}</th>`).join("");
  const rowsHtml = q.rows.map((row, idx) => {
    const cells = allCols.map(col => {
      const val = col === "srNo" ? (row[col] || idx + 1) : (row[col] || "");
      return `<td style="vertical-align:top;${col === "workSpec" ? "text-align:left;min-width:200px;" : "text-align:center;"}">${val}</td>`;
    }).join("");
    return `<tr style="border-bottom:1px solid #e2e8f0">${cells}</tr>`;
  }).join("");

  const gstEnabled = q.gstEnabled || false;
  const gstPercent = parseFloat(q.gstPercent) || 0;
  const gstType = q.gstType || "igst";
  const gstAmount = gstEnabled ? (totalAmount * gstPercent / 100) : 0;
  const grandTotal = totalAmount + gstAmount;
  const numCols = allCols.length;

  const gstRows = gstEnabled && totalAmount > 0 ? (
    gstType === "igst"
      ? `<tr style="background:#ede9fe"><td colspan="${numCols - 1}" style="text-align:right;padding:7px 12px;font-weight:600;color:#7c3aed">IGST @ ${gstPercent}%</td><td style="text-align:center;padding:7px 12px;color:#7c3aed;font-family:'Courier New',monospace;font-weight:700">${gstAmount.toFixed(2)}</td></tr>`
      : `<tr style="background:#ede9fe"><td colspan="${numCols - 1}" style="text-align:right;padding:6px 12px;font-weight:600;color:#7c3aed">CGST @ ${gstPercent/2}%</td><td style="text-align:center;padding:6px 12px;color:#7c3aed;font-family:'Courier New',monospace;font-weight:700">${(gstAmount/2).toFixed(2)}</td></tr>
         <tr style="background:#ede9fe"><td colspan="${numCols - 1}" style="text-align:right;padding:6px 12px;font-weight:600;color:#7c3aed">SGST @ ${gstPercent/2}%</td><td style="text-align:center;padding:6px 12px;color:#7c3aed;font-family:'Courier New',monospace;font-weight:700">${(gstAmount/2).toFixed(2)}</td></tr>`
  ) : "";

  const subTotalRow = q.columns.includes("amount") && totalAmount > 0
    ? `<tr style="background:#f0fdf4;font-weight:700"><td colspan="${numCols - 1}" style="text-align:right;padding:7px 12px;border-top:2px solid #1854d4">${gstEnabled ? "SUB-TOTAL" : "TOTAL AMOUNT"}</td><td style="text-align:center;padding:7px 12px;border-top:2px solid #1854d4;color:#059669;font-family:'Courier New',monospace">${totalAmount.toFixed(2)}</td></tr>`
    : "";

  const grandTotalRow = gstEnabled && q.columns.includes("amount") && totalAmount > 0
    ? `<tr style="background:linear-gradient(90deg,#1854d4,#7c3aed);font-weight:800;font-size:13px"><td colspan="${numCols - 1}" style="text-align:right;padding:9px 12px;color:#fff">GRAND TOTAL (incl. GST)</td><td style="text-align:center;padding:9px 12px;color:#fef3c7;font-family:'Courier New',monospace;font-size:14px">${grandTotal.toFixed(2)}</td></tr>`
    : "";

  const totalRow = subTotalRow + gstRows + grandTotalRow;

  return `<!DOCTYPE html><html><head><title>Quotation ${q.serialNo}</title>
<style>
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:'Segoe UI',Arial,sans-serif;color:#0f172a;background:#fff;font-size:12px}
.page{max-width:800px;margin:0 auto;padding:30px}
.top-bar{background:linear-gradient(90deg,#1854d4,#7c3aed);color:#fff;padding:8px 20px;font-size:11px;letter-spacing:.05em;text-align:right;border-radius:0 0 6px 6px}
.header{display:flex;justify-content:space-between;align-items:flex-start;padding:20px 0 16px;border-bottom:3px solid #1854d4;margin-bottom:18px}
.company-block{display:flex;align-items:flex-start;gap:14px}
.company-name{font-size:22px;font-weight:800;color:#0d1b2e;letter-spacing:-.5px}
.company-tagline{font-size:10px;color:#64748b;margin-top:2px;font-style:italic}
.company-details{font-size:10px;color:#64748b;margin-top:6px;line-height:1.7}
.doc-block{text-align:right}
.doc-type{font-size:22px;font-weight:900;color:#7c3aed;letter-spacing:2px;text-transform:uppercase}
.doc-serial{font-size:14px;font-weight:700;font-family:'Courier New',monospace;color:#0d1b2e;margin-top:4px}
.doc-date{font-size:11px;color:#64748b;margin-top:3px}
.issued-box{display:flex;gap:20px;margin-bottom:16px}
.issued-card{flex:1;background:#f8fafc;border:1px solid #e2e8f0;border-radius:6px;padding:12px 16px}
.issued-label{font-size:10px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#94a3b8;margin-bottom:4px}
.issued-value{font-size:13px;font-weight:600;color:#0f172a;line-height:1.5}
.subject-bar{background:linear-gradient(90deg,#7c3aed,#1854d4);color:#fff;padding:8px 16px;border-radius:4px;font-size:12px;font-weight:600;margin-bottom:16px}
table{width:100%;border-collapse:collapse;margin-bottom:14px}
thead{background:linear-gradient(90deg,#0d1b2e,#1854d4)}
th{color:#fff;padding:8px 12px;font-size:11px;letter-spacing:.05em;text-transform:uppercase;text-align:center}
th:first-child{text-align:left}
td{padding:8px 12px;border-bottom:1px solid #f1f5f9;font-size:12px}
tbody tr:nth-child(even){background:#f8fafc}
.notes-section{background:#faf5ff;border:1px solid #ddd6fe;border-radius:6px;padding:14px 16px;margin-bottom:16px}
.notes-label{font-size:10px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#7c3aed;margin-bottom:6px}
.notes-text{font-size:12px;color:#0f172a;line-height:1.7}
.validity-box{background:#fffbeb;border:1px solid #fde68a;border-radius:6px;padding:8px 14px;font-size:11px;color:#b45309;font-weight:600;margin-bottom:14px;text-align:center}
.footer-bar{display:flex;justify-content:space-between;font-size:10px;color:#94a3b8;border-top:1px solid #e2e8f0;padding-top:10px;margin-top:10px}
.auto-gen-box{background:#f5f3ff;border:1px solid #ddd6fe;border-radius:6px;padding:8px 14px;font-size:10px;color:#7c3aed;text-align:center;margin-top:14px}
.status-badge{display:inline-block;padding:3px 10px;border-radius:20px;font-size:10px;font-weight:700;background:#ede9fe;color:#7c3aed;margin-left:8px}
@media print{body{padding:0}.page{padding:15px}.top-bar{display:none}@page{margin:10mm}}
</style></head><body>
<div class="top-bar">${compName.toUpperCase()} · QUOTATION · ${new Date().toLocaleDateString()}</div>
<div class="page">
<div class="header">
  <div class="company-block">
    ${compLogo ? `<img src="${compLogo}" alt="${compName}" style="width:64px;height:64px;object-fit:contain"/>` : ""}
    <div>
      <div class="company-name">${compName}</div>
      ${compTagline && compTagline.trim() ? `<div class="company-tagline">${compTagline}</div>` : ""}
      <div class="company-details">
        ${companyDetailsHtml}
      </div>
    </div>
  </div>
  <div class="doc-block">
    <div class="doc-type">Quotation</div>
    <div class="doc-serial">${q.serialNo}</div>
    <div class="doc-date">Date: ${q.issuedDate}</div>
    <div class="doc-date" style="margin-top:6px"><span class="status-badge">${q.status}</span></div>
  </div>
</div>

${q.subject ? `<div class="subject-bar">Re: ${q.subject}</div>` : ""}

<div class="issued-box">
  <div class="issued-card">
    <div class="issued-label">Quotation For (Vendor / Client)</div>
    <div class="issued-value">${q.issuedTo}</div>
    ${q.vendorGstin ? `<div style="font-size:11px;color:#64748b;margin-top:4px"><strong>GSTIN:</strong> ${q.vendorGstin}</div>` : ""}
    ${q.vendorContactName ? `<div style="font-size:11px;color:#64748b;margin-top:2px"><strong>Contact:</strong> ${q.vendorContactName}</div>` : ""}
    ${q.vendorContactNo ? `<div style="font-size:11px;color:#64748b;margin-top:2px"><strong>Phone:</strong> ${q.vendorContactNo}</div>` : ""}
    ${q.vendorRemarks ? `<div style="font-size:11px;color:#b45309;margin-top:4px;background:#fffbeb;padding:4px 8px;border-radius:4px;border:1px solid #fde68a"><strong>Remarks:</strong> ${q.vendorRemarks}</div>` : ""}
  </div>
  <div class="issued-card" style="flex:0 0 220px">
    <div class="issued-label">Prepared By</div>
    <div class="issued-value">${compName}</div>
    <div style="font-size:11px;color:#64748b;margin-top:2px">${q.createdBy} · ${q.createdAt}</div>
  </div>
</div>

<table>
  <thead><tr>${colsHtml}</tr></thead>
  <tbody>${rowsHtml}</tbody>
  ${totalRow}
</table>

${q.notes ? `<div class="notes-section"><div class="notes-label">Terms, Conditions & Notes</div><div class="notes-text">${q.notes}</div></div>` : ""}

<div class="auto-gen-box">✦ This is a system-generated Quotation. No physical signature is required for authenticity. Reference: ${q.serialNo} ✦</div>
<div class="footer-bar">
  <span>Generated: ${new Date().toLocaleString()} · ${compName} ERP System</span>
  <span>OFFICIAL QUOTATION — ${q.serialNo}</span>
</div>
</div></body></html>`;
}

// ─── APPOINTMENT LETTER HTML TEMPLATE ─────────────────────────────────────────
function generateALHTML(letter, settings, showPrintDateTime = false) {
  const compName = settings?.companyName || COMPANY_INFO.name;
  const compTagline = settings?.companyTagline !== undefined ? settings.companyTagline : COMPANY_INFO.tagline;
  const compAddress = settings?.companyAddress !== undefined ? settings.companyAddress : COMPANY_INFO.address;
  const compPhone = settings?.companyPhone !== undefined ? settings.companyPhone : COMPANY_INFO.phone;
  const compEmail = settings?.companyEmail !== undefined ? settings.companyEmail : COMPANY_INFO.email;
  const compWebsite = settings?.companyWebsite !== undefined ? settings.companyWebsite : COMPANY_INFO.website;
  const compLogo = settings?.logo !== undefined ? settings.logo : LOGO_B64;

  const detailsLines = [];
  if (compAddress && compAddress.trim()) detailsLines.push(compAddress);
  const contacts = [];
  if (compPhone && compPhone.trim()) contacts.push(`Ph: ${compPhone}`);
  if (compEmail && compEmail.trim()) contacts.push(`Email: ${compEmail}`);
  if (contacts.length > 0) detailsLines.push(contacts.join(" &nbsp;|&nbsp; "));
  if (compWebsite && compWebsite.trim()) detailsLines.push(`Website: ${compWebsite}`);
  const companyDetailsHtml = detailsLines.join("<br/>");

  const fmtSalary = letter.salary ? new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(letter.salary) : "Negotiable";

  return `<!DOCTYPE html><html><head><title>Appointment Letter - ${letter.userName}</title>
<style>
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:'Segoe UI',Arial,sans-serif;color:#0f172a;line-height:1.6;background:#fff;padding:0}
.doc{max-width:800px;margin:0 auto;padding:40px}
.hdr{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #0d1b2e;padding-bottom:18px;margin-bottom:25px}
.company-block{display:flex;align-items:center;gap:15px}
.company-name{font-size:22px;font-weight:800;color:#0d1b2e;letter-spacing:-.02em}
.company-tagline{font-size:11px;color:#64748b;font-weight:600;margin-top:2px}
.company-details{font-size:11px;color:#64748b;margin-top:6px;line-height:1.4}
.doc-block{text-align:right}
.doc-type{font-size:20px;font-weight:800;color:#0d1b2e;text-transform:uppercase;letter-spacing:.05em}
.doc-serial{font-family:'Courier New',monospace;font-size:14px;font-weight:700;color:#1e3a8a;margin-top:3px}
.doc-date{font-size:12px;color:#64748b;margin-top:4px}
.salutation{margin-top:25px;font-weight:700;font-size:14px}
.recipient{margin-bottom:20px;font-size:13px;line-height:1.5}
.body-text{font-size:13.5px;color:#334155;text-align:justify;margin-bottom:20px}
.body-text p{margin-bottom:12px}
.terms-list{margin:15px 0 25px 20px;font-size:13px;color:#334155}
.terms-list li{margin-bottom:8px}
.sig-box{margin-top:50px;display:flex;justify-content:space-between}
.sig{text-align:center;width:200px}
.sig-line{border-top:1px solid #94a3b8;padding-top:6px;font-size:12px;color:#64748b;font-weight:600}
.footer-bar{margin-top:50px;font-size:10px;color:#94a3b8;border-top:1px solid #e2e8f0;padding-top:12px;display:flex;justify-content:space-between}
@media print{body{padding:0}.doc{padding:15px}}
</style></head><body>
<div class="doc">
  <div class="hdr">
    <div class="company-block">
      ${compLogo ? `<img src="${compLogo}" alt="${compName}" style="width:64px;height:64px;object-fit:contain"/>` : ""}
      <div>
        <div class="company-name">${compName}</div>
        ${compTagline && compTagline.trim() ? `<div class="company-tagline">${compTagline}</div>` : ""}
        <div class="company-details">
          ${companyDetailsHtml}
        </div>
      </div>
    </div>
    <div class="doc-block">
      <div class="doc-type">Appointment Letter</div>
      <div class="doc-serial">${letter.serialNo}</div>
      <div class="doc-date">Date of Issue: ${letter.issuedDate}</div>
    </div>
  </div>

  <div class="recipient">
    <strong>To,</strong><br/>
    <span style="font-size:15px;font-weight:700;color:#0d1b2e">${letter.userName}</span><br/>
    Designation: ${letter.designation}<br/>
    Department: ${letter.dept}
  </div>

  <div class="salutation">Dear ${letter.userName},</div>

  <div class="body-text">
    <p>${letter.openingLine !== undefined ? letter.openingLine : `We are pleased to offer you the position of <strong>${letter.designation}</strong> in the <strong>${letter.dept}</strong> department at <strong>${compName}</strong>. Your date of joining is confirmed as <strong>${letter.issuedDate}</strong>.`}</p>
    <p>Your employment with us will be governed by the following terms and conditions:</p>
    
    <ul class="terms-list">
      <li><strong>Compensation:</strong> ${letter.compensationLine !== undefined ? letter.compensationLine : `You will receive a monthly gross salary of <strong>${fmtSalary}</strong>, subject to statutory deductions. Details of the salary breakdown will be shared separately by the HR department.`}</li>
      <li><strong>Probation:</strong> ${letter.probationLine !== undefined ? letter.probationLine : "You will be on probation for a period of fifteen (15) days from your joining date. Upon successful performance review, your employment will be confirmed in writing."}</li>
      <li><strong>Duties &amp; Conduct:</strong> ${letter.dutiesLine !== undefined ? letter.dutiesLine : "You are expected to perform your duties diligently and maintain high standards of discipline, confidentiality, and professional integrity in line with the company handbook."}</li>
      <li><strong>Termination:</strong> ${letter.terminationLine !== undefined ? letter.terminationLine : "Either party can terminate the employment by giving a sixty (60) days written notice or salary in lieu thereof."}</li>
      ${(letter.customLines || []).map(cl => `<li>${cl.text}</li>`).join("\n      ")}
    </ul>

    <p>Please return a signed duplicate copy of this letter as a token of your acceptance of this offer and its terms.</p>
    <p>${letter.closingLine !== undefined ? letter.closingLine : `We welcome you to our team and wish you a successful career ahead with ${compName}.`}</p>
  </div>

  <div class="sig-box">
    <div class="sig">
      <br/><br/><br/>
      <div class="sig-line">Accepted & Signed By</div>
      <div style="font-size:11px;color:#94a3b8;margin-top:2px">${letter.userName}</div>
    </div>
    <div class="sig">
      <img src="data:image/jpeg;base64,${SIGNATURE_B64}" alt="Authorized Signature" style="width:140px;height:60px;object-fit:contain;margin-bottom:2px" />
      <div class="sig-line">For ${compName}</div>
      <div style="font-size:11px;color:#94a3b8;margin-top:2px">Authorized Signatory</div>
    </div>
  </div>

  <div class="footer-bar">
    ${showPrintDateTime ? `<span>Generated: ${new Date().toLocaleString()} &middot; ${compName} ERP System</span>` : `<span>${compName} ERP System</span>`}
    <span>CONFIDENTIAL APPOINTMENT LETTER &mdash; ${letter.serialNo}</span>
  </div>
</div>
</body></html>`;
}
